//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const UpV1_BASE_URL = new InjectionToken<string>('UpV1_BASE_URL');

export interface IUpV1Service {
    /**
     * Grants, update or remove access to a container based on the specified organization and container information.
     * @param body (optional) A collection of object containing the organization and container details used to determine access permissions. Cannot be null.
     * @return Success
     */
    allowAddUpdateOrRemoveAllowedAccessAccess(body: AllowedOrganisationByContainerDto[] | undefined): Observable<void>;
    /**
     * Retrieves the list of organisations that have access to the specified container.
     * @param containerId The unique identifier of the container for which to retrieve access information.
     * @return Success
     */
    getContainerAccessByOrganisation(containerId: number): Observable<AllowedOrganisationByContainerDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAllowedOrganisationByContainer(body: AllowedOrganisationByContainerDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAllowedOrganisationByContainer(body: AllowedOrganisationByContainerDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAllowedOrganisationByContainer(id: number): Observable<void>;
    /**
     * <br>Allow a user access from GPR Gebouw to calculations by adding a building(container) to the table AllowedUserByCalculationOrContainer.
    <br>Creates User and/or Container if does not exist.
     * @param identityId identityId of User to allow acces
     * @param body (optional) Dto to describe container properties if does not exist
     * @return Success
     * @deprecated
     */
    allowUserAccessToBuilding(identityId: string, body: RequestBuildingAccessContainerDto | undefined): Observable<void>;
    /**
     * Hard Delete WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto by identityId and gprGebouwProjectInhoudId
     * @param identityId identityId of User to remove from AllowedUserByCalculationOrContainer table
     * @param gprGebouwProjectInhoudId BuildingId but with name used in GPR Gebouw (ProjectInhoudId)
     * @return Success
     */
    removeUserAccessFromBuilding(identityId: string, gprGebouwProjectInhoudId: number): Observable<void>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAllowedUserByCalculationOrContainer(body: AllowedUserByCalculationOrContainerDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAllowedUserByCalculationOrContainer(body: AllowedUserByCalculationOrContainerDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAllowedUserByCalculationOrContainer(id: number): Observable<void>;
    /**
     * Get Applications List From Amp Client
     * @return Success
     */
    getApplications(): Observable<ApplicationDto[]>;
    /**
     * Gets the angular authorization context
     * @return Success
     */
    authContext(): Observable<AuthContext>;
    /**
     * Check whether the user has created at least one calculation or container
     * @param userId The User Id
     * @param organizationId The organization Id to filter calculations or containers
     * @return Success
     */
    checkWhetherUserHasCreatedAtLeastOneCalculationOrContainer(userId: string, organizationId: number): Observable<boolean>;
    /**
     * Create new calculation
     * @param organizationId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createCalculation(organizationId: number | undefined, body: CalculationDto | undefined): Observable<string>;
    /**
     * Duplicate a calculation
     * @param calculationUrlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    duplicateCalculation(calculationUrlId: string): Observable<string>;
    /**
     * Hard Delete all trashed WE.UserPortal.Models.DataTransferObjects.CalculationDto for Logged In User
     * @return Success
     */
    emptyCalculationTrashBin(organizationId: number): Observable<void>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationDto  entities the logged in user has acces to, except for trashed
    calculations.
     * @return Success
     * @deprecated
     */
    getAllCalculationEntitiesOfUser(): Observable<CalculationPageDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculation(body: CalculationDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculation(body: CalculationDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationDto based on an unique identifier
     * @param id Unique identifier
     * @param returnWithAllRelatedEntities If set to true, all related entities will also be returned from the DB
     * @return Success
     * @deprecated
     */
    getCalculationById(id: number, returnWithAllRelatedEntities: boolean): Observable<CalculationDto>;
    /**
     * Gets all the Example Calculations for the select box
     * @return Success
     */
    getAllExampleCalculations(): Observable<ExampleCalculationsSelectListDto[]>;
    /**
     * <br>
                        Gets all GPR Materiaal calculations as WE.UserPortal.Models.DataTransferObjects.GprBuilding.MinimalCalculationDto entities the logged in user has
                        acces to, except for trashed and example calculations. Endpoint is (at least) used by GPR Gebouw
                        GprMaterialsCalculationConnectorController.GetAllMaterialsCalculationsOfUser method
                
    <br>Will return an empty list if no calculations could be found
     * @param isExistingBuildingCalculation (optional) Flag to check if only Existing Building Calculations need to be returned
     * @return Success
     */
    getAllMinimalCalculationDtoOfMaterialByLoggedinUser(isExistingBuildingCalculation: boolean | undefined): Observable<MinimalCalculationDto[]>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationDto based on an url safe unique identifier
     * @param urlId Unique identifier
     * @param returnWithAllRelatedEntities If set to true, all related entities will also be returned from the DB
     * @return Success
     */
    getCalculationByUrlId(urlId: string, returnWithAllRelatedEntities: boolean): Observable<CalculationDto>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationDto  entities
     * @return Success
     */
    getLastCalculationsOfUser(loggedInUserIdentityId: string, gprLicentiebeheerAppId: number, applicationId: number): Observable<CalculationPageDto[]>;
    /**
     * Get paginated calculation of other users who are on same license as logged in user.
    Post request is used so that huge list of userIds can be send in form body.
    nswag client is not able to encode the url if userId count increases in url.
     * @param body Dto for pagination request
     * @return Success
     */
    paginatedCalculations(body: CalculationPaginationAndFilterRequestDto): Observable<CalculationPageDto[]>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.TrashBinDto  entities
     * @return Success
     */
    getAllPaginatedCalculationTrashedEntities(body: CalculationPaginationAndFilterRequestDto): Observable<TrashBinDto[]>;
    /**
     * Hard Delete WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param urlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    hardDeleteCalculationByUrlId(urlId: string): Observable<void>;
    /**
     * Used by GPR Gebouw to import a Materials calculation into a Gebouw calculation
    The user selects a calculation from a dropdown showing all the material calculations the user has access to (the calculation to import)
    The old calculation formerly linked to the building will be deleted and replaced by a duplicate of calculation to be imported
     * @param oldCalculationUrlId The old Calculation Url Id to be deleted.
     * @param calculationToBeImportedUrlId The calculation Url Id of the calculation to be imported, a duplicate will be made and that duplicate will be linked to the Gebouw calculation (that URL id will be returned)
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    postGebouwToDuplicateCalculationWithExistingCalculation(oldCalculationUrlId: string, calculationToBeImportedUrlId: string, body: ProjectDto | undefined): Observable<string>;
    /**
     * Update an existing entity from a WE.UserPortal.Models.DataTransferObjects.CalculationPageDto
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationPageDto(body: CalculationPageDto | undefined): Observable<void>;
    /**
     * Update calculation access for those users for whom HasAccess flag changed.
     * @param calculationUrlId unique identifying Guid of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param body (optional) The new Name of a existing calculation
     * @return Success
     * @deprecated
     */
    renameCalculation(calculationUrlId: string, body: string | undefined): Observable<void>;
    /**
     * Restore a soft deleted WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param urlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    restoreCalculationByUrlId(urlId: string): Observable<void>;
    /**
     * Soft delete WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param urlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    softDeleteCalculationByUrlId(urlId: string): Observable<void>;
    /**
     * Update calculation access for those users for whom HasAccess flag changed.
     * @param calculationUrlId unique identifying Guid of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param body (optional) list of WE.UserPortal.Models.DataTransferObjects.GrantedIdpUserDto of users with HasAccess flag changed
     * @return Success
     */
    updateCalculationAccessOfUsers(calculationUrlId: string, body: GrantedIdpUserDto[] | undefined): Observable<CalculationAccessDto[]>;
    /**
     * Move calculations from one container to another by updating the container Id for calculations.
     * @param containerId unique identifier of container to which calculations needs to be moved.
     * @param body (optional) url ids of calculations to be moved.
     * @return Success
     */
    updateContainerForCalculations(containerId: number, body: string[] | undefined): Observable<void>;
    /**
     * Changes the owner of the calculation by updating the CreatedById
     * @param urlId unique identifier of calculation that gets a new owner.
     * @param newUpUserId Userportal identity id of the new owner
     * @param isOldUserAccessRevoked if false, user can still access his calculations
     * @return Success
     */
    changeOwnerOfCalculation(urlId: string, newUpUserId: number, isOldUserAccessRevoked: boolean): Observable<number>;
    /**
     * Duplicate a calculation to organization
     * @param body (optional) 
     * @return Success
     */
    duplicateToOrganizationCalculation(body: DuplicateCalculationDto | undefined): Observable<string>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculation(id: number): Observable<void>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllCalculationCoreResultEntities(): Observable<CalculationCoreResultDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreResult(body: CalculationCoreResultDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreResult(body: CalculationCoreResultDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getCalculationCoreResultById(id: number): Observable<CalculationCoreResultDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreResult(id: number): Observable<void>;
    /**
     * Get core results of calculation based on calculation urlId
     * @param calculationUrlId guid Id
     * @return Success
     * @deprecated
     */
    getResultsForGprBuilding(calculationUrlId: string): Observable<CalculationResultGprBuildingSummaryDto>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultExpressionResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllCalculationCoreResultExpressionResultEntities(): Observable<CalculationCoreResultExpressionResultDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreResultExpressionResult(body: CalculationCoreResultExpressionResultDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreResultExpressionResult(body: CalculationCoreResultExpressionResultDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultExpressionResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getCalculationCoreResultExpressionResultById(id: number): Observable<CalculationCoreResultExpressionResultDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreResultExpressionResult(id: number): Observable<void>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.ContainerDto  entities
     * @return Success
     * @deprecated
     */
    getAllContainerEntities(): Observable<ContainerDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postContainer(body: ContainerDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putContainer(body: ContainerDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.ContainerDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getContainerById(id: number): Observable<ContainerDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteContainer(id: number): Observable<void>;
    /**
     * Add a container, if parentId is provided, the new container will be added as a child of the parent container.
     * @param body (optional) 
     * @return Success
     */
    createContainer(body: ContainerDto | undefined): Observable<MinimalContainerDto>;
    /**
     * Update container details
     * @param body (optional) 
     * @return Success
     */
    updateContainer(body: ContainerDto | undefined): Observable<MinimalContainerDto>;
    /**
     * Get Containers
     * @param organizationId organization Id
     * @return Success
     */
    getContainers(organizationId: number): Observable<MinimalContainerDto[]>;
    /**
     * Soft delete WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @param containerId unique identifier of WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @return Success
     */
    softDeleteContainer(containerId: number): Observable<void>;
    /**
     * Hard Delete WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @param containerId unique identifier of WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @return Success
     */
    hardDeleteContainer(containerId: number): Observable<void>;
    /**
     * Restore a soft deleted WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @param containerId unique identifier of WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @return Success
     */
    restoreContainer(containerId: number): Observable<void>;
    /**
     * Changes the owner of the container by updating the CreatedById
     * @param containerId container that gets a new owner.
     * @param newUpUserId Userportal identity id of the new owner
     * @param isOldUserAccessRevoked if false, user can still access his calculations
     * @return Success
     */
    changeOwnerOfContainer(containerId: number, newUpUserId: number, isOldUserAccessRevoked: boolean): Observable<number>;
    /**
     * Get paginated list of WE.UserPortal.Models.DataTransferObjects.CalculationDto based on organisationId and page number
     * @param organisationId organisationId to which calculations are linked via container
     * @param pageNumber requested page number
     * @param pageSize requested page size
     * @param includeOwnFolderCalculations (optional) if true then include the calculations added to the folders belonging to the organisation
     * @return Success
     */
    getPaginatedCalculationsForDataPortal(organisationId: number, pageNumber: number, pageSize: number, includeOwnFolderCalculations: boolean | undefined): Observable<CalculationDto[]>;
    /**
     * Get paginated list of WE.UserPortal.Models.DataTransferObjects.CalculationDto based on organisationId, page number, dateFrom and dateUntil
     * @param organisationId organisationId to which calculations are linked via container
     * @param pageNumber requested page number
     * @param pageSize requested page size
     * @param dateFrom date from which the calculations should be retrieved
     * @param dateUntil (optional) date until which the calculations should be retrieved. If null, then default to today's date
     * @param includeOwnFolderCalculations (optional) if true then include the calculations added to the folders belonging to the organisation
     * @return Success
     */
    getPaginatedCalculationsByDateRangeForDataPortal(organisationId: number, pageNumber: number, pageSize: number, dateFrom: Date, dateUntil: Date | undefined, includeOwnFolderCalculations: boolean | undefined): Observable<CalculationDto[]>;
    /**
     * Gets whether a feature is enabled for the logged in user or not
     * @param featureId (optional) The text id of the feature
     * @return Success
     */
    isFeatureEnabledForUser(featureId: string | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return Success
     */
    importImportCalculation(calculationName: string, organisationId: number, contentVersionId: number, applicationId: number, body: string | undefined): Observable<string>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.UpLicenseDto  entities
     * @return Success
     * @deprecated
     */
    getAllLicenseEntities(): Observable<UpLicenseDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postLicense(body: UpLicenseDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putLicense(body: UpLicenseDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.UpLicenseDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getLicenseById(id: number): Observable<UpLicenseDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteLicense(id: number): Observable<void>;
    /**
     * Get Licenses with users
     * @return Success
     */
    getLicensesWithUsers(): Observable<LicenseManagementDto>;
    /**
     * Delete User from license
     * @return Success
     */
    deleteUserFromLicense(licenseId: number, userId: string): Observable<void>;
    /**
     * Notify GPR Gebouw that user has removed from license
     * @return Success
     */
    notifyGprGebouwUserWasRemovedFromLicense(licenseId: number, userId: string): Observable<void>;
    /**
     * Add a new user to license and returns entire list
     * @param body (optional) 
     * @return Success
     */
    addUserToLicense(body: AddUserToLicenseDto | undefined): Observable<AddUsersToLicenseResponseDto>;
    /**
     * Resend an invitation email to the unregistered user
     * @param body (optional) 
     * @return Success
     */
    resendInvitationEmail(body: SendEmailAnnouncementDto | undefined): Observable<void>;
    /**
     * Change roles of a user for a certain license
     * @param body (optional) 
     * @return Success
     */
    addOrRemoveUserFromRoles(body: UserToRolesRequestDto | undefined): Observable<void>;
    /**
     * Delete User from license after reassigning calculations and containers/ folders of old user to new user
     * @param body (optional) 
     * @return Success
     */
    reassigningCalculationsAndContainersToNewUserAndDeleteOldUserFromLicense(body: DeleteUserAndReassignCalculationsDto | undefined): Observable<void>;
    /**
     * Get license subscription info of current year
     * @return Success
     */
    subscriptionOfCurrentYear(licenseId: number): Observable<SubscriptionDto>;
    /**
     * Add a list of new users to license and return list of successfully added users and list of users failed to be added
     * @param totalAvailableSeats (optional) 
     * @param csvFile (optional) 
     * @return Success
     */
    addUsersToLicense(licenseId: number, totalAvailableSeats: number | undefined, gprLicentiebeheerAppId: number, csvFile: FileParameter | undefined): Observable<AddUsersToLicenseResponseDto>;
    /**
     * Saving the Front-End logs into text file
     * @param body (optional) Log information
     * @return Success
     */
    saveFrontEndLogs(body: string | undefined): Observable<void>;
    /**
     * Get the list of organization and licenses name to which user is mapped to.
     * @param userIdentityId unique identifier of user from Idp which is also stored in WE.UserPortal.Models.DataTransferObjects.UpUserDto as WE.UserPortal.Models.DataTransferObjects.UpUserDto.IdentityId
     * @param gprLicentiebeheerAppId unique identifier of the GprLicentiebeheer applications to which the license belongs to.
                This is stored in WE.AMP.Models.DataTransferObjects.ApplicationDto.GprLicentiebeheerAppId
     * @return Success
     */
    getOrganizationLicenseInfo(userIdentityId: string, gprLicentiebeheerAppId: number): Observable<OrganizationLicenseInfoDto[]>;
    /**
     * Get the list of organization and licenses name to which user is mapped to.
     * @param userIdentityId unique identifier of user from Idp which is also stored in WE.UserPortal.Models.DataTransferObjects.UpUserDto as WE.UserPortal.Models.DataTransferObjects.UpUserDto.IdentityId
     * @return Success
     * @deprecated
     */
    getOrganizationLicenseInfoByUserIdentityId(userIdentityId: string): Observable<OrganizationLicenseInfoDto[]>;
    /**
     * Retrieves summary information for an organization identified by its unique code.
     * @param organisationCode The unique identifier of the organization to retrieve information for.
     * @return Success
     */
    getOrganisationInfoByCode(organisationCode: string): Observable<OrganizationSummaryResponse>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllParameterToAssessmentExpressionResultEntities(): Observable<ParameterToAssessmentExpressionResultDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterToAssessmentExpressionResult(body: ParameterToAssessmentExpressionResultDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterToAssessmentExpressionResult(body: ParameterToAssessmentExpressionResultDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getParameterToAssessmentExpressionResultById(id: number): Observable<ParameterToAssessmentExpressionResultDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterToAssessmentExpressionResult(id: number): Observable<void>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.ParameterToCalculationCoreExpressionResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllParameterToCalculationCoreExpressionResultEntities(): Observable<ParameterToCalculationCoreExpressionResultDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterToCalculationCoreExpressionResult(body: ParameterToCalculationCoreExpressionResultDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterToCalculationCoreExpressionResult(body: ParameterToCalculationCoreExpressionResultDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.ParameterToCalculationCoreExpressionResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getParameterToCalculationCoreExpressionResultById(id: number): Observable<ParameterToCalculationCoreExpressionResultDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterToCalculationCoreExpressionResult(id: number): Observable<void>;
    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.UpUserDto  entities
     * @return Success
     * @deprecated
     */
    getAllUserEntities(): Observable<UpUserDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postUser(body: UpUserDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putUser(body: UpUserDto | undefined): Observable<void>;
    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.UpUserDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getUserById(id: number): Observable<UpUserDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteUser(id: number): Observable<void>;
    /**
     * Get all users that are linked to the same organization.
     * @return Success
     */
    getUsersByOrganizationId(organizationId: number): Observable<IdpUserDto[]>;
    /**
     * Get logged in user licenses along with other mapped users to that licenses
     * @return Success
     */
    getLicensesWithOtherUsers(): Observable<LicenseManagementDto>;
    /**
     * Gets all loggedIn user id
     * @return Success
     */
    getLoggedInUserId(): Observable<number>;
    /**
     * Get all users that are linked to the same license as the license with user in request
     * @return Success
     */
    getOtherUsersInSameLicense(licenseId: number, userIdentityId: string): Observable<IdpUserDto[]>;
}

@Injectable()
export class UpV1Service implements IUpV1Service {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(UpV1_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Grants, update or remove access to a container based on the specified organization and container information.
     * @param body (optional) A collection of object containing the organization and container details used to determine access permissions. Cannot be null.
     * @return Success
     */
    allowAddUpdateOrRemoveAllowedAccessAccess(body: AllowedOrganisationByContainerDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedOrganisationByContainer/AddUpdateOrRemoveAllowedAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowAddUpdateOrRemoveAllowedAccessAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowAddUpdateOrRemoveAllowedAccessAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAllowAddUpdateOrRemoveAllowedAccessAccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the list of organisations that have access to the specified container.
     * @param containerId The unique identifier of the container for which to retrieve access information.
     * @return Success
     */
    getContainerAccessByOrganisation(containerId: number): Observable<AllowedOrganisationByContainerDto[]> {
        let url_ = this.baseUrl + "/api/v1/AllowedOrganisationByContainer/GetContainerAccessByOrganisation/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerAccessByOrganisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerAccessByOrganisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowedOrganisationByContainerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowedOrganisationByContainerDto[]>;
        }));
    }

    protected processGetContainerAccessByOrganisation(response: HttpResponseBase): Observable<AllowedOrganisationByContainerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllowedOrganisationByContainerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAllowedOrganisationByContainer(body: AllowedOrganisationByContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedOrganisationByContainer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAllowedOrganisationByContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAllowedOrganisationByContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAllowedOrganisationByContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAllowedOrganisationByContainer(body: AllowedOrganisationByContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedOrganisationByContainer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAllowedOrganisationByContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAllowedOrganisationByContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAllowedOrganisationByContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAllowedOrganisationByContainer(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedOrganisationByContainer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllowedOrganisationByContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllowedOrganisationByContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllowedOrganisationByContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * <br>Allow a user access from GPR Gebouw to calculations by adding a building(container) to the table AllowedUserByCalculationOrContainer.
    <br>Creates User and/or Container if does not exist.
     * @param identityId identityId of User to allow acces
     * @param body (optional) Dto to describe container properties if does not exist
     * @return Success
     * @deprecated
     */
    allowUserAccessToBuilding(identityId: string, body: RequestBuildingAccessContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedUserByCalculationOrContainer/{identityId}";
        if (identityId === undefined || identityId === null)
            throw new globalThis.Error("The parameter 'identityId' must be defined.");
        url_ = url_.replace("{identityId}", encodeURIComponent("" + identityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowUserAccessToBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowUserAccessToBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAllowUserAccessToBuilding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hard Delete WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto by identityId and gprGebouwProjectInhoudId
     * @param identityId identityId of User to remove from AllowedUserByCalculationOrContainer table
     * @param gprGebouwProjectInhoudId BuildingId but with name used in GPR Gebouw (ProjectInhoudId)
     * @return Success
     */
    removeUserAccessFromBuilding(identityId: string, gprGebouwProjectInhoudId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedUserByCalculationOrContainer/{identityId}/{gprGebouwProjectInhoudId}";
        if (identityId === undefined || identityId === null)
            throw new globalThis.Error("The parameter 'identityId' must be defined.");
        url_ = url_.replace("{identityId}", encodeURIComponent("" + identityId));
        if (gprGebouwProjectInhoudId === undefined || gprGebouwProjectInhoudId === null)
            throw new globalThis.Error("The parameter 'gprGebouwProjectInhoudId' must be defined.");
        url_ = url_.replace("{gprGebouwProjectInhoudId}", encodeURIComponent("" + gprGebouwProjectInhoudId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserAccessFromBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserAccessFromBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserAccessFromBuilding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAllowedUserByCalculationOrContainer(body: AllowedUserByCalculationOrContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedUserByCalculationOrContainer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAllowedUserByCalculationOrContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAllowedUserByCalculationOrContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAllowedUserByCalculationOrContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAllowedUserByCalculationOrContainer(body: AllowedUserByCalculationOrContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedUserByCalculationOrContainer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAllowedUserByCalculationOrContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAllowedUserByCalculationOrContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAllowedUserByCalculationOrContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAllowedUserByCalculationOrContainer(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AllowedUserByCalculationOrContainer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllowedUserByCalculationOrContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllowedUserByCalculationOrContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllowedUserByCalculationOrContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Applications List From Amp Client
     * @return Success
     */
    getApplications(): Observable<ApplicationDto[]> {
        let url_ = this.baseUrl + "/api/v1/Application";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto[]>;
        }));
    }

    protected processGetApplications(response: HttpResponseBase): Observable<ApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the angular authorization context
     * @return Success
     */
    authContext(): Observable<AuthContext> {
        let url_ = this.baseUrl + "/api/v1/Auth/AuthContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthContext>;
        }));
    }

    protected processAuthContext(response: HttpResponseBase): Observable<AuthContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check whether the user has created at least one calculation or container
     * @param userId The User Id
     * @param organizationId The organization Id to filter calculations or containers
     * @return Success
     */
    checkWhetherUserHasCreatedAtLeastOneCalculationOrContainer(userId: string, organizationId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/Calculation/CheckWhetherUserHasCreatedAtLeastOneCalculationOrContainer/{userId}/{organizationId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckWhetherUserHasCreatedAtLeastOneCalculationOrContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWhetherUserHasCreatedAtLeastOneCalculationOrContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckWhetherUserHasCreatedAtLeastOneCalculationOrContainer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create new calculation
     * @param organizationId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createCalculation(organizationId: number | undefined, body: CalculationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Calculation/Create?";
        if (organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateCalculation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Duplicate a calculation
     * @param calculationUrlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    duplicateCalculation(calculationUrlId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Calculation/Duplicate/{calculationUrlId}";
        if (calculationUrlId === undefined || calculationUrlId === null)
            throw new globalThis.Error("The parameter 'calculationUrlId' must be defined.");
        url_ = url_.replace("{calculationUrlId}", encodeURIComponent("" + calculationUrlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDuplicateCalculation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hard Delete all trashed WE.UserPortal.Models.DataTransferObjects.CalculationDto for Logged In User
     * @return Success
     */
    emptyCalculationTrashBin(organizationId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/EmptyCalculationTrashBin/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmptyCalculationTrashBin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmptyCalculationTrashBin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmptyCalculationTrashBin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationDto  entities the logged in user has acces to, except for trashed
    calculations.
     * @return Success
     * @deprecated
     */
    getAllCalculationEntitiesOfUser(): Observable<CalculationPageDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationEntitiesOfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationEntitiesOfUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationPageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationPageDto[]>;
        }));
    }

    protected processGetAllCalculationEntitiesOfUser(response: HttpResponseBase): Observable<CalculationPageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationPageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculation(body: CalculationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculation(body: CalculationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationDto based on an unique identifier
     * @param id Unique identifier
     * @param returnWithAllRelatedEntities If set to true, all related entities will also be returned from the DB
     * @return Success
     * @deprecated
     */
    getCalculationById(id: number, returnWithAllRelatedEntities: boolean): Observable<CalculationDto> {
        let url_ = this.baseUrl + "/api/v1/Calculation/{id}/{returnWithAllRelatedEntities}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (returnWithAllRelatedEntities === undefined || returnWithAllRelatedEntities === null)
            throw new globalThis.Error("The parameter 'returnWithAllRelatedEntities' must be defined.");
        url_ = url_.replace("{returnWithAllRelatedEntities}", encodeURIComponent("" + returnWithAllRelatedEntities));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationDto>;
        }));
    }

    protected processGetCalculationById(response: HttpResponseBase): Observable<CalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the Example Calculations for the select box
     * @return Success
     */
    getAllExampleCalculations(): Observable<ExampleCalculationsSelectListDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation/GetAllExampleCalculations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExampleCalculations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExampleCalculations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExampleCalculationsSelectListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExampleCalculationsSelectListDto[]>;
        }));
    }

    protected processGetAllExampleCalculations(response: HttpResponseBase): Observable<ExampleCalculationsSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExampleCalculationsSelectListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * <br>
                        Gets all GPR Materiaal calculations as WE.UserPortal.Models.DataTransferObjects.GprBuilding.MinimalCalculationDto entities the logged in user has
                        acces to, except for trashed and example calculations. Endpoint is (at least) used by GPR Gebouw
                        GprMaterialsCalculationConnectorController.GetAllMaterialsCalculationsOfUser method
                
    <br>Will return an empty list if no calculations could be found
     * @param isExistingBuildingCalculation (optional) Flag to check if only Existing Building Calculations need to be returned
     * @return Success
     */
    getAllMinimalCalculationDtoOfMaterialByLoggedinUser(isExistingBuildingCalculation: boolean | undefined): Observable<MinimalCalculationDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation/GetAllMinimalCalculationDtoOfMaterialByLoggedinUser?";
        if (isExistingBuildingCalculation === null)
            throw new globalThis.Error("The parameter 'isExistingBuildingCalculation' cannot be null.");
        else if (isExistingBuildingCalculation !== undefined)
            url_ += "isExistingBuildingCalculation=" + encodeURIComponent("" + isExistingBuildingCalculation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMinimalCalculationDtoOfMaterialByLoggedinUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMinimalCalculationDtoOfMaterialByLoggedinUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimalCalculationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimalCalculationDto[]>;
        }));
    }

    protected processGetAllMinimalCalculationDtoOfMaterialByLoggedinUser(response: HttpResponseBase): Observable<MinimalCalculationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinimalCalculationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationDto based on an url safe unique identifier
     * @param urlId Unique identifier
     * @param returnWithAllRelatedEntities If set to true, all related entities will also be returned from the DB
     * @return Success
     */
    getCalculationByUrlId(urlId: string, returnWithAllRelatedEntities: boolean): Observable<CalculationDto> {
        let url_ = this.baseUrl + "/api/v1/Calculation/ByUrlId/{urlId}/{returnWithAllRelatedEntities}";
        if (urlId === undefined || urlId === null)
            throw new globalThis.Error("The parameter 'urlId' must be defined.");
        url_ = url_.replace("{urlId}", encodeURIComponent("" + urlId));
        if (returnWithAllRelatedEntities === undefined || returnWithAllRelatedEntities === null)
            throw new globalThis.Error("The parameter 'returnWithAllRelatedEntities' must be defined.");
        url_ = url_.replace("{returnWithAllRelatedEntities}", encodeURIComponent("" + returnWithAllRelatedEntities));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationByUrlId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationByUrlId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationDto>;
        }));
    }

    protected processGetCalculationByUrlId(response: HttpResponseBase): Observable<CalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationDto  entities
     * @return Success
     */
    getLastCalculationsOfUser(loggedInUserIdentityId: string, gprLicentiebeheerAppId: number, applicationId: number): Observable<CalculationPageDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation/Last/{loggedInUserIdentityId}/{gprLicentiebeheerAppId}/{applicationId}";
        if (loggedInUserIdentityId === undefined || loggedInUserIdentityId === null)
            throw new globalThis.Error("The parameter 'loggedInUserIdentityId' must be defined.");
        url_ = url_.replace("{loggedInUserIdentityId}", encodeURIComponent("" + loggedInUserIdentityId));
        if (gprLicentiebeheerAppId === undefined || gprLicentiebeheerAppId === null)
            throw new globalThis.Error("The parameter 'gprLicentiebeheerAppId' must be defined.");
        url_ = url_.replace("{gprLicentiebeheerAppId}", encodeURIComponent("" + gprLicentiebeheerAppId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCalculationsOfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCalculationsOfUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationPageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationPageDto[]>;
        }));
    }

    protected processGetLastCalculationsOfUser(response: HttpResponseBase): Observable<CalculationPageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationPageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get paginated calculation of other users who are on same license as logged in user.
    Post request is used so that huge list of userIds can be send in form body.
    nswag client is not able to encode the url if userId count increases in url.
     * @param body Dto for pagination request
     * @return Success
     */
    paginatedCalculations(body: CalculationPaginationAndFilterRequestDto): Observable<CalculationPageDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation/PaginatedCalculations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaginatedCalculations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaginatedCalculations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationPageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationPageDto[]>;
        }));
    }

    protected processPaginatedCalculations(response: HttpResponseBase): Observable<CalculationPageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationPageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.TrashBinDto  entities
     * @return Success
     */
    getAllPaginatedCalculationTrashedEntities(body: CalculationPaginationAndFilterRequestDto): Observable<TrashBinDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation/GetPaginatedTrashedCalculationsAndContainers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaginatedCalculationTrashedEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaginatedCalculationTrashedEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrashBinDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrashBinDto[]>;
        }));
    }

    protected processGetAllPaginatedCalculationTrashedEntities(response: HttpResponseBase): Observable<TrashBinDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrashBinDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hard Delete WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param urlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    hardDeleteCalculationByUrlId(urlId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/HardDeleteByUrlId/{urlId}";
        if (urlId === undefined || urlId === null)
            throw new globalThis.Error("The parameter 'urlId' must be defined.");
        url_ = url_.replace("{urlId}", encodeURIComponent("" + urlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardDeleteCalculationByUrlId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardDeleteCalculationByUrlId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHardDeleteCalculationByUrlId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Used by GPR Gebouw to import a Materials calculation into a Gebouw calculation
    The user selects a calculation from a dropdown showing all the material calculations the user has access to (the calculation to import)
    The old calculation formerly linked to the building will be deleted and replaced by a duplicate of calculation to be imported
     * @param oldCalculationUrlId The old Calculation Url Id to be deleted.
     * @param calculationToBeImportedUrlId The calculation Url Id of the calculation to be imported, a duplicate will be made and that duplicate will be linked to the Gebouw calculation (that URL id will be returned)
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    postGebouwToDuplicateCalculationWithExistingCalculation(oldCalculationUrlId: string, calculationToBeImportedUrlId: string, body: ProjectDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Calculation/DuplicateCalculationWithProjectData/{oldCalculationUrlId}/{calculationToBeImportedUrlId}";
        if (oldCalculationUrlId === undefined || oldCalculationUrlId === null)
            throw new globalThis.Error("The parameter 'oldCalculationUrlId' must be defined.");
        url_ = url_.replace("{oldCalculationUrlId}", encodeURIComponent("" + oldCalculationUrlId));
        if (calculationToBeImportedUrlId === undefined || calculationToBeImportedUrlId === null)
            throw new globalThis.Error("The parameter 'calculationToBeImportedUrlId' must be defined.");
        url_ = url_.replace("{calculationToBeImportedUrlId}", encodeURIComponent("" + calculationToBeImportedUrlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostGebouwToDuplicateCalculationWithExistingCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostGebouwToDuplicateCalculationWithExistingCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPostGebouwToDuplicateCalculationWithExistingCalculation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity from a WE.UserPortal.Models.DataTransferObjects.CalculationPageDto
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationPageDto(body: CalculationPageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/CalculationPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationPageDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationPageDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationPageDto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update calculation access for those users for whom HasAccess flag changed.
     * @param calculationUrlId unique identifying Guid of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param body (optional) The new Name of a existing calculation
     * @return Success
     * @deprecated
     */
    renameCalculation(calculationUrlId: string, body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/Rename/{calculationUrlId}";
        if (calculationUrlId === undefined || calculationUrlId === null)
            throw new globalThis.Error("The parameter 'calculationUrlId' must be defined.");
        url_ = url_.replace("{calculationUrlId}", encodeURIComponent("" + calculationUrlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenameCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Restore a soft deleted WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param urlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    restoreCalculationByUrlId(urlId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/RestoreByUrlId/{urlId}";
        if (urlId === undefined || urlId === null)
            throw new globalThis.Error("The parameter 'urlId' must be defined.");
        url_ = url_.replace("{urlId}", encodeURIComponent("" + urlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreCalculationByUrlId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreCalculationByUrlId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreCalculationByUrlId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Soft delete WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param urlId Url save Unique Identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @return Success
     */
    softDeleteCalculationByUrlId(urlId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/SoftDeleteByUrlId/{urlId}";
        if (urlId === undefined || urlId === null)
            throw new globalThis.Error("The parameter 'urlId' must be defined.");
        url_ = url_.replace("{urlId}", encodeURIComponent("" + urlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSoftDeleteCalculationByUrlId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftDeleteCalculationByUrlId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSoftDeleteCalculationByUrlId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update calculation access for those users for whom HasAccess flag changed.
     * @param calculationUrlId unique identifying Guid of WE.UserPortal.Models.DataTransferObjects.CalculationDto
     * @param body (optional) list of WE.UserPortal.Models.DataTransferObjects.GrantedIdpUserDto of users with HasAccess flag changed
     * @return Success
     */
    updateCalculationAccessOfUsers(calculationUrlId: string, body: GrantedIdpUserDto[] | undefined): Observable<CalculationAccessDto[]> {
        let url_ = this.baseUrl + "/api/v1/Calculation/UpdateAccessOfUsers/{calculationUrlId}";
        if (calculationUrlId === undefined || calculationUrlId === null)
            throw new globalThis.Error("The parameter 'calculationUrlId' must be defined.");
        url_ = url_.replace("{calculationUrlId}", encodeURIComponent("" + calculationUrlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCalculationAccessOfUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCalculationAccessOfUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationAccessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationAccessDto[]>;
        }));
    }

    protected processUpdateCalculationAccessOfUsers(response: HttpResponseBase): Observable<CalculationAccessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationAccessDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Move calculations from one container to another by updating the container Id for calculations.
     * @param containerId unique identifier of container to which calculations needs to be moved.
     * @param body (optional) url ids of calculations to be moved.
     * @return Success
     */
    updateContainerForCalculations(containerId: number, body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/UpdateContainerForCalculations/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContainerForCalculations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContainerForCalculations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateContainerForCalculations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Changes the owner of the calculation by updating the CreatedById
     * @param urlId unique identifier of calculation that gets a new owner.
     * @param newUpUserId Userportal identity id of the new owner
     * @param isOldUserAccessRevoked if false, user can still access his calculations
     * @return Success
     */
    changeOwnerOfCalculation(urlId: string, newUpUserId: number, isOldUserAccessRevoked: boolean): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Calculation/ChangeOwnerOfCalculation/{urlId}/{newUpUserId}/{isOldUserAccessRevoked}";
        if (urlId === undefined || urlId === null)
            throw new globalThis.Error("The parameter 'urlId' must be defined.");
        url_ = url_.replace("{urlId}", encodeURIComponent("" + urlId));
        if (newUpUserId === undefined || newUpUserId === null)
            throw new globalThis.Error("The parameter 'newUpUserId' must be defined.");
        url_ = url_.replace("{newUpUserId}", encodeURIComponent("" + newUpUserId));
        if (isOldUserAccessRevoked === undefined || isOldUserAccessRevoked === null)
            throw new globalThis.Error("The parameter 'isOldUserAccessRevoked' must be defined.");
        url_ = url_.replace("{isOldUserAccessRevoked}", encodeURIComponent("" + isOldUserAccessRevoked));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOwnerOfCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOwnerOfCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeOwnerOfCalculation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Duplicate a calculation to organization
     * @param body (optional) 
     * @return Success
     */
    duplicateToOrganizationCalculation(body: DuplicateCalculationDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Calculation/DuplicateCalculationToOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateToOrganizationCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateToOrganizationCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDuplicateToOrganizationCalculation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculation(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Calculation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllCalculationCoreResultEntities(): Observable<CalculationCoreResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationCoreResultEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationCoreResultEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreResultDto[]>;
        }));
    }

    protected processGetAllCalculationCoreResultEntities(response: HttpResponseBase): Observable<CalculationCoreResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationCoreResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreResult(body: CalculationCoreResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculationCoreResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculationCoreResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculationCoreResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreResult(body: CalculationCoreResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationCoreResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationCoreResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationCoreResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getCalculationCoreResultById(id: number): Observable<CalculationCoreResultDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationCoreResultById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationCoreResultById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreResultDto>;
        }));
    }

    protected processGetCalculationCoreResultById(response: HttpResponseBase): Observable<CalculationCoreResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationCoreResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreResult(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculationCoreResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculationCoreResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculationCoreResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get core results of calculation based on calculation urlId
     * @param calculationUrlId guid Id
     * @return Success
     * @deprecated
     */
    getResultsForGprBuilding(calculationUrlId: string): Observable<CalculationResultGprBuildingSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResult/GetResultsForGprBuilding/{calculationUrlId}";
        if (calculationUrlId === undefined || calculationUrlId === null)
            throw new globalThis.Error("The parameter 'calculationUrlId' must be defined.");
        url_ = url_.replace("{calculationUrlId}", encodeURIComponent("" + calculationUrlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultsForGprBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultsForGprBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationResultGprBuildingSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationResultGprBuildingSummaryDto>;
        }));
    }

    protected processGetResultsForGprBuilding(response: HttpResponseBase): Observable<CalculationResultGprBuildingSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationResultGprBuildingSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultExpressionResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllCalculationCoreResultExpressionResultEntities(): Observable<CalculationCoreResultExpressionResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationCoreResultExpressionResultEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationCoreResultExpressionResultEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreResultExpressionResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreResultExpressionResultDto[]>;
        }));
    }

    protected processGetAllCalculationCoreResultExpressionResultEntities(response: HttpResponseBase): Observable<CalculationCoreResultExpressionResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationCoreResultExpressionResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreResultExpressionResult(body: CalculationCoreResultExpressionResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculationCoreResultExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculationCoreResultExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculationCoreResultExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreResultExpressionResult(body: CalculationCoreResultExpressionResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationCoreResultExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationCoreResultExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationCoreResultExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultExpressionResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getCalculationCoreResultExpressionResultById(id: number): Observable<CalculationCoreResultExpressionResultDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpressionResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationCoreResultExpressionResultById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationCoreResultExpressionResultById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreResultExpressionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreResultExpressionResultDto>;
        }));
    }

    protected processGetCalculationCoreResultExpressionResultById(response: HttpResponseBase): Observable<CalculationCoreResultExpressionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationCoreResultExpressionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreResultExpressionResult(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpressionResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculationCoreResultExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculationCoreResultExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculationCoreResultExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.ContainerDto  entities
     * @return Success
     * @deprecated
     */
    getAllContainerEntities(): Observable<ContainerDto[]> {
        let url_ = this.baseUrl + "/api/v1/Container";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContainerEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContainerEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContainerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContainerDto[]>;
        }));
    }

    protected processGetAllContainerEntities(response: HttpResponseBase): Observable<ContainerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContainerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postContainer(body: ContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Container";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putContainer(body: ContainerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Container";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.ContainerDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getContainerById(id: number): Observable<ContainerDto> {
        let url_ = this.baseUrl + "/api/v1/Container/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContainerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContainerDto>;
        }));
    }

    protected processGetContainerById(response: HttpResponseBase): Observable<ContainerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContainerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteContainer(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Container/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a container, if parentId is provided, the new container will be added as a child of the parent container.
     * @param body (optional) 
     * @return Success
     */
    createContainer(body: ContainerDto | undefined): Observable<MinimalContainerDto> {
        let url_ = this.baseUrl + "/api/v1/Container/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimalContainerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimalContainerDto>;
        }));
    }

    protected processCreateContainer(response: HttpResponseBase): Observable<MinimalContainerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalContainerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update container details
     * @param body (optional) 
     * @return Success
     */
    updateContainer(body: ContainerDto | undefined): Observable<MinimalContainerDto> {
        let url_ = this.baseUrl + "/api/v1/Container/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimalContainerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimalContainerDto>;
        }));
    }

    protected processUpdateContainer(response: HttpResponseBase): Observable<MinimalContainerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalContainerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Containers
     * @param organizationId organization Id
     * @return Success
     */
    getContainers(organizationId: number): Observable<MinimalContainerDto[]> {
        let url_ = this.baseUrl + "/api/v1/Container/GetContainers/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContainers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContainers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MinimalContainerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MinimalContainerDto[]>;
        }));
    }

    protected processGetContainers(response: HttpResponseBase): Observable<MinimalContainerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MinimalContainerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Soft delete WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @param containerId unique identifier of WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @return Success
     */
    softDeleteContainer(containerId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Container/SoftDelete/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSoftDeleteContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftDeleteContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSoftDeleteContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Hard Delete WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @param containerId unique identifier of WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @return Success
     */
    hardDeleteContainer(containerId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Container/HardDelete/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHardDeleteContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHardDeleteContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHardDeleteContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Restore a soft deleted WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @param containerId unique identifier of WE.UserPortal.Models.DataTransferObjects.ContainerDto
     * @return Success
     */
    restoreContainer(containerId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Container/Restore/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestoreContainer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Changes the owner of the container by updating the CreatedById
     * @param containerId container that gets a new owner.
     * @param newUpUserId Userportal identity id of the new owner
     * @param isOldUserAccessRevoked if false, user can still access his calculations
     * @return Success
     */
    changeOwnerOfContainer(containerId: number, newUpUserId: number, isOldUserAccessRevoked: boolean): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Container/ChangeOwnerOfContainer/{containerId}/{newUpUserId}/{isOldUserAccessRevoked}";
        if (containerId === undefined || containerId === null)
            throw new globalThis.Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        if (newUpUserId === undefined || newUpUserId === null)
            throw new globalThis.Error("The parameter 'newUpUserId' must be defined.");
        url_ = url_.replace("{newUpUserId}", encodeURIComponent("" + newUpUserId));
        if (isOldUserAccessRevoked === undefined || isOldUserAccessRevoked === null)
            throw new globalThis.Error("The parameter 'isOldUserAccessRevoked' must be defined.");
        url_ = url_.replace("{isOldUserAccessRevoked}", encodeURIComponent("" + isOldUserAccessRevoked));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOwnerOfContainer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOwnerOfContainer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeOwnerOfContainer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get paginated list of WE.UserPortal.Models.DataTransferObjects.CalculationDto based on organisationId and page number
     * @param organisationId organisationId to which calculations are linked via container
     * @param pageNumber requested page number
     * @param pageSize requested page size
     * @param includeOwnFolderCalculations (optional) if true then include the calculations added to the folders belonging to the organisation
     * @return Success
     */
    getPaginatedCalculationsForDataPortal(organisationId: number, pageNumber: number, pageSize: number, includeOwnFolderCalculations: boolean | undefined): Observable<CalculationDto[]> {
        let url_ = this.baseUrl + "/api/v1/DataPortal/GetPaginatedCalculations/{organisationId}/{pageNumber}/{pageSize}?";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (pageNumber === undefined || pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' must be defined.");
        url_ = url_.replace("{pageNumber}", encodeURIComponent("" + pageNumber));
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (includeOwnFolderCalculations === null)
            throw new globalThis.Error("The parameter 'includeOwnFolderCalculations' cannot be null.");
        else if (includeOwnFolderCalculations !== undefined)
            url_ += "includeOwnFolderCalculations=" + encodeURIComponent("" + includeOwnFolderCalculations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginatedCalculationsForDataPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginatedCalculationsForDataPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationDto[]>;
        }));
    }

    protected processGetPaginatedCalculationsForDataPortal(response: HttpResponseBase): Observable<CalculationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get paginated list of WE.UserPortal.Models.DataTransferObjects.CalculationDto based on organisationId, page number, dateFrom and dateUntil
     * @param organisationId organisationId to which calculations are linked via container
     * @param pageNumber requested page number
     * @param pageSize requested page size
     * @param dateFrom date from which the calculations should be retrieved
     * @param dateUntil (optional) date until which the calculations should be retrieved. If null, then default to today's date
     * @param includeOwnFolderCalculations (optional) if true then include the calculations added to the folders belonging to the organisation
     * @return Success
     */
    getPaginatedCalculationsByDateRangeForDataPortal(organisationId: number, pageNumber: number, pageSize: number, dateFrom: Date, dateUntil: Date | undefined, includeOwnFolderCalculations: boolean | undefined): Observable<CalculationDto[]> {
        let url_ = this.baseUrl + "/api/v1/DataPortal/GetPaginatedCalculationsByDateRange/{organisationId}/{pageNumber}/{pageSize}/{dateFrom}?";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (pageNumber === undefined || pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' must be defined.");
        url_ = url_.replace("{pageNumber}", encodeURIComponent("" + pageNumber));
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (dateFrom === undefined || dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' must be defined.");
        url_ = url_.replace("{dateFrom}", encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "null"));
        if (dateUntil === null)
            throw new globalThis.Error("The parameter 'dateUntil' cannot be null.");
        else if (dateUntil !== undefined)
            url_ += "dateUntil=" + encodeURIComponent(dateUntil ? "" + dateUntil.toISOString() : "") + "&";
        if (includeOwnFolderCalculations === null)
            throw new globalThis.Error("The parameter 'includeOwnFolderCalculations' cannot be null.");
        else if (includeOwnFolderCalculations !== undefined)
            url_ += "includeOwnFolderCalculations=" + encodeURIComponent("" + includeOwnFolderCalculations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginatedCalculationsByDateRangeForDataPortal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginatedCalculationsByDateRangeForDataPortal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationDto[]>;
        }));
    }

    protected processGetPaginatedCalculationsByDateRangeForDataPortal(response: HttpResponseBase): Observable<CalculationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets whether a feature is enabled for the logged in user or not
     * @param featureId (optional) The text id of the feature
     * @return Success
     */
    isFeatureEnabledForUser(featureId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/Feature/IsEnabled?";
        if (featureId === null)
            throw new globalThis.Error("The parameter 'featureId' cannot be null.");
        else if (featureId !== undefined)
            url_ += "featureId=" + encodeURIComponent("" + featureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsFeatureEnabledForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsFeatureEnabledForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsFeatureEnabledForUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importImportCalculation(calculationName: string, organisationId: number, contentVersionId: number, applicationId: number, body: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/ImportCalculation/ImportCalculation/{calculationName}/{organisationId}/{contentVersionId}/{applicationId}";
        if (calculationName === undefined || calculationName === null)
            throw new globalThis.Error("The parameter 'calculationName' must be defined.");
        url_ = url_.replace("{calculationName}", encodeURIComponent("" + calculationName));
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        if (applicationId === undefined || applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportImportCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportImportCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportImportCalculation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.UpLicenseDto  entities
     * @return Success
     * @deprecated
     */
    getAllLicenseEntities(): Observable<UpLicenseDto[]> {
        let url_ = this.baseUrl + "/api/v1/License";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLicenseEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLicenseEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpLicenseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpLicenseDto[]>;
        }));
    }

    protected processGetAllLicenseEntities(response: HttpResponseBase): Observable<UpLicenseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UpLicenseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postLicense(body: UpLicenseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/License";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostLicense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putLicense(body: UpLicenseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/License";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutLicense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.UpLicenseDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getLicenseById(id: number): Observable<UpLicenseDto> {
        let url_ = this.baseUrl + "/api/v1/License/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpLicenseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpLicenseDto>;
        }));
    }

    protected processGetLicenseById(response: HttpResponseBase): Observable<UpLicenseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpLicenseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteLicense(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/License/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLicense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Licenses with users
     * @return Success
     */
    getLicensesWithUsers(): Observable<LicenseManagementDto> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/LicensesWithUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicensesWithUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicensesWithUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenseManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenseManagementDto>;
        }));
    }

    protected processGetLicensesWithUsers(response: HttpResponseBase): Observable<LicenseManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseManagementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete User from license
     * @return Success
     */
    deleteUserFromLicense(licenseId: number, userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/DeleteUserFromLicense/{licenseId}/{userId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserFromLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserFromLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserFromLicense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Notify GPR Gebouw that user has removed from license
     * @return Success
     */
    notifyGprGebouwUserWasRemovedFromLicense(licenseId: number, userId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/NotifyGprGebouwUserWasRemovedFromLicense/{licenseId}/{userId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyGprGebouwUserWasRemovedFromLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyGprGebouwUserWasRemovedFromLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyGprGebouwUserWasRemovedFromLicense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new user to license and returns entire list
     * @param body (optional) 
     * @return Success
     */
    addUserToLicense(body: AddUserToLicenseDto | undefined): Observable<AddUsersToLicenseResponseDto> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/AddUserToLicense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserToLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserToLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddUsersToLicenseResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddUsersToLicenseResponseDto>;
        }));
    }

    protected processAddUserToLicense(response: HttpResponseBase): Observable<AddUsersToLicenseResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddUsersToLicenseResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resend an invitation email to the unregistered user
     * @param body (optional) 
     * @return Success
     */
    resendInvitationEmail(body: SendEmailAnnouncementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/ResendInvitationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendInvitationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendInvitationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendInvitationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change roles of a user for a certain license
     * @param body (optional) 
     * @return Success
     */
    addOrRemoveUserFromRoles(body: UserToRolesRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/AddOrRemoveUserFromRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrRemoveUserFromRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrRemoveUserFromRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrRemoveUserFromRoles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete User from license after reassigning calculations and containers/ folders of old user to new user
     * @param body (optional) 
     * @return Success
     */
    reassigningCalculationsAndContainersToNewUserAndDeleteOldUserFromLicense(body: DeleteUserAndReassignCalculationsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/ReassigningCalculationsAndContainersToNewUserAndDeleteOldUserFromLicense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassigningCalculationsAndContainersToNewUserAndDeleteOldUserFromLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassigningCalculationsAndContainersToNewUserAndDeleteOldUserFromLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReassigningCalculationsAndContainersToNewUserAndDeleteOldUserFromLicense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get license subscription info of current year
     * @return Success
     */
    subscriptionOfCurrentYear(licenseId: number): Observable<SubscriptionDto> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/SubscriptionOfCurrentYear/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionOfCurrentYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionOfCurrentYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDto>;
        }));
    }

    protected processSubscriptionOfCurrentYear(response: HttpResponseBase): Observable<SubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a list of new users to license and return list of successfully added users and list of users failed to be added
     * @param totalAvailableSeats (optional) 
     * @param csvFile (optional) 
     * @return Success
     */
    addUsersToLicense(licenseId: number, totalAvailableSeats: number | undefined, gprLicentiebeheerAppId: number, csvFile: FileParameter | undefined): Observable<AddUsersToLicenseResponseDto> {
        let url_ = this.baseUrl + "/api/v1/LicenseManager/AddUsersToLicense/{licenseId}/{gprLicentiebeheerAppId}?";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (gprLicentiebeheerAppId === undefined || gprLicentiebeheerAppId === null)
            throw new globalThis.Error("The parameter 'gprLicentiebeheerAppId' must be defined.");
        url_ = url_.replace("{gprLicentiebeheerAppId}", encodeURIComponent("" + gprLicentiebeheerAppId));
        if (totalAvailableSeats === null)
            throw new globalThis.Error("The parameter 'totalAvailableSeats' cannot be null.");
        else if (totalAvailableSeats !== undefined)
            url_ += "totalAvailableSeats=" + encodeURIComponent("" + totalAvailableSeats) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csvFile === null || csvFile === undefined)
            throw new globalThis.Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("csvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "csvFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddUsersToLicenseResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddUsersToLicenseResponseDto>;
        }));
    }

    protected processAddUsersToLicense(response: HttpResponseBase): Observable<AddUsersToLicenseResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddUsersToLicenseResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saving the Front-End logs into text file
     * @param body (optional) Log information
     * @return Success
     */
    saveFrontEndLogs(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Logger/SaveFrontEndLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFrontEndLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFrontEndLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveFrontEndLogs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the list of organization and licenses name to which user is mapped to.
     * @param userIdentityId unique identifier of user from Idp which is also stored in WE.UserPortal.Models.DataTransferObjects.UpUserDto as WE.UserPortal.Models.DataTransferObjects.UpUserDto.IdentityId
     * @param gprLicentiebeheerAppId unique identifier of the GprLicentiebeheer applications to which the license belongs to.
                This is stored in WE.AMP.Models.DataTransferObjects.ApplicationDto.GprLicentiebeheerAppId
     * @return Success
     */
    getOrganizationLicenseInfo(userIdentityId: string, gprLicentiebeheerAppId: number): Observable<OrganizationLicenseInfoDto[]> {
        let url_ = this.baseUrl + "/api/v1/Organization/GetOrganizationLicenseInfo/{userIdentityId}/{gprLicentiebeheerAppId}";
        if (userIdentityId === undefined || userIdentityId === null)
            throw new globalThis.Error("The parameter 'userIdentityId' must be defined.");
        url_ = url_.replace("{userIdentityId}", encodeURIComponent("" + userIdentityId));
        if (gprLicentiebeheerAppId === undefined || gprLicentiebeheerAppId === null)
            throw new globalThis.Error("The parameter 'gprLicentiebeheerAppId' must be defined.");
        url_ = url_.replace("{gprLicentiebeheerAppId}", encodeURIComponent("" + gprLicentiebeheerAppId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationLicenseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationLicenseInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationLicenseInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationLicenseInfoDto[]>;
        }));
    }

    protected processGetOrganizationLicenseInfo(response: HttpResponseBase): Observable<OrganizationLicenseInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationLicenseInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the list of organization and licenses name to which user is mapped to.
     * @param userIdentityId unique identifier of user from Idp which is also stored in WE.UserPortal.Models.DataTransferObjects.UpUserDto as WE.UserPortal.Models.DataTransferObjects.UpUserDto.IdentityId
     * @return Success
     * @deprecated
     */
    getOrganizationLicenseInfoByUserIdentityId(userIdentityId: string): Observable<OrganizationLicenseInfoDto[]> {
        let url_ = this.baseUrl + "/api/v1/Organization/GetOrganizationLicenseInfoByUserIdentityId/{userIdentityId}";
        if (userIdentityId === undefined || userIdentityId === null)
            throw new globalThis.Error("The parameter 'userIdentityId' must be defined.");
        url_ = url_.replace("{userIdentityId}", encodeURIComponent("" + userIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationLicenseInfoByUserIdentityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationLicenseInfoByUserIdentityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationLicenseInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationLicenseInfoDto[]>;
        }));
    }

    protected processGetOrganizationLicenseInfoByUserIdentityId(response: HttpResponseBase): Observable<OrganizationLicenseInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationLicenseInfoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves summary information for an organization identified by its unique code.
     * @param organisationCode The unique identifier of the organization to retrieve information for.
     * @return Success
     */
    getOrganisationInfoByCode(organisationCode: string): Observable<OrganizationSummaryResponse> {
        let url_ = this.baseUrl + "/api/v1/Organization/GetOrganisationInfoByCode/{organisationCode}";
        if (organisationCode === undefined || organisationCode === null)
            throw new globalThis.Error("The parameter 'organisationCode' must be defined.");
        url_ = url_.replace("{organisationCode}", encodeURIComponent("" + organisationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationInfoByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationInfoByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationSummaryResponse>;
        }));
    }

    protected processGetOrganisationInfoByCode(response: HttpResponseBase): Observable<OrganizationSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllParameterToAssessmentExpressionResultEntities(): Observable<ParameterToAssessmentExpressionResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/ParameterToAssessmentExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParameterToAssessmentExpressionResultEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParameterToAssessmentExpressionResultEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToAssessmentExpressionResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToAssessmentExpressionResultDto[]>;
        }));
    }

    protected processGetAllParameterToAssessmentExpressionResultEntities(response: HttpResponseBase): Observable<ParameterToAssessmentExpressionResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterToAssessmentExpressionResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterToAssessmentExpressionResult(body: ParameterToAssessmentExpressionResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterToAssessmentExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostParameterToAssessmentExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostParameterToAssessmentExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostParameterToAssessmentExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterToAssessmentExpressionResult(body: ParameterToAssessmentExpressionResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterToAssessmentExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutParameterToAssessmentExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutParameterToAssessmentExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutParameterToAssessmentExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getParameterToAssessmentExpressionResultById(id: number): Observable<ParameterToAssessmentExpressionResultDto> {
        let url_ = this.baseUrl + "/api/v1/ParameterToAssessmentExpressionResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterToAssessmentExpressionResultById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterToAssessmentExpressionResultById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToAssessmentExpressionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToAssessmentExpressionResultDto>;
        }));
    }

    protected processGetParameterToAssessmentExpressionResultById(response: HttpResponseBase): Observable<ParameterToAssessmentExpressionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterToAssessmentExpressionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterToAssessmentExpressionResult(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterToAssessmentExpressionResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParameterToAssessmentExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParameterToAssessmentExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParameterToAssessmentExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.ParameterToCalculationCoreExpressionResultDto  entities
     * @return Success
     * @deprecated
     */
    getAllParameterToCalculationCoreExpressionResultEntities(): Observable<ParameterToCalculationCoreExpressionResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/ParameterToCalculationCoreExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParameterToCalculationCoreExpressionResultEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParameterToCalculationCoreExpressionResultEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToCalculationCoreExpressionResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToCalculationCoreExpressionResultDto[]>;
        }));
    }

    protected processGetAllParameterToCalculationCoreExpressionResultEntities(response: HttpResponseBase): Observable<ParameterToCalculationCoreExpressionResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterToCalculationCoreExpressionResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterToCalculationCoreExpressionResult(body: ParameterToCalculationCoreExpressionResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterToCalculationCoreExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostParameterToCalculationCoreExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostParameterToCalculationCoreExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostParameterToCalculationCoreExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterToCalculationCoreExpressionResult(body: ParameterToCalculationCoreExpressionResultDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterToCalculationCoreExpressionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutParameterToCalculationCoreExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutParameterToCalculationCoreExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutParameterToCalculationCoreExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.ParameterToCalculationCoreExpressionResultDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getParameterToCalculationCoreExpressionResultById(id: number): Observable<ParameterToCalculationCoreExpressionResultDto> {
        let url_ = this.baseUrl + "/api/v1/ParameterToCalculationCoreExpressionResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterToCalculationCoreExpressionResultById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterToCalculationCoreExpressionResultById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToCalculationCoreExpressionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToCalculationCoreExpressionResultDto>;
        }));
    }

    protected processGetParameterToCalculationCoreExpressionResultById(response: HttpResponseBase): Observable<ParameterToCalculationCoreExpressionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterToCalculationCoreExpressionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterToCalculationCoreExpressionResult(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterToCalculationCoreExpressionResult/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParameterToCalculationCoreExpressionResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParameterToCalculationCoreExpressionResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParameterToCalculationCoreExpressionResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.UserPortal.Models.DataTransferObjects.UpUserDto  entities
     * @return Success
     * @deprecated
     */
    getAllUserEntities(): Observable<UpUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpUserDto[]>;
        }));
    }

    protected processGetAllUserEntities(response: HttpResponseBase): Observable<UpUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UpUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postUser(body: UpUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putUser(body: UpUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.UserPortal.Models.DataTransferObjects.UpUserDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     * @deprecated
     */
    getUserById(id: number): Observable<UpUserDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpUserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UpUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all users that are linked to the same organization.
     * @return Success
     */
    getUsersByOrganizationId(organizationId: number): Observable<IdpUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/User/GetUsersByOrganizationId/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdpUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdpUserDto[]>;
        }));
    }

    protected processGetUsersByOrganizationId(response: HttpResponseBase): Observable<IdpUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdpUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get logged in user licenses along with other mapped users to that licenses
     * @return Success
     */
    getLicensesWithOtherUsers(): Observable<LicenseManagementDto> {
        let url_ = this.baseUrl + "/api/v1/User/LicensesWithOtherUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicensesWithOtherUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicensesWithOtherUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenseManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenseManagementDto>;
        }));
    }

    protected processGetLicensesWithOtherUsers(response: HttpResponseBase): Observable<LicenseManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseManagementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all loggedIn user id
     * @return Success
     */
    getLoggedInUserId(): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/User/LoggedInUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoggedInUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedInUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLoggedInUserId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all users that are linked to the same license as the license with user in request
     * @return Success
     */
    getOtherUsersInSameLicense(licenseId: number, userIdentityId: string): Observable<IdpUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/User/OtherUsersInSameLicense/{licenseId}/{userIdentityId}";
        if (licenseId === undefined || licenseId === null)
            throw new globalThis.Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (userIdentityId === undefined || userIdentityId === null)
            throw new globalThis.Error("The parameter 'userIdentityId' must be defined.");
        url_ = url_.replace("{userIdentityId}", encodeURIComponent("" + userIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherUsersInSameLicense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherUsersInSameLicense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdpUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdpUserDto[]>;
        }));
    }

    protected processGetOtherUsersInSameLicense(response: HttpResponseBase): Observable<IdpUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdpUserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ApplicationDto implements IApplicationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name!: string;
    key!: string;
    description?: string | undefined;
    image?: string | undefined;
    brandLogo?: string | undefined;
    lastPublishedDate?: Date | undefined;
    createdById?: number;
    createdBy?: UserDto;
    modifiedById?: number | undefined;
    modifiedBy?: UserDto;
    lastPublishedById?: number | undefined;
    lastPublishedBy?: UserDto;
    contentVersions?: ContentVersionDto[] | undefined;
    domainUrl?: string | undefined;
    noCalculations?: boolean;
    gprLicentiebeheerAppId?: number | undefined;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.brandLogo = _data["brandLogo"];
            this.lastPublishedDate = _data["lastPublishedDate"] ? new Date(_data["lastPublishedDate"].toString()) : undefined as any;
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : undefined as any;
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : undefined as any;
            this.lastPublishedById = _data["lastPublishedById"];
            this.lastPublishedBy = _data["lastPublishedBy"] ? UserDto.fromJS(_data["lastPublishedBy"]) : undefined as any;
            if (Array.isArray(_data["contentVersions"])) {
                this.contentVersions = [] as any;
                for (let item of _data["contentVersions"])
                    this.contentVersions!.push(ContentVersionDto.fromJS(item));
            }
            this.domainUrl = _data["domainUrl"];
            this.noCalculations = _data["noCalculations"];
            this.gprLicentiebeheerAppId = _data["gprLicentiebeheerAppId"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["description"] = this.description;
        data["image"] = this.image;
        data["brandLogo"] = this.brandLogo;
        data["lastPublishedDate"] = this.lastPublishedDate ? this.lastPublishedDate.toISOString() : undefined as any;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : undefined as any;
        data["lastPublishedById"] = this.lastPublishedById;
        data["lastPublishedBy"] = this.lastPublishedBy ? this.lastPublishedBy.toJSON() : undefined as any;
        if (Array.isArray(this.contentVersions)) {
            data["contentVersions"] = [];
            for (let item of this.contentVersions)
                data["contentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        data["domainUrl"] = this.domainUrl;
        data["noCalculations"] = this.noCalculations;
        data["gprLicentiebeheerAppId"] = this.gprLicentiebeheerAppId;
        return data;
    }
}

export interface IApplicationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name: string;
    key: string;
    description?: string | undefined;
    image?: string | undefined;
    brandLogo?: string | undefined;
    lastPublishedDate?: Date | undefined;
    createdById?: number;
    createdBy?: UserDto;
    modifiedById?: number | undefined;
    modifiedBy?: UserDto;
    lastPublishedById?: number | undefined;
    lastPublishedBy?: UserDto;
    contentVersions?: ContentVersionDto[] | undefined;
    domainUrl?: string | undefined;
    noCalculations?: boolean;
    gprLicentiebeheerAppId?: number | undefined;
}

export class AssessmentEntityByContentVersionByAssessmentSubjectDto implements IAssessmentEntityByContentVersionByAssessmentSubjectDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    weight?: number | undefined;
    assessmentEntityByContentVersionId!: number;
    assessmentSubjectTypeId!: number;

    constructor(data?: IAssessmentEntityByContentVersionByAssessmentSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.weight = _data["weight"];
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.assessmentSubjectTypeId = _data["assessmentSubjectTypeId"];
        }
    }

    static fromJS(data: any): AssessmentEntityByContentVersionByAssessmentSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityByContentVersionByAssessmentSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["weight"] = this.weight;
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["assessmentSubjectTypeId"] = this.assessmentSubjectTypeId;
        return data;
    }
}

export interface IAssessmentEntityByContentVersionByAssessmentSubjectDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    weight?: number | undefined;
    assessmentEntityByContentVersionId: number;
    assessmentSubjectTypeId: number;
}

export class AssessmentEntityByContentVersionDto implements IAssessmentEntityByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    order?: number;
    contentVersionId!: number;
    isNewBuilding?: boolean;
    isExistingBuilding?: boolean;
    assessmentEntityId!: number;
    assessmentEntityByContentVersionByAssessmentSubjects?: AssessmentEntityByContentVersionByAssessmentSubjectDto[] | undefined;

    constructor(data?: IAssessmentEntityByContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.order = _data["order"];
            this.contentVersionId = _data["contentVersionId"];
            this.isNewBuilding = _data["isNewBuilding"];
            this.isExistingBuilding = _data["isExistingBuilding"];
            this.assessmentEntityId = _data["assessmentEntityId"];
            if (Array.isArray(_data["assessmentEntityByContentVersionByAssessmentSubjects"])) {
                this.assessmentEntityByContentVersionByAssessmentSubjects = [] as any;
                for (let item of _data["assessmentEntityByContentVersionByAssessmentSubjects"])
                    this.assessmentEntityByContentVersionByAssessmentSubjects!.push(AssessmentEntityByContentVersionByAssessmentSubjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentEntityByContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityByContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["order"] = this.order;
        data["contentVersionId"] = this.contentVersionId;
        data["isNewBuilding"] = this.isNewBuilding;
        data["isExistingBuilding"] = this.isExistingBuilding;
        data["assessmentEntityId"] = this.assessmentEntityId;
        if (Array.isArray(this.assessmentEntityByContentVersionByAssessmentSubjects)) {
            data["assessmentEntityByContentVersionByAssessmentSubjects"] = [];
            for (let item of this.assessmentEntityByContentVersionByAssessmentSubjects)
                data["assessmentEntityByContentVersionByAssessmentSubjects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssessmentEntityByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    order?: number;
    contentVersionId: number;
    isNewBuilding?: boolean;
    isExistingBuilding?: boolean;
    assessmentEntityId: number;
    assessmentEntityByContentVersionByAssessmentSubjects?: AssessmentEntityByContentVersionByAssessmentSubjectDto[] | undefined;
}

export class CalculationCoreDto implements ICalculationCoreDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name!: string;
    description?: string | undefined;
    endPoint?: string | undefined;
    calculationCoreVersions?: CalculationCoreVersionDto[] | undefined;

    constructor(data?: ICalculationCoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.endPoint = _data["endPoint"];
            if (Array.isArray(_data["calculationCoreVersions"])) {
                this.calculationCoreVersions = [] as any;
                for (let item of _data["calculationCoreVersions"])
                    this.calculationCoreVersions!.push(CalculationCoreVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationCoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["endPoint"] = this.endPoint;
        if (Array.isArray(this.calculationCoreVersions)) {
            data["calculationCoreVersions"] = [];
            for (let item of this.calculationCoreVersions)
                data["calculationCoreVersions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalculationCoreDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name: string;
    description?: string | undefined;
    endPoint?: string | undefined;
    calculationCoreVersions?: CalculationCoreVersionDto[] | undefined;
}

export class CalculationCoreExpressionDto implements ICalculationCoreExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    explanation?: string | undefined;
    value!: string;
    requestDataMemberName?: string | undefined;
    calculationCoreVersionId!: number;
    calculationCoreVersion?: CalculationCoreVersionDto;

    constructor(data?: ICalculationCoreExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            this.value = _data["value"];
            this.requestDataMemberName = _data["requestDataMemberName"];
            this.calculationCoreVersionId = _data["calculationCoreVersionId"];
            this.calculationCoreVersion = _data["calculationCoreVersion"] ? CalculationCoreVersionDto.fromJS(_data["calculationCoreVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationCoreExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        data["value"] = this.value;
        data["requestDataMemberName"] = this.requestDataMemberName;
        data["calculationCoreVersionId"] = this.calculationCoreVersionId;
        data["calculationCoreVersion"] = this.calculationCoreVersion ? this.calculationCoreVersion.toJSON() : undefined as any;
        return data;
    }
}

export interface ICalculationCoreExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    explanation?: string | undefined;
    value: string;
    requestDataMemberName?: string | undefined;
    calculationCoreVersionId: number;
    calculationCoreVersion?: CalculationCoreVersionDto;
}

export class CalculationCoreResultExpressionDto implements ICalculationCoreResultExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    explanation?: string | undefined;
    value!: string;
    responseDataMemberName?: string | undefined;
    calculationCoreVersionId?: number | undefined;
    calculationCoreVersion?: CalculationCoreVersionDto;

    constructor(data?: ICalculationCoreResultExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            this.value = _data["value"];
            this.responseDataMemberName = _data["responseDataMemberName"];
            this.calculationCoreVersionId = _data["calculationCoreVersionId"];
            this.calculationCoreVersion = _data["calculationCoreVersion"] ? CalculationCoreVersionDto.fromJS(_data["calculationCoreVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationCoreResultExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreResultExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        data["value"] = this.value;
        data["responseDataMemberName"] = this.responseDataMemberName;
        data["calculationCoreVersionId"] = this.calculationCoreVersionId;
        data["calculationCoreVersion"] = this.calculationCoreVersion ? this.calculationCoreVersion.toJSON() : undefined as any;
        return data;
    }
}

export interface ICalculationCoreResultExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    explanation?: string | undefined;
    value: string;
    responseDataMemberName?: string | undefined;
    calculationCoreVersionId?: number | undefined;
    calculationCoreVersion?: CalculationCoreVersionDto;
}

export class CalculationCoreVersionDto implements ICalculationCoreVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    number!: number;
    calculationCoreId?: number;
    calculationCore?: CalculationCoreDto;
    calculationCoreResultExpressions?: CalculationCoreResultExpressionDto[] | undefined;
    calculationCoreExpressions?: CalculationCoreExpressionDto[] | undefined;

    constructor(data?: ICalculationCoreVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.number = _data["number"];
            this.calculationCoreId = _data["calculationCoreId"];
            this.calculationCore = _data["calculationCore"] ? CalculationCoreDto.fromJS(_data["calculationCore"]) : undefined as any;
            if (Array.isArray(_data["calculationCoreResultExpressions"])) {
                this.calculationCoreResultExpressions = [] as any;
                for (let item of _data["calculationCoreResultExpressions"])
                    this.calculationCoreResultExpressions!.push(CalculationCoreResultExpressionDto.fromJS(item));
            }
            if (Array.isArray(_data["calculationCoreExpressions"])) {
                this.calculationCoreExpressions = [] as any;
                for (let item of _data["calculationCoreExpressions"])
                    this.calculationCoreExpressions!.push(CalculationCoreExpressionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationCoreVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["number"] = this.number;
        data["calculationCoreId"] = this.calculationCoreId;
        data["calculationCore"] = this.calculationCore ? this.calculationCore.toJSON() : undefined as any;
        if (Array.isArray(this.calculationCoreResultExpressions)) {
            data["calculationCoreResultExpressions"] = [];
            for (let item of this.calculationCoreResultExpressions)
                data["calculationCoreResultExpressions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calculationCoreExpressions)) {
            data["calculationCoreExpressions"] = [];
            for (let item of this.calculationCoreExpressions)
                data["calculationCoreExpressions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalculationCoreVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    number: number;
    calculationCoreId?: number;
    calculationCore?: CalculationCoreDto;
    calculationCoreResultExpressions?: CalculationCoreResultExpressionDto[] | undefined;
    calculationCoreExpressions?: CalculationCoreExpressionDto[] | undefined;
}

export class ContentVersionDto implements IContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    number!: number;
    description?: string | undefined;
    applicationId?: number;
    application?: ApplicationDto;
    statusId?: number;
    status?: StatusDto;
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    assessmentEntityByContentVersions?: AssessmentEntityByContentVersionDto[] | undefined;
    editSessions?: EditSessionDto[] | undefined;

    constructor(data?: IContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : undefined as any;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? StatusDto.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["elementsByContentVersions"])) {
                this.elementsByContentVersions = [] as any;
                for (let item of _data["elementsByContentVersions"])
                    this.elementsByContentVersions!.push(ElementByContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["assessmentEntityByContentVersions"])) {
                this.assessmentEntityByContentVersions = [] as any;
                for (let item of _data["assessmentEntityByContentVersions"])
                    this.assessmentEntityByContentVersions!.push(AssessmentEntityByContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["editSessions"])) {
                this.editSessions = [] as any;
                for (let item of _data["editSessions"])
                    this.editSessions!.push(EditSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["number"] = this.number;
        data["description"] = this.description;
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.elementsByContentVersions)) {
            data["elementsByContentVersions"] = [];
            for (let item of this.elementsByContentVersions)
                data["elementsByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentEntityByContentVersions)) {
            data["assessmentEntityByContentVersions"] = [];
            for (let item of this.assessmentEntityByContentVersions)
                data["assessmentEntityByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.editSessions)) {
            data["editSessions"] = [];
            for (let item of this.editSessions)
                data["editSessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    number: number;
    description?: string | undefined;
    applicationId?: number;
    application?: ApplicationDto;
    statusId?: number;
    status?: StatusDto;
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    assessmentEntityByContentVersions?: AssessmentEntityByContentVersionDto[] | undefined;
    editSessions?: EditSessionDto[] | undefined;
}

export class DataContractDto implements IDataContractDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name!: string;
    baseContractId!: number;
    baseContract?: DataContractDto;
    calculationCoreVersionId!: number;
    calculationCoreVersion?: CalculationCoreVersionDto;
    dataMembers?: DataMemberDto[] | undefined;

    constructor(data?: IDataContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.baseContractId = _data["baseContractId"];
            this.baseContract = _data["baseContract"] ? DataContractDto.fromJS(_data["baseContract"]) : undefined as any;
            this.calculationCoreVersionId = _data["calculationCoreVersionId"];
            this.calculationCoreVersion = _data["calculationCoreVersion"] ? CalculationCoreVersionDto.fromJS(_data["calculationCoreVersion"]) : undefined as any;
            if (Array.isArray(_data["dataMembers"])) {
                this.dataMembers = [] as any;
                for (let item of _data["dataMembers"])
                    this.dataMembers!.push(DataMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["baseContractId"] = this.baseContractId;
        data["baseContract"] = this.baseContract ? this.baseContract.toJSON() : undefined as any;
        data["calculationCoreVersionId"] = this.calculationCoreVersionId;
        data["calculationCoreVersion"] = this.calculationCoreVersion ? this.calculationCoreVersion.toJSON() : undefined as any;
        if (Array.isArray(this.dataMembers)) {
            data["dataMembers"] = [];
            for (let item of this.dataMembers)
                data["dataMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataContractDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name: string;
    baseContractId: number;
    baseContract?: DataContractDto;
    calculationCoreVersionId: number;
    calculationCoreVersion?: CalculationCoreVersionDto;
    dataMembers?: DataMemberDto[] | undefined;
}

export class DataMemberDto implements IDataMemberDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key!: string;
    name!: string;
    description?: string | undefined;
    isEnumerable?: boolean;
    dataType?: string | undefined;
    dataContractId!: number;
    dataContract?: DataContractDto;
    parameters?: ParameterDto[] | undefined;

    constructor(data?: IDataMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isEnumerable = _data["isEnumerable"];
            this.dataType = _data["dataType"];
            this.dataContractId = _data["dataContractId"];
            this.dataContract = _data["dataContract"] ? DataContractDto.fromJS(_data["dataContract"]) : undefined as any;
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isEnumerable"] = this.isEnumerable;
        data["dataType"] = this.dataType;
        data["dataContractId"] = this.dataContractId;
        data["dataContract"] = this.dataContract ? this.dataContract.toJSON() : undefined as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataMemberDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key: string;
    name: string;
    description?: string | undefined;
    isEnumerable?: boolean;
    dataType?: string | undefined;
    dataContractId: number;
    dataContract?: DataContractDto;
    parameters?: ParameterDto[] | undefined;
}

export class ExpressionByParameterElementAndContentVersionDto implements IExpressionByParameterElementAndContentVersionDto {
    parameterToAssessmentExpressionId!: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;
    parameterId!: number;
    parameter?: ParameterDto;
    elementId!: number;
    element?: ElementDto;
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    assessmentEntityByContentVersionId!: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    expressionVariable!: string;

    constructor(data?: IExpressionByParameterElementAndContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterToAssessmentExpressionId = _data["parameterToAssessmentExpressionId"];
            this.parameterToAssessmentExpression = _data["parameterToAssessmentExpression"] ? ParameterToAssessmentExpressionDto.fromJS(_data["parameterToAssessmentExpression"]) : undefined as any;
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.elementId = _data["elementId"];
            this.element = _data["element"] ? ElementDto.fromJS(_data["element"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.assessmentEntityByContentVersion = _data["assessmentEntityByContentVersion"] ? AssessmentEntityByContentVersionDto.fromJS(_data["assessmentEntityByContentVersion"]) : undefined as any;
            this.expressionVariable = _data["expressionVariable"];
        }
    }

    static fromJS(data: any): ExpressionByParameterElementAndContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpressionByParameterElementAndContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterToAssessmentExpressionId"] = this.parameterToAssessmentExpressionId;
        data["parameterToAssessmentExpression"] = this.parameterToAssessmentExpression ? this.parameterToAssessmentExpression.toJSON() : undefined as any;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["elementId"] = this.elementId;
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["assessmentEntityByContentVersion"] = this.assessmentEntityByContentVersion ? this.assessmentEntityByContentVersion.toJSON() : undefined as any;
        data["expressionVariable"] = this.expressionVariable;
        return data;
    }
}

export interface IExpressionByParameterElementAndContentVersionDto {
    parameterToAssessmentExpressionId: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;
    parameterId: number;
    parameter?: ParameterDto;
    elementId: number;
    element?: ElementDto;
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    assessmentEntityByContentVersionId: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    expressionVariable: string;
}

export class ParameterToAssessmentExpressionByAssessmentEntityDto implements IParameterToAssessmentExpressionByAssessmentEntityDto {
    assessmentEntityByContentVersionId!: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    parameterToAssessmentExpressionId!: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;

    constructor(data?: IParameterToAssessmentExpressionByAssessmentEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.assessmentEntityByContentVersion = _data["assessmentEntityByContentVersion"] ? AssessmentEntityByContentVersionDto.fromJS(_data["assessmentEntityByContentVersion"]) : undefined as any;
            this.parameterToAssessmentExpressionId = _data["parameterToAssessmentExpressionId"];
            this.parameterToAssessmentExpression = _data["parameterToAssessmentExpression"] ? ParameterToAssessmentExpressionDto.fromJS(_data["parameterToAssessmentExpression"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParameterToAssessmentExpressionByAssessmentEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterToAssessmentExpressionByAssessmentEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["assessmentEntityByContentVersion"] = this.assessmentEntityByContentVersion ? this.assessmentEntityByContentVersion.toJSON() : undefined as any;
        data["parameterToAssessmentExpressionId"] = this.parameterToAssessmentExpressionId;
        data["parameterToAssessmentExpression"] = this.parameterToAssessmentExpression ? this.parameterToAssessmentExpression.toJSON() : undefined as any;
        return data;
    }
}

export interface IParameterToAssessmentExpressionByAssessmentEntityDto {
    assessmentEntityByContentVersionId: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    parameterToAssessmentExpressionId: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;
}

export class ParameterToAssessmentExpressionDto implements IParameterToAssessmentExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    explanation?: string | undefined;
    value!: string;
    readonly isMappedWithParameter?: boolean;
    isNew?: boolean;
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;
    parameterToAssessmentExpressionByAssessmentEntities?: ParameterToAssessmentExpressionByAssessmentEntityDto[] | undefined;

    constructor(data?: IParameterToAssessmentExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            this.value = _data["value"];
            (this as any).isMappedWithParameter = _data["isMappedWithParameter"];
            this.isNew = _data["isNew"];
            if (Array.isArray(_data["expressionByParameterElementAndContentVersions"])) {
                this.expressionByParameterElementAndContentVersions = [] as any;
                for (let item of _data["expressionByParameterElementAndContentVersions"])
                    this.expressionByParameterElementAndContentVersions!.push(ExpressionByParameterElementAndContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["parameterToAssessmentExpressionByAssessmentEntities"])) {
                this.parameterToAssessmentExpressionByAssessmentEntities = [] as any;
                for (let item of _data["parameterToAssessmentExpressionByAssessmentEntities"])
                    this.parameterToAssessmentExpressionByAssessmentEntities!.push(ParameterToAssessmentExpressionByAssessmentEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterToAssessmentExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterToAssessmentExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        data["value"] = this.value;
        data["isMappedWithParameter"] = this.isMappedWithParameter;
        data["isNew"] = this.isNew;
        if (Array.isArray(this.expressionByParameterElementAndContentVersions)) {
            data["expressionByParameterElementAndContentVersions"] = [];
            for (let item of this.expressionByParameterElementAndContentVersions)
                data["expressionByParameterElementAndContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parameterToAssessmentExpressionByAssessmentEntities)) {
            data["parameterToAssessmentExpressionByAssessmentEntities"] = [];
            for (let item of this.parameterToAssessmentExpressionByAssessmentEntities)
                data["parameterToAssessmentExpressionByAssessmentEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParameterToAssessmentExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    explanation?: string | undefined;
    value: string;
    isMappedWithParameter?: boolean;
    isNew?: boolean;
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;
    parameterToAssessmentExpressionByAssessmentEntities?: ParameterToAssessmentExpressionByAssessmentEntityDto[] | undefined;
}

export class InputSubTypeDto implements IInputSubTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value!: string;
    templateOptionses?: TemplateOptionsDto[] | undefined;

    constructor(data?: IInputSubTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            if (Array.isArray(_data["templateOptionses"])) {
                this.templateOptionses = [] as any;
                for (let item of _data["templateOptionses"])
                    this.templateOptionses!.push(TemplateOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputSubTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputSubTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        if (Array.isArray(this.templateOptionses)) {
            data["templateOptionses"] = [];
            for (let item of this.templateOptionses)
                data["templateOptionses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInputSubTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value: string;
    templateOptionses?: TemplateOptionsDto[] | undefined;
}

export class PatternDto implements IPatternDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    value!: string;
    templateOptionses?: TemplateOptionsDto[] | undefined;

    constructor(data?: IPatternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["templateOptionses"])) {
                this.templateOptionses = [] as any;
                for (let item of _data["templateOptionses"])
                    this.templateOptionses!.push(TemplateOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatternDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.templateOptionses)) {
            data["templateOptionses"] = [];
            for (let item of this.templateOptionses)
                data["templateOptionses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPatternDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    value: string;
    templateOptionses?: TemplateOptionsDto[] | undefined;
}

export class TemplateOptionsDto implements ITemplateOptionsDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    defaultValue?: string | undefined;
    checked?: boolean | undefined;
    disabled?: boolean | undefined;
    hidden?: boolean | undefined;
    max?: number | undefined;
    min?: number | undefined;
    valueIsGreaterThanMin?: boolean;
    valueIsLessThanMax?: boolean;
    readonly?: boolean | undefined;
    decimalPrecision?: number | undefined;
    maxlength?: number | undefined;
    patternId?: number | undefined;
    pattern?: PatternDto;
    inputSubTypeId?: number | undefined;
    inputSubType?: InputSubTypeDto;
    parameterOverride?: ParameterOverrideDto;

    constructor(data?: ITemplateOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.defaultValue = _data["defaultValue"];
            this.checked = _data["checked"];
            this.disabled = _data["disabled"];
            this.hidden = _data["hidden"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.valueIsGreaterThanMin = _data["valueIsGreaterThanMin"];
            this.valueIsLessThanMax = _data["valueIsLessThanMax"];
            this.readonly = _data["readonly"];
            this.decimalPrecision = _data["decimalPrecision"];
            this.maxlength = _data["maxlength"];
            this.patternId = _data["patternId"];
            this.pattern = _data["pattern"] ? PatternDto.fromJS(_data["pattern"]) : undefined as any;
            this.inputSubTypeId = _data["inputSubTypeId"];
            this.inputSubType = _data["inputSubType"] ? InputSubTypeDto.fromJS(_data["inputSubType"]) : undefined as any;
            this.parameterOverride = _data["parameterOverride"] ? ParameterOverrideDto.fromJS(_data["parameterOverride"]) : undefined as any;
        }
    }

    static fromJS(data: any): TemplateOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["defaultValue"] = this.defaultValue;
        data["checked"] = this.checked;
        data["disabled"] = this.disabled;
        data["hidden"] = this.hidden;
        data["max"] = this.max;
        data["min"] = this.min;
        data["valueIsGreaterThanMin"] = this.valueIsGreaterThanMin;
        data["valueIsLessThanMax"] = this.valueIsLessThanMax;
        data["readonly"] = this.readonly;
        data["decimalPrecision"] = this.decimalPrecision;
        data["maxlength"] = this.maxlength;
        data["patternId"] = this.patternId;
        data["pattern"] = this.pattern ? this.pattern.toJSON() : undefined as any;
        data["inputSubTypeId"] = this.inputSubTypeId;
        data["inputSubType"] = this.inputSubType ? this.inputSubType.toJSON() : undefined as any;
        data["parameterOverride"] = this.parameterOverride ? this.parameterOverride.toJSON() : undefined as any;
        return data;
    }
}

export interface ITemplateOptionsDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    defaultValue?: string | undefined;
    checked?: boolean | undefined;
    disabled?: boolean | undefined;
    hidden?: boolean | undefined;
    max?: number | undefined;
    min?: number | undefined;
    valueIsGreaterThanMin?: boolean;
    valueIsLessThanMax?: boolean;
    readonly?: boolean | undefined;
    decimalPrecision?: number | undefined;
    maxlength?: number | undefined;
    patternId?: number | undefined;
    pattern?: PatternDto;
    inputSubTypeId?: number | undefined;
    inputSubType?: InputSubTypeDto;
    parameterOverride?: ParameterOverrideDto;
}

export class OrganizationDto implements IOrganizationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    gprGebruikersId!: number;
    users?: UserDto[] | undefined;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.gprGebruikersId = _data["gprGebruikersId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["gprGebruikersId"] = this.gprGebruikersId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    gprGebruikersId: number;
    users?: UserDto[] | undefined;
}

export class ElementByContentVersionDto implements IElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    order?: number;
    elementId!: number;
    element?: ElementDto;
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    referencedChildren?: ElementByContentVersionSelfReferenceDto[] | undefined;
    referencedParents?: ElementByContentVersionSelfReferenceDto[] | undefined;
    parameterByElementByContentVersions?: ParameterByElementByContentVersionDto[] | undefined;

    constructor(data?: IElementByContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.order = _data["order"];
            this.elementId = _data["elementId"];
            this.element = _data["element"] ? ElementDto.fromJS(_data["element"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            if (Array.isArray(_data["referencedChildren"])) {
                this.referencedChildren = [] as any;
                for (let item of _data["referencedChildren"])
                    this.referencedChildren!.push(ElementByContentVersionSelfReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["referencedParents"])) {
                this.referencedParents = [] as any;
                for (let item of _data["referencedParents"])
                    this.referencedParents!.push(ElementByContentVersionSelfReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["parameterByElementByContentVersions"])) {
                this.parameterByElementByContentVersions = [] as any;
                for (let item of _data["parameterByElementByContentVersions"])
                    this.parameterByElementByContentVersions!.push(ParameterByElementByContentVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementByContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementByContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["order"] = this.order;
        data["elementId"] = this.elementId;
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        if (Array.isArray(this.referencedChildren)) {
            data["referencedChildren"] = [];
            for (let item of this.referencedChildren)
                data["referencedChildren"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referencedParents)) {
            data["referencedParents"] = [];
            for (let item of this.referencedParents)
                data["referencedParents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parameterByElementByContentVersions)) {
            data["parameterByElementByContentVersions"] = [];
            for (let item of this.parameterByElementByContentVersions)
                data["parameterByElementByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    order?: number;
    elementId: number;
    element?: ElementDto;
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    referencedChildren?: ElementByContentVersionSelfReferenceDto[] | undefined;
    referencedParents?: ElementByContentVersionSelfReferenceDto[] | undefined;
    parameterByElementByContentVersions?: ParameterByElementByContentVersionDto[] | undefined;
}

export class ElementByContentVersionSelfReferenceDto implements IElementByContentVersionSelfReferenceDto {
    parentId!: number;
    parent?: ElementByContentVersionDto;
    childId!: number;
    child?: ElementByContentVersionDto;

    constructor(data?: IElementByContentVersionSelfReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? ElementByContentVersionDto.fromJS(_data["parent"]) : undefined as any;
            this.childId = _data["childId"];
            this.child = _data["child"] ? ElementByContentVersionDto.fromJS(_data["child"]) : undefined as any;
        }
    }

    static fromJS(data: any): ElementByContentVersionSelfReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementByContentVersionSelfReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["childId"] = this.childId;
        data["child"] = this.child ? this.child.toJSON() : undefined as any;
        return data;
    }
}

export interface IElementByContentVersionSelfReferenceDto {
    parentId: number;
    parent?: ElementByContentVersionDto;
    childId: number;
    child?: ElementByContentVersionDto;
}

export class ElementDto implements IElementDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    elementTypeId!: number;
    elementType?: ElementTypeDto;
    elementOverrides?: ElementOverrideDto[] | undefined;
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;

    constructor(data?: IElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.elementTypeId = _data["elementTypeId"];
            this.elementType = _data["elementType"] ? ElementTypeDto.fromJS(_data["elementType"]) : undefined as any;
            if (Array.isArray(_data["elementOverrides"])) {
                this.elementOverrides = [] as any;
                for (let item of _data["elementOverrides"])
                    this.elementOverrides!.push(ElementOverrideDto.fromJS(item));
            }
            if (Array.isArray(_data["elementsByContentVersions"])) {
                this.elementsByContentVersions = [] as any;
                for (let item of _data["elementsByContentVersions"])
                    this.elementsByContentVersions!.push(ElementByContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["expressionByParameterElementAndContentVersions"])) {
                this.expressionByParameterElementAndContentVersions = [] as any;
                for (let item of _data["expressionByParameterElementAndContentVersions"])
                    this.expressionByParameterElementAndContentVersions!.push(ExpressionByParameterElementAndContentVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["elementTypeId"] = this.elementTypeId;
        data["elementType"] = this.elementType ? this.elementType.toJSON() : undefined as any;
        if (Array.isArray(this.elementOverrides)) {
            data["elementOverrides"] = [];
            for (let item of this.elementOverrides)
                data["elementOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elementsByContentVersions)) {
            data["elementsByContentVersions"] = [];
            for (let item of this.elementsByContentVersions)
                data["elementsByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.expressionByParameterElementAndContentVersions)) {
            data["expressionByParameterElementAndContentVersions"] = [];
            for (let item of this.expressionByParameterElementAndContentVersions)
                data["expressionByParameterElementAndContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    elementTypeId: number;
    elementType?: ElementTypeDto;
    elementOverrides?: ElementOverrideDto[] | undefined;
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;
}

export class ElementOverrideDto implements IElementOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name!: string;
    elementId?: number;
    element?: ElementDto;
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    explanation?: string | undefined;
    iconPath?: string | undefined;
    nlSfbCode?: string | undefined;
    isRequired?: boolean;

    constructor(data?: IElementOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.elementId = _data["elementId"];
            this.element = _data["element"] ? ElementDto.fromJS(_data["element"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            this.explanation = _data["explanation"];
            this.iconPath = _data["iconPath"];
            this.nlSfbCode = _data["nlSfbCode"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): ElementOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["elementId"] = this.elementId;
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        data["explanation"] = this.explanation;
        data["iconPath"] = this.iconPath;
        data["nlSfbCode"] = this.nlSfbCode;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IElementOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name: string;
    elementId?: number;
    element?: ElementDto;
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    explanation?: string | undefined;
    iconPath?: string | undefined;
    nlSfbCode?: string | undefined;
    isRequired?: boolean;
}

export class ElementTypeDto implements IElementTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value!: string;
    isRoot?: boolean;
    referencedParents?: ElementTypeSelfReferenceDto[] | undefined;

    constructor(data?: IElementTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.isRoot = _data["isRoot"];
            if (Array.isArray(_data["referencedParents"])) {
                this.referencedParents = [] as any;
                for (let item of _data["referencedParents"])
                    this.referencedParents!.push(ElementTypeSelfReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["isRoot"] = this.isRoot;
        if (Array.isArray(this.referencedParents)) {
            data["referencedParents"] = [];
            for (let item of this.referencedParents)
                data["referencedParents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value: string;
    isRoot?: boolean;
    referencedParents?: ElementTypeSelfReferenceDto[] | undefined;
}

export class ElementTypeSelfReferenceDto implements IElementTypeSelfReferenceDto {
    parentElementId!: number;
    parentElementType?: ElementTypeDto;
    childElementTypeId!: number;
    childElementType?: ElementTypeDto;

    constructor(data?: IElementTypeSelfReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentElementId = _data["parentElementId"];
            this.parentElementType = _data["parentElementType"] ? ElementTypeDto.fromJS(_data["parentElementType"]) : undefined as any;
            this.childElementTypeId = _data["childElementTypeId"];
            this.childElementType = _data["childElementType"] ? ElementTypeDto.fromJS(_data["childElementType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ElementTypeSelfReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypeSelfReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentElementId"] = this.parentElementId;
        data["parentElementType"] = this.parentElementType ? this.parentElementType.toJSON() : undefined as any;
        data["childElementTypeId"] = this.childElementTypeId;
        data["childElementType"] = this.childElementType ? this.childElementType.toJSON() : undefined as any;
        return data;
    }
}

export interface IElementTypeSelfReferenceDto {
    parentElementId: number;
    parentElementType?: ElementTypeDto;
    childElementTypeId: number;
    childElementType?: ElementTypeDto;
}

export class DependentDto implements IDependentDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key!: string;
    parameterOverrideId!: number;
    parameterOverride?: ParameterOverrideDto;
    parameterOptionId?: number | undefined;
    parameterOption?: ParameterOptionDto;
    defaultValue?: string | undefined;
    inputTypeId!: number;
    inputType?: InputTypeDto;
    dataTypeId!: number;
    dependentParameterId!: number;
    dependentParameter?: ParameterDto;

    constructor(data?: IDependentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.parameterOverrideId = _data["parameterOverrideId"];
            this.parameterOverride = _data["parameterOverride"] ? ParameterOverrideDto.fromJS(_data["parameterOverride"]) : undefined as any;
            this.parameterOptionId = _data["parameterOptionId"];
            this.parameterOption = _data["parameterOption"] ? ParameterOptionDto.fromJS(_data["parameterOption"]) : undefined as any;
            this.defaultValue = _data["defaultValue"];
            this.inputTypeId = _data["inputTypeId"];
            this.inputType = _data["inputType"] ? InputTypeDto.fromJS(_data["inputType"]) : undefined as any;
            this.dataTypeId = _data["dataTypeId"];
            this.dependentParameterId = _data["dependentParameterId"];
            this.dependentParameter = _data["dependentParameter"] ? ParameterDto.fromJS(_data["dependentParameter"]) : undefined as any;
        }
    }

    static fromJS(data: any): DependentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parameterOverrideId"] = this.parameterOverrideId;
        data["parameterOverride"] = this.parameterOverride ? this.parameterOverride.toJSON() : undefined as any;
        data["parameterOptionId"] = this.parameterOptionId;
        data["parameterOption"] = this.parameterOption ? this.parameterOption.toJSON() : undefined as any;
        data["defaultValue"] = this.defaultValue;
        data["inputTypeId"] = this.inputTypeId;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["dataTypeId"] = this.dataTypeId;
        data["dependentParameterId"] = this.dependentParameterId;
        data["dependentParameter"] = this.dependentParameter ? this.dependentParameter.toJSON() : undefined as any;
        return data;
    }
}

export interface IDependentDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key: string;
    parameterOverrideId: number;
    parameterOverride?: ParameterOverrideDto;
    parameterOptionId?: number | undefined;
    parameterOption?: ParameterOptionDto;
    defaultValue?: string | undefined;
    inputTypeId: number;
    inputType?: InputTypeDto;
    dataTypeId: number;
    dependentParameterId: number;
    dependentParameter?: ParameterDto;
}

export class InputTypeDto implements IInputTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value?: string | undefined;

    constructor(data?: IInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IInputTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value?: string | undefined;
}

export class ParameterByElementByContentVersionDto implements IParameterByElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    order?: number;
    parameterId!: number;
    parameter?: ParameterDto;
    elementByContentVersionId!: number;
    elementByContentVersion?: ElementByContentVersionDto;

    constructor(data?: IParameterByElementByContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.order = _data["order"];
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.elementByContentVersionId = _data["elementByContentVersionId"];
            this.elementByContentVersion = _data["elementByContentVersion"] ? ElementByContentVersionDto.fromJS(_data["elementByContentVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParameterByElementByContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterByElementByContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["order"] = this.order;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["elementByContentVersionId"] = this.elementByContentVersionId;
        data["elementByContentVersion"] = this.elementByContentVersion ? this.elementByContentVersion.toJSON() : undefined as any;
        return data;
    }
}

export interface IParameterByElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    order?: number;
    parameterId: number;
    parameter?: ParameterDto;
    elementByContentVersionId: number;
    elementByContentVersion?: ElementByContentVersionDto;
}

export class ParameterDto implements IParameterDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    parameterTypeId?: number;
    key?: string | undefined;
    dataMemberId?: number | undefined;
    dataMember?: DataMemberDto;
    parameterOverrides?: ParameterOverrideDto[] | undefined;
    dependentOn?: DependentDto[] | undefined;

    constructor(data?: IParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.parameterTypeId = _data["parameterTypeId"];
            this.key = _data["key"];
            this.dataMemberId = _data["dataMemberId"];
            this.dataMember = _data["dataMember"] ? DataMemberDto.fromJS(_data["dataMember"]) : undefined as any;
            if (Array.isArray(_data["parameterOverrides"])) {
                this.parameterOverrides = [] as any;
                for (let item of _data["parameterOverrides"])
                    this.parameterOverrides!.push(ParameterOverrideDto.fromJS(item));
            }
            if (Array.isArray(_data["dependentOn"])) {
                this.dependentOn = [] as any;
                for (let item of _data["dependentOn"])
                    this.dependentOn!.push(DependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["parameterTypeId"] = this.parameterTypeId;
        data["key"] = this.key;
        data["dataMemberId"] = this.dataMemberId;
        data["dataMember"] = this.dataMember ? this.dataMember.toJSON() : undefined as any;
        if (Array.isArray(this.parameterOverrides)) {
            data["parameterOverrides"] = [];
            for (let item of this.parameterOverrides)
                data["parameterOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dependentOn)) {
            data["dependentOn"] = [];
            for (let item of this.dependentOn)
                data["dependentOn"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParameterDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    parameterTypeId?: number;
    key?: string | undefined;
    dataMemberId?: number | undefined;
    dataMember?: DataMemberDto;
    parameterOverrides?: ParameterOverrideDto[] | undefined;
    dependentOn?: DependentDto[] | undefined;
}

export class ParameterOptionDto implements IParameterOptionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    key?: string | undefined;
    order?: number;
    parameterOverrideId?: number;
    enumId?: number;
    parameterOverride?: ParameterOverrideDto;
    dependents?: DependentDto[] | undefined;

    constructor(data?: IParameterOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.order = _data["order"];
            this.parameterOverrideId = _data["parameterOverrideId"];
            this.enumId = _data["enumId"];
            this.parameterOverride = _data["parameterOverride"] ? ParameterOverrideDto.fromJS(_data["parameterOverride"]) : undefined as any;
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(DependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["order"] = this.order;
        data["parameterOverrideId"] = this.parameterOverrideId;
        data["enumId"] = this.enumId;
        data["parameterOverride"] = this.parameterOverride ? this.parameterOverride.toJSON() : undefined as any;
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParameterOptionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    name?: string | undefined;
    key?: string | undefined;
    order?: number;
    parameterOverrideId?: number;
    enumId?: number;
    parameterOverride?: ParameterOverrideDto;
    dependents?: DependentDto[] | undefined;
}

export class ParameterOverrideDto implements IParameterOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    parameterId?: number;
    parameter?: ParameterDto;
    contentVersionId!: number;
    name!: string;
    description?: string | undefined;
    label?: string | undefined;
    dependencyLogic?: string | undefined;
    iconPath?: string | undefined;
    unitId?: number | undefined;
    unit?: UnitDto;
    inputTypeId!: number;
    inputType?: InputTypeDto;
    templateOptionId?: number;
    templateOptions?: TemplateOptionsDto;
    parameterOptions?: ParameterOptionDto[] | undefined;
    dependents?: DependentDto[] | undefined;

    constructor(data?: IParameterOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.label = _data["label"];
            this.dependencyLogic = _data["dependencyLogic"];
            this.iconPath = _data["iconPath"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : undefined as any;
            this.inputTypeId = _data["inputTypeId"];
            this.inputType = _data["inputType"] ? InputTypeDto.fromJS(_data["inputType"]) : undefined as any;
            this.templateOptionId = _data["templateOptionId"];
            this.templateOptions = _data["templateOptions"] ? TemplateOptionsDto.fromJS(_data["templateOptions"]) : undefined as any;
            if (Array.isArray(_data["parameterOptions"])) {
                this.parameterOptions = [] as any;
                for (let item of _data["parameterOptions"])
                    this.parameterOptions!.push(ParameterOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(DependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["label"] = this.label;
        data["dependencyLogic"] = this.dependencyLogic;
        data["iconPath"] = this.iconPath;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["inputTypeId"] = this.inputTypeId;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["templateOptionId"] = this.templateOptionId;
        data["templateOptions"] = this.templateOptions ? this.templateOptions.toJSON() : undefined as any;
        if (Array.isArray(this.parameterOptions)) {
            data["parameterOptions"] = [];
            for (let item of this.parameterOptions)
                data["parameterOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParameterOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    parameterId?: number;
    parameter?: ParameterDto;
    contentVersionId: number;
    name: string;
    description?: string | undefined;
    label?: string | undefined;
    dependencyLogic?: string | undefined;
    iconPath?: string | undefined;
    unitId?: number | undefined;
    unit?: UnitDto;
    inputTypeId: number;
    inputType?: InputTypeDto;
    templateOptionId?: number;
    templateOptions?: TemplateOptionsDto;
    parameterOptions?: ParameterOptionDto[] | undefined;
    dependents?: DependentDto[] | undefined;
}

export class EditSessionDto implements IEditSessionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    userId!: number;
    user?: UserDto;
    editSessionTypeId!: number;
    editSessionType?: EditSessionTypeDto;
    sessionDate?: Date;

    constructor(data?: IEditSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.editSessionTypeId = _data["editSessionTypeId"];
            this.editSessionType = _data["editSessionType"] ? EditSessionTypeDto.fromJS(_data["editSessionType"]) : undefined as any;
            this.sessionDate = _data["sessionDate"] ? new Date(_data["sessionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EditSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["editSessionTypeId"] = this.editSessionTypeId;
        data["editSessionType"] = this.editSessionType ? this.editSessionType.toJSON() : undefined as any;
        data["sessionDate"] = this.sessionDate ? this.sessionDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IEditSessionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    userId: number;
    user?: UserDto;
    editSessionTypeId: number;
    editSessionType?: EditSessionTypeDto;
    sessionDate?: Date;
}

export class EditSessionTypeDto implements IEditSessionTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value!: string;
    editSessions?: EditSessionDto[] | undefined;

    constructor(data?: IEditSessionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            if (Array.isArray(_data["editSessions"])) {
                this.editSessions = [] as any;
                for (let item of _data["editSessions"])
                    this.editSessions!.push(EditSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditSessionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSessionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        if (Array.isArray(this.editSessions)) {
            data["editSessions"] = [];
            for (let item of this.editSessions)
                data["editSessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEditSessionTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value: string;
    editSessions?: EditSessionDto[] | undefined;
}

export class StatusDto implements IStatusDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value!: string;

    constructor(data?: IStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatusDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    value: string;
}

export class UnitDto implements IUnitDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUnitDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    value?: string | undefined;
}

export class UserDto implements IUserDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    gprGebruikersId!: number;
    organizationId!: number;
    organization?: OrganizationDto;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.gprGebruikersId = _data["gprGebruikersId"];
            this.organizationId = _data["organizationId"];
            this.organization = _data["organization"] ? OrganizationDto.fromJS(_data["organization"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["gprGebruikersId"] = this.gprGebruikersId;
        data["organizationId"] = this.organizationId;
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    key?: string | undefined;
    gprGebruikersId: number;
    organizationId: number;
    organization?: OrganizationDto;
}

export enum EditSessionTypeEnum {
    AssessmentModel = 1,
    ExpressionModel = 3,
    ProjectModel = 2,
}

export enum ModelTypeEnum {
    AssessmentEntity = 1,
    Element = 2,
    Parameter = 3,
}

export enum ParameterInputTypeEnum {
    Checkbox = 4,
    Input = 1,
    Radio = 5,
    Select = 3,
    Textarea = 2,
}

export enum ProjectTypeEnum {
    WE_AMP_Api = 1,
}

export enum StatusEnum {
    Concept = 1,
    Published = 3,
    Test = 2,
}

export class MpgPerPhaseDto implements IMpgPerPhaseDto {
    code?: string | undefined;
    id?: number;
    mpg?: number;

    constructor(data?: IMpgPerPhaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
            this.mpg = _data["mpg"];
        }
    }

    static fromJS(data: any): MpgPerPhaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MpgPerPhaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["mpg"] = this.mpg;
        return data;
    }
}

export interface IMpgPerPhaseDto {
    code?: string | undefined;
    id?: number;
    mpg?: number;
}

export enum ApiVersionEnum {
    TestVersion = 0,
    V1_1 = 2,
    ValidationVersion = 1,
}

export enum AssessmentEntityLabelEnum {
    Geen = 0,
    EU_Taxonomy = 1,
}

export enum AssessmentEntitySubTypeEnum {
    CO2 = 13,
    Eigen_Invoer = 6,
    Energie = 2,
    Input_Points = 15,
    MPG = 9,
    Percentages = 7,
    Proces = 3,
    Radio = 4,
    Standard = 1,
    Thema_Score = 14,
    Vink = 5,
    Vink_Percentage = 8,
}

export enum AssessmentEntityTypeEnum {
    Cluster = 3,
    Fork = 4,
    ForkOption = 5,
    Measure = 7,
    MeasureGroup = 6,
    SubTheme = 2,
    Theme = 1,
}

export enum BuildingUseFunctionEnum {
    Bijeenkomstfunctie = 2,
    Celfunctie = 3,
    Combinatiegebouw = 14,
    Industriefunctie = 5,
    Kantoorfunctie = 6,
    Logiesfunctie = 7,
    Onderwijsfunctie = 8,
    OverigeGebruiksfunctie = 11,
    Sportfunctie = 9,
    Winkelfunctie = 10,
    WoonfunctieEengezins = 1,
    WoonfunctieMeergezins = 13,
    Woonzorggebouw = 4,
    Zwembaden = 12,
}

export enum ConnectionProjectEnum {
    WE_GPR_Connections = 0,
    _WE_GPR_Connections_Common = 0,
    _WE_GPR_Connections_Models = 0,
}

export enum DataTypeEnum {
    Boolean = 1,
    Double = 4,
    Integer = 2,
    String = 3,
}

export enum AssessmentStrategyEnum {
    A1 = 1,
    A2 = 2,
    P = 100,
}

export enum ElementTypeEnum {
    Composite = 2,
    MainCharacteristic = 4,
    Parameter = 5,
    Root = 1,
    Single = 3,
}

export enum ExtraIndicatorEnum {
    CSRD_rapportage = 3,
    Het_Nieuwe_Normaal = 2,
    QCI = 1,
}

export enum InputSubTypeEnum {
    Boolean = 6,
    Decimal = 3,
    Email = 4,
    Number = 2,
    Range = 5,
    Text = 1,
}

export enum JsonDataTypeEnum {
    ExistingBuildingAfterAmpInput_ = 4,
    ExistingBuildingAmpInput = 6,
    ExistingBuildingCurrentAmpInput = 3,
    Extra_Indicators_ = 5,
    NewBuildingAmpInput = 2,
    ProductInputByNmdElement = 1,
}

export enum MailContentStringEnum {
    Beste_gebruiker_ = 1,
    Geachte_heer_ = 2,
    Geachte_mevrouw_ = 3,
    GPR_Software = 5,
    Met_vriendelijke_groet___br_____br____Het_GPR_Software_Team = 4,
    Noreply_gprlogin_nl = 6,
}

export enum ModuleEnum {
    GWP = 3,
    HNN = 3,
    Normaal = 4,
    Sportgebouwen = 4,
    Zwembaden = 4,
}

export enum ParameterTypeEnum {
    Aandeel_hernieuwbaar__EP3_ = 17,
    Aantal = 3,
    Aantal_Eenheden = 31,
    Aardgas = 26,
    Adaptief_vermogen = 18,
    As_designed = 23,
    Bereken_CSRD = 21,
    Bereken_HNN = 22,
    Bereken_QCI = 10,
    Bereken_WLC = 24,
    Bouw_objectnummer = 30,
    Bouwjaar = 7,
    Bouwmateriaal = 2,
    Bruto_Vloeroppervlak__BVO_ = 5,
    Compactheid = 38,
    Correctiefactor = 42,
    Electriciteit_teruggeleverd = 29,
    Elektriciteitsvoorziening = 25,
    Energiebehoefte__EP1_ = 16,
    Functies = 32,
    Functies_na_ingreep = 33,
    Gebouwlevensduur = 6,
    Gebouwtype = 11,
    Gebruiksfunctie = 4,
    Gebruiksoppervlak__GBO_ = 9,
    Gemeenschappelijke_ruimte = 34,
    Gemeenschappelijke_ruimte_na_ingreep = 35,
    Geveloppervlakte = 36,
    Geveloppervlakte_na_ingreep = 37,
    Gezonde_materialen__aantal_ = 19,
    Jaar_van_oplevering = 12,
    Korte_teeltijd__landbouwgrond = 14,
    Mpg_ambitie = 39,
    Mpg_Limit = 40,
    Mpg_Limit_Eased = 41,
    Normaal = 1,
    Omgang_restmaterialen_bouw = 20,
    Primair_fossiel_energiegebruik__EP2_ = 13,
    Uit_duurzame_bosbouw = 15,
    Verwacht_Sloopjaar = 8,
    Warmte = 28,
    Warmtetype = 27,
}

export enum UserRoleTypeEnum {
    Administrator = 1,
    Applicatiebeheerder = 4,
    Gastgebruiker = 6,
    Gebruiker = 3,
    Licentiebeheerder = 2,
    Projectbeheerder = 7,
}

export class AuthContext implements IAuthContext {
    claims?: BaseClaim[] | undefined;

    constructor(data?: IAuthContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(BaseClaim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthContext {
        data = typeof data === 'object' ? data : {};
        let result = new AuthContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAuthContext {
    claims?: BaseClaim[] | undefined;
}

export class BaseClaim implements IBaseClaim {
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: IBaseClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BaseClaim {
        data = typeof data === 'object' ? data : {};
        let result = new BaseClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IBaseClaim {
    type?: string | undefined;
    value?: string | undefined;
}

export enum CalculationCoreVersionEnum {
    _1_Calculation_rule_changes_for_validating_ProfielMilieueffectVersies_zero_values_To_prevent_zero_mki_results_in_precalculations__2_In_Update_console_app_validation_if_any_of_child_entity_is_invalid_then_invalidate_whole_product_chain_data_ = 4,
    Calculate_CSC_based_on_product_lifespan___building_lifespan = 9,
    Calculate_CSRD_category_11_module_B6_to_kg_CO2_instead_of_to_kWh = 8,
    Calculation_rule_changes_for_HFactor_and_Phase_B_and_D = 2,
    Calculation_rule_changes_for_Product_Attribute_Versies_deactivation__multiple_elementId_check_and_Productlifespan = 3,
    Corrected_dimension_two_not_being_scaled_if_dimension_one_was_equal_to_the_default_dimension = 5,
    Exclude_module_B5_from_precalculations__needs_EDS_schema___Start_calculating_with_FB_in__also_named_Fpr_ini_or_PhaseBFrequency___Start_precalculating_A2__based_on_EDS_schema___added_detailed_calculation_for_single_products_for_EB__NB_and_A1__A2 = 6,
    First_DB_release = 1,
    Include_3rd_condition_for_Existing_building_Current_and_After_Keep = 7,
    Materialization_is_included_in_the_new_energy_cards_used_in_the_MPG_should_not_be_included_in_the_WLC = 10,
    Test_release = 0,
}

export enum EnergyTypeEnum {
    ElectricityGrey = 1,
    ElectricityMix = 2,
    ElectricityRenewable = 3,
    ElectricityRenewableBiomass = 4,
    ElectricityRenewableSolar = 7,
    ElectricityRenewableWindLand = 6,
    ElectricityRenewableWindSea = 5,
    Gas = 8,
    HeatHighGrey = 9,
    HeatHighRenewable = 10,
    HeatLowGrey = 11,
    HeatLowRenewable = 12,
    Materialisatie_elektriciteitsnet_zonder_opwekkingsmiddelen__externe_levering__bij_consument__per_kWh = 100,
    No = 13,
}

export enum EntityTypeEnum {
    ChildElement = 2,
    Other = 4,
    ParentElement = 1,
    Product = 3,
}

export enum NmdDataActionTypeEnum {
    Add = 1,
    CSRD_calculation_Rule = 21,
    Deactivate = 2,
    HNN_calculation_Rule = 22,
    MPG_Calculation_Rule = 11,
    New_NMD_data_structure = 13,
    QCi_calculation_Rule = 23,
    Scaling_Change = 12,
    Update = 3,
}

export enum NmdJsonDataEntityTypeEnum {
    NMD_BouwwerkFuncties_Versies = 15,
    NMD_Eenheid_Versies = 7,
    NMD_Element_Element_Versies = 11,
    NMD_Element_Versies = 10,
    NMD_Fasen_Versies = 12,
    NMD_Milieucategorie_Versies = 9,
    NMD_Product_Element_ProfielSet_Versies = 3,
    NMD_Product_Product_Versies = 2,
    NMD_Product_Versies = 1,
    NMD_Profiel_Versies = 5,
    NMD_ProfielMilieueffect_Versies = 6,
    NMD_ProfielSets_Versies = 4,
    NMD_Schalingsformules_Versies = 13,
    NMD_ToepassingsGebieden_Versies = 14,
    NMD_Type_Kaart_Versies = 8,
}

export enum NmdJsonDataPropertyTypeEnum {
    Bim_code = 10,
    CUAS_ID = 1,
    EenheidID_SchalingsMaat = 16,
    Element_Attribuut_ID = 4,
    IS_Indicator = 6,
    IsOH_ProfielSet = 17,
    NMD23_SchaalFactor = 18,
    PME_ID = 13,
    Product_ProductID = 12,
    Rc_waarde = 9,
    SchalingsMaat_X1 = 14,
    SchalingsMaat_X2 = 15,
    Toelichting_eindgebruiker = 7,
    Toelichting_HelpTekst = 5,
    U_waarde = 8,
}

export enum ScaleEquationsEnum {
    Exponential = 4,
    Linear = 1,
    LinearV4 = 7,
    Logarithmic = 3,
    Mass_through_table = 5,
    None = 0,
    NonlinearV4 = 6,
    Power = 2,
}

export enum ProductPrecalculationTypeEnum {
    Normal = 1,
    Reuse = 2,
}

export enum NmdProductSortKeyEnum {
    Category = 5,
    GwpPerUnit = 4,
    Lifespan = 7,
    MkiPerUnit = 2,
    Name = 1,
    NlSfb = 6,
    PpiPerUnit = 3,
}

export enum ResultCodeEnum {
    An_unknown_error_occured = 520,
    Code_not_implemented = 501,
    Internal_code_error = 500,
    Model_state_was_invalid = 400,
    Multiple_choices = 300,
    No_Content = 204,
    Successfull_result = 200,
    Unauthorized = 401,
    Value_was_not_found = 404,
}

export class SortFilterDto implements ISortFilterDto {
    key?: number;
    orderIsDescending?: boolean;

    constructor(data?: ISortFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.orderIsDescending = _data["orderIsDescending"];
        }
    }

    static fromJS(data: any): SortFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SortFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["orderIsDescending"] = this.orderIsDescending;
        return data;
    }
}

export interface ISortFilterDto {
    key?: number;
    orderIsDescending?: boolean;
}

export enum ClassificationSystemEnum {
    Energie = 1,
    Nl_SfB = 2,
    Processen = 3,
    RAW = 4,
}

export enum CategoryEnum {
    Category1 = 1,
    Category2 = 2,
    Category3 = 3,
    Category3a = 4,
}

export enum InvalidationEnum {
    Declaration_ActiveFrom_date_is_greater_than_or_equal_to_ActiveUntil = 4,
    Declaration_has_all_profile_amount_less_than_or_equal_to_0 = 16,
    Declaration_has_no_calculable_profile_at_all_for_A1 = 22,
    Declaration_has_no_calculable_profile_at_all_for_A2 = 23,
    Declaration_has_no_component_group = 24,
    Declaration_has_no_precalculation_s_ = 25,
    Declaration_has_no_profiles = 3,
    Declaration_has_profiles_score_count_mismatched_for_A1 = 18,
    Declaration_has_profiles_score_count_mismatched_for_A2 = 19,
    Declaration_having_all_profile_score_value_0_for_A1 = 20,
    Declaration_having_all_profile_score_value_0_for_A2 = 21,
    Declaration_lifespan_is_less_than_or_equal_to_0 = 1,
    Declaration_Something_went_wrong_in_mapping_declaration_properties = 26,
    Declaration_unit_Id_is_null = 2,
    Declaration_FieldOfApplication_mismatches_with_not_allowed_Element_ClassificationSystem = 15,
    Dimension_scaling_inspected_value_is_greater_than_max_value = 9,
    Dimension_scaling_inspected_value_is_less_than_min_value = 8,
    Dimension_scaling_min_value_is_greater_than_max_value = 7,
    Dimension_unit_Id_is_null = 17,
    Profile_all_scores_are_zero_for_assessment_strategy_A1 = 13,
    Profile_all_scores_are_zero_for_assessment_strategy_A2 = 14,
    Profile_amount_is_less_than_or_equal_to_0 = 5,
    Profile_has_no_scores = 6,
    Profile_scores_missing_for_A1 = 11,
    Profile_scores_missing_for_A2 = 12,
    Score_values_are_all_zero_for_Impact_Indicator_of_A1 = 10,
    Score_values_are_all_zero_for_Impact_Indicator_of_A2 = 27,
}

export enum PrecalculationTypeEnum {
    Normal = 1,
    Reuse = 2,
}

export enum SeverityEnum {
    Error = 3,
    Information = 1,
    Warning = 2,
}

export enum StatusEnum2 {
    Invalid = 3,
    Partial_valid = 2,
    Precalculation_processing_is_pending = 0,
    Valid = 1,
}

export enum EnvironmentEffectsEnum {
    Abiotic = 1,
    Acidification = 7,
    ClimateChange = 4,
    EcoToxicFreshWater = 10,
    Ecotoxiciteit_aquatisch_zoetwater = 54,
    EcoToxicSaltWater = 12,
    EcoToxicSoil = 14,
    Eutrophication = 8,
    Fijnstofvorming = 52,
    Fossile = 2,
    Grondstofuitputting_energiedragers = 50,
    Grondstofuitputting_metalen_en_mineralen = 49,
    Humane_toxiciteit_kankerverwekkend_effect = 55,
    Humane_toxiciteit_nietKankerverwekkend_effect = 56,
    HumanToxic = 9,
    Klimaatverandering_biogeen = 41,
    Klimaatverandering_fossiel = 40,
    Klimaatverandering_landgebruik_en_landgebruiksveranderingen = 42,
    Landgebruik = 57,
    OzoneLayer = 5,
    Ozonlaagaantasting = 58,
    Smog = 6,
    Smogvorming = 48,
    Straling = 53,
    Vermesting_land = 47,
    Vermesting_zoetwater = 45,
    Vermesting_zoutwater = 46,
    Verzuring = 44,
    Waterschaarste = 51,
}

export enum ConnectionAccessibilityEnum {
    Niet_toegankelijk__onherstelbare_schade_aan_het_product_of_omliggende_producten = 5,
    Toegankelijk_met_extra_handelingen_die_geen_schade_veroorzaken = 2,
    Toegankelijk_met_extra_handelingen_met_gedeeltelijk_herstelbare_schade = 4,
    Toegankelijk_met_extra_handelingen_met_volledig_herstelbare_schade = 3,
    Vrij_toegankelijk_zonder_extra_handelingen = 1,
}

export enum ConnectionTypeEnum {
    Directe_integrale_verbinding = 3,
    Droge_verbinding = 1,
    Harde_chemische_verbinding = 5,
    Verbinding_met_toegevoegde_elementen = 2,
    Zachte_chemische_verbinding = 4,
}

export enum EdgeEnclosureEnum {
    Gesloten__volledige_belemmering_voor_het__tussentijds__uitnemen_van_producten_of_elementen = 3,
    Open__geen_belemmering_voor_het__tussentijds__uitnemen_van_producten_of_elementen = 1,
    Overlapping__gedeeltelijke_belemmering_voor_het__tussentijds__uitnemen_van_producten_of_elementen = 2,
}

export enum PiercingEnum {
    Geen_doorkruisingen__modulaire_zonering_van_producten_of_elementen_uit_verschillende_lagen = 1,
    Incidentele_doorkruisingen_van_producten_of_elementen_uit_verschillende_lagen = 2,
    Volledige_integratie_van_producten_of_elementen_uit_verschillende_lagen = 3,
}

export enum FieldOfApplicationEnum {
    B_U = 1,
    B_U_en_GWW = 2,
    GWW = 3,
    Proces = 4,
}

export enum IndicatorsEnum {
    Energy = 18,
    ExportedEnergy = 28,
    HazardousWaste = 21,
    MaterialForEnergy = 27,
    MaterialRecycling = 26,
    MaterialReuse = 25,
    NonHazardousWaste = 20,
    NonRenewableEnergy = 17,
    RenewableEnergy = 16,
    SecondaryMaterialUse = 22,
    SecondaryNonRenewableEnergy = 24,
    SecondaryRenewableEnergy = 23,
    WaterConsumption = 19,
}

export enum NmdCalcCoreProjectEnum {
    SbkUpdateConsole = 0,
    PrefetchConsole = 0,
    NmdCalculationCore = 0,
    PopulateManyToManyTable = 0,
    ProductPreCalculationApplication = 0,
    PrecalculationValidatorApplication = 0,
    WE_Gpr_Nmd_SbkUpdateConsole = 0,
    WE_Gpr_Nmd_PrefetchConsole = 0,
    WE_Gpr_Nmd_BLL = 0,
    WE_Gpr_Nmd_Helpers = 0,
    WE_Gpr_Nmd_Mapper = 0,
    WE_Gpr_MaterialCalculationCore_Equations = 0,
    WE_Gpr_MaterialCalculationCore_BLL = 0,
    WE_Gpr_MaterialCalculationCore_Constants = 0,
    WE_Gpr_MaterialCalculationCore_Dal = 0,
    WE_Gpr_Nmd_Service = 0,
    WE_Gpr_Nmd_UpdateLogic = 0,
    WE_Gpr_MaterialsCalculationCore_PopulateManyToManyTable = 0,
    WE_Gpr_Nmd_PrecalculateProducts_Cons = 0,
    WE_Gpr_Nmd_UpdateNmdEntitiesNames_Cons = 0,
    WE_Gpr_Nmd_PrecalculationValidator_Cons = 0,
}

export enum PhaseOrModuleEnum {
    A_Construction_phase = 2,
    A_Production_phase = 1,
    A1ToA3 = 11,
    A4 = 12,
    A5 = 13,
    B_Use_phase = 3,
    B1 = 14,
    B2 = 15,
    B3 = 16,
    B4 = 17,
    B5 = 18,
    C_Waste_phase = 4,
    C1 = 19,
    C2 = 20,
    C3 = 21,
    C4 = 22,
    D = 23,
    D_Beyond_building_lifecycle = 5,
}

export enum SubPhaseEnum {
    Afvalverwerking = 11,
    Afvalverwijdering = 12,
    Baten_en_lasten_voorbij_de_systeemgrenzen = 13,
    Bouwfase = 3,
    Deconstructie___sloop = 9,
    Gebruik_van_product = 4,
    Onderhoud = 5,
    Opknappen = 8,
    Productie = 1,
    Reparatie = 6,
    Transport___afval = 10,
    Transport___bouwplaats = 2,
    Vervangen = 7,
}

export class SubscriptionDto implements ISubscriptionDto {
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    licenseType?: string | undefined;
    totalBundle?: number | undefined;
    buildingsUsed?: number | undefined;
    buildingsLeft?: number | undefined;
    buildingsOutsideBundle?: number | undefined;

    constructor(data?: ISubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.licenseType = _data["licenseType"];
            this.totalBundle = _data["totalBundle"];
            this.buildingsUsed = _data["buildingsUsed"];
            this.buildingsLeft = _data["buildingsLeft"];
            this.buildingsOutsideBundle = _data["buildingsOutsideBundle"];
        }
    }

    static fromJS(data: any): SubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["licenseType"] = this.licenseType;
        data["totalBundle"] = this.totalBundle;
        data["buildingsUsed"] = this.buildingsUsed;
        data["buildingsLeft"] = this.buildingsLeft;
        data["buildingsOutsideBundle"] = this.buildingsOutsideBundle;
        return data;
    }
}

export interface ISubscriptionDto {
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    licenseType?: string | undefined;
    totalBundle?: number | undefined;
    buildingsUsed?: number | undefined;
    buildingsLeft?: number | undefined;
    buildingsOutsideBundle?: number | undefined;
}

export enum ActionEnum {
    RedirectToAction = 2,
    View = 1,
}

export enum IdpProjectEnum {
    WE_IdentityProvider = 0,
    WE_IdentityProvider_Common = 0,
    WE_GPR_LicentieBeheer_ApiClient = 0,
    WE_IdentityProvider_Logic = 0,
    WE_IdentityProvider_Web = 0,
    WE_IdentityProvider_TokenRevokationConsole = 0,
}

export enum MailContentTypeEnum {
    DataUpdated = 9,
    EmailConfirmation = 10,
    InviteNewLicenseManager = 5,
    InviteNewUser = 4,
    InviteNewUserOnLicense = 3,
    InviteRegisteredLicenseManager = 7,
    InviteRegisteredUser = 6,
    ResetPassword = 2,
    RolesUpdated = 11,
    Test = 80,
    UserRegistration = 1,
}

export enum MessageEnum {
    Bericht_succesvol_verzonden = 19,
    De_registratie_kon_niet_worden_voltooid__Controleer_of_het_eMailadres_waarmee_u_zich_registreert_overeenkomt_met_het_eMailadres_waarop_u_bent_uitgenodigd__Blijft_dit_probleem_zich_voordoen__neem_dan_contact_op_met_de_helpdesk = 9,
    Deze_gebruiker_is_al_toegevoegd_aan_de_licentie__U_kunt_eenzelfde_gebruiker_niet_meermaals_toevoegen = 41,
    Email_address_is_not_a_valid_emailAddress_according_RFC_2822 = 30,
    Email_adres_is_onbekend_ = 32,
    Er_is_een_softwareProbleem_opgetreden__de_communicatie_met_GPR_Licentiebeheer_is_mislukt__Neem_contact_op_met_de_helpdesk_ = 34,
    Er_is_een_softwareProbleem_opgetreden__Het_is_niet_gelukt_een_account_aan_te_maken__Neem_zo_snel_mogelijk_contact_op_met_de_helpdesk = 13,
    Er_is_een_softwareProbleem_opgetreden__U_heeft_al_een_account__Uw_uitnodiging_is_verwijderd_uit_het_systeem__Ga_naar_de_loginPagina_om_in_te_loggen_of_kies_wachtwoord_vergeten = 12,
    Er_is_ergens_iets_mis_gegaan_in_de_broncode_ = 500,
    Er_is_iets_mis_met_uw_link_naar_de_pagina_om_uw_email_te_bevestigen__Probeer_de_link_in_uw_eMail_opnieuw_te_openen__Mocht_het_probleem_blijven_bestaan__neem_dan_contact_op_met_de_helpdesk = 26,
    Er_is_iets_mis_met_uw_link_naar_de_pagina_om_uw_wachtwoord_te_wijzigen__Probeer_de_link_in_uw_eMail_opnieuw_te_openen__Mocht_het_probleem_blijven_bestaan__neem_dan_contact_op_met_de_helpdesk = 15,
    Er_is_iets_mis_met_uw_link_naar_de_registratiepagina__Mogelijk_is_de_registratielink_al_gebruikt_of_uw_uitnodiging_is_ouder_dan__InvitationExpiryDays__dagen_en_verlopen__Vraag_dan_om_een_nieuwe_uitnodiging__Mocht_het_probleem_blijven_bestaan__neem_dan_contact_op_met_de_helpdesk = 7,
    Er_zijn_geen_gebruikers_gevonden_ = 36,
    Er_zijn_geen_licenties_gevonden_ = 35,
    Er_zijn_minder_gebruikers_gevonden_in_IdentityProvider_dan_er_in_Licentiebeheer_toegevoegd_zijn__Neem_contact_op_met_de_helpdesk = 37,
    Failure_in_adding_claims_to_the_user = 39,
    Failure_in_deleting_claims_from_the_user = 38,
    Gebruiker_is_niet_gevonden = 33,
    Gebruiker_succesvol_uitgenodigd = 17,
    Gebruikerslijst_is_leeg = 42,
    Het_door_u_opgegeven_emailAdres_en_of_wachtwoord_is_niet_juist__Probeer_het_opnieuw_ = 1,
    Het_is_niet_gelukt_de_gebruiker_uit_te_nodigen = 18,
    Het_is_niet_gelukt_het_bericht_te_verzenden = 20,
    Het_maximaal_aantal_gebruikers_is_bereikt_voor_uw_licentie__Neem_contact_op_met_W_E_adviseurs_om_uw_licentie_te_verruimen = 40,
    Het_wijzigen_van_uw_gegevens_is_mislukt__De_software_heeft_geen_wijzigingen_gedetecteerd = 25,
    Het_wijzigen_van_uw_gegevens_is_mislukt__Er_heeft_te_vaak_het_verkeerde_wachtwoord_ingevoerd__u_bent_tijdelijk_geblokkeerd_ = 24,
    Het_wijzigen_van_uw_gegevens_is_mislukt__Er_is_iets_mis_gegaan_bij_het_valideren_van_het_wachtwoord_ = 23,
    Het_wijzigen_van_uw_gegevens_is_mislukt__Er_zit_een_fout_in_het_formulier_ = 22,
    Het_wijzigen_van_uw_gegevens_is_mislukt__Het_wijzigen_van_het_wachtwoord_is_mislukt__probeer_het_opnieuw_met_een_ander_wachtwoord_ = 29,
    Het_wijzigen_van_uw_gegevens_is_mislukt__Probeer_het_eMail_adres_opnieuw_te_wijzigen_op_de_gegevens_wijzigen_pagina = 27,
    Het_wijzigen_van_uw_gegevens_is_mislukt__U_heeft_een_verkeerd_wachtwoord_ingevuld_ = 21,
    The_login_was_successful__In_Development_Mode_there_is_no_redirect_to_GPR_Portaal_ = 5,
    U_bent_succesvol_ingelogd__maar_er_is_iets_mis_met_de_url_waar_u_vandaan_komt__Als_dit_probleem_zich_blijft_voordoen__neem_dan_contact_op_met_de_helpdesk__U_kunt_verder_gaan_met_de_volgende_link = 6,
    U_bent_succesvol_uitgelogd_bij_GPR_software = 4,
    U_bent_succesvol_uitgenodigd = 14,
    U_heeft_geen_licentie_bij_W_E_adviseurs__of_uw_licentie_is_verlopen__U_heeft_daarom_geen_toegang__meer__tot_onze_software_ = 3,
    U_heeft_uw_eMailadres_succesvol_gewijzigd__u_kunt_inloggen_met_uw_nieuwe_eMail = 28,
    U_heeft_uw_wachtwoord_succesvol_gewijzigd__u_kunt_inloggen = 16,
    U_heeft_zich_succesvol_geregistreerd__u_kunt_nu_inloggen = 8,
    UserId_not_found_in_the_User_claimsprincipal = 31,
    Uw_account_is_geblokkeerd__Waarschijnlijk_omdat_u_of_anderen_meerdere_malen_heeft_geprobeerd_in_te_loggen_met_een_onjuist_emailAdres_en_of_wachtwoord__Probeer_het_over_vijf_minuten_opnieuw_ = 2,
    Uw_uitnodiging_is_verlopen__Om_veiligheidsredenen_heeft_u__InvitationExpiryDays__dagen_om_uzelf_te_registreren__daarna_verloopt_de_uitnodiging__Registratie_is_niet_mogelijk__Vraag_een_nieuwe_uitnodiging_aan_ = 10,
    Uw_uitnodiging_is_verlopen__Om_veiligheidsredenen_heeft_u_drie_pogingen_om_uzelf_te_registreren__daarna_verloopt_de_uitnodiging__Registratie_is_niet_mogelijk__Vraag_een_nieuwe_uitnodiging_aan_ = 11,
}

export enum ResultCodeEnum2 {
    Code_not_implemented = 501,
    Conflict = 409,
    Internal_code_error = 500,
    Model_state_was_invalid = 400,
    Payment_Required = 402,
    Successfull_request = 204,
    Successfull_result = 200,
    Unauthorized = 401,
    Value_was_not_found = 404,
}

export enum SalutationEnum {
    Mannelijk = 2,
    Neutraal = 1,
    Vrouwelijk = 3,
}

export enum ViewModelTypeEnum {
    Account = 8,
    ContactConfirmation = 14,
    EmailConfirmation = 13,
    ForgotPassword = 4,
    ForgotPasswordConfirmation = 5,
    Home = 10,
    Login = 1,
    Manage = 9,
    ManageAccountConfirmation = 12,
    Redirect = 2,
    Register = 6,
    ResetPassword = 7,
    Start = 11,
    Warning = 3,
}

export class AddUserToLicenseDto implements IAddUserToLicenseDto {
    emailAddress?: string | undefined;
    licenseId?: number;
    isGuest?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    assignedRoles?: RoleDto[] | undefined;

    constructor(data?: IAddUserToLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.licenseId = _data["licenseId"];
            this.isGuest = _data["isGuest"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["assignedRoles"])) {
                this.assignedRoles = [] as any;
                for (let item of _data["assignedRoles"])
                    this.assignedRoles!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUserToLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["licenseId"] = this.licenseId;
        data["isGuest"] = this.isGuest;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.assignedRoles)) {
            data["assignedRoles"] = [];
            for (let item of this.assignedRoles)
                data["assignedRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddUserToLicenseDto {
    emailAddress?: string | undefined;
    licenseId?: number;
    isGuest?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    assignedRoles?: RoleDto[] | undefined;
}

export class AddUsersToLicenseResponseDto implements IAddUsersToLicenseResponseDto {
    totalUsersAdded?: number;
    newlyAddedEmail?: string[] | undefined;
    alreadyAddedEmails?: string[] | undefined;
    failedEmails?: string[] | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IAddUsersToLicenseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUsersAdded = _data["totalUsersAdded"];
            if (Array.isArray(_data["newlyAddedEmail"])) {
                this.newlyAddedEmail = [] as any;
                for (let item of _data["newlyAddedEmail"])
                    this.newlyAddedEmail!.push(item);
            }
            if (Array.isArray(_data["alreadyAddedEmails"])) {
                this.alreadyAddedEmails = [] as any;
                for (let item of _data["alreadyAddedEmails"])
                    this.alreadyAddedEmails!.push(item);
            }
            if (Array.isArray(_data["failedEmails"])) {
                this.failedEmails = [] as any;
                for (let item of _data["failedEmails"])
                    this.failedEmails!.push(item);
            }
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): AddUsersToLicenseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersToLicenseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUsersAdded"] = this.totalUsersAdded;
        if (Array.isArray(this.newlyAddedEmail)) {
            data["newlyAddedEmail"] = [];
            for (let item of this.newlyAddedEmail)
                data["newlyAddedEmail"].push(item);
        }
        if (Array.isArray(this.alreadyAddedEmails)) {
            data["alreadyAddedEmails"] = [];
            for (let item of this.alreadyAddedEmails)
                data["alreadyAddedEmails"].push(item);
        }
        if (Array.isArray(this.failedEmails)) {
            data["failedEmails"] = [];
            for (let item of this.failedEmails)
                data["failedEmails"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IAddUsersToLicenseResponseDto {
    totalUsersAdded?: number;
    newlyAddedEmail?: string[] | undefined;
    alreadyAddedEmails?: string[] | undefined;
    failedEmails?: string[] | undefined;
    errorMessage?: string | undefined;
}

export class ApplicationSummaryResponse implements IApplicationSummaryResponse {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IApplicationSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ApplicationSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplicationSummaryResponse {
    id?: number | undefined;
    name?: string | undefined;
}

export class LicenseManagementDto implements ILicenseManagementDto {
    licenses?: LicenseResponseDto[] | undefined;

    constructor(data?: ILicenseManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(LicenseResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseManagementDto {
    licenses?: LicenseResponseDto[] | undefined;
}

export class LicenseResponseDto implements ILicenseResponseDto {
    comments?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalSeats?: number | undefined;
    totalAvailableSeats?: number | undefined;
    status?: string | undefined;
    type?: string | undefined;
    unit?: string | undefined;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    organizationSummary?: OrganizationSummaryResponse;
    modulesSummary?: ModulesSummaryResponse[] | undefined;
    id?: number | undefined;
    name?: string | undefined;
    licenseCode?: string | undefined;
    applicationSummary?: ApplicationSummaryResponse;
    users?: UserOnLicenseInfoDto[] | undefined;
    roles?: RoleDto[] | undefined;

    constructor(data?: ILicenseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.totalSeats = _data["totalSeats"];
            this.totalAvailableSeats = _data["totalAvailableSeats"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.unit = _data["unit"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.organizationSummary = _data["organizationSummary"] ? OrganizationSummaryResponse.fromJS(_data["organizationSummary"]) : undefined as any;
            if (Array.isArray(_data["modulesSummary"])) {
                this.modulesSummary = [] as any;
                for (let item of _data["modulesSummary"])
                    this.modulesSummary!.push(ModulesSummaryResponse.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.licenseCode = _data["licenseCode"];
            this.applicationSummary = _data["applicationSummary"] ? ApplicationSummaryResponse.fromJS(_data["applicationSummary"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserOnLicenseInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["totalSeats"] = this.totalSeats;
        data["totalAvailableSeats"] = this.totalAvailableSeats;
        data["status"] = this.status;
        data["type"] = this.type;
        data["unit"] = this.unit;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["organizationSummary"] = this.organizationSummary ? this.organizationSummary.toJSON() : undefined as any;
        if (Array.isArray(this.modulesSummary)) {
            data["modulesSummary"] = [];
            for (let item of this.modulesSummary)
                data["modulesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["licenseCode"] = this.licenseCode;
        data["applicationSummary"] = this.applicationSummary ? this.applicationSummary.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILicenseResponseDto {
    comments?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalSeats?: number | undefined;
    totalAvailableSeats?: number | undefined;
    status?: string | undefined;
    type?: string | undefined;
    unit?: string | undefined;
    dateCreated?: Date | undefined;
    dateModified?: Date | undefined;
    organizationSummary?: OrganizationSummaryResponse;
    modulesSummary?: ModulesSummaryResponse[] | undefined;
    id?: number | undefined;
    name?: string | undefined;
    licenseCode?: string | undefined;
    applicationSummary?: ApplicationSummaryResponse;
    users?: UserOnLicenseInfoDto[] | undefined;
    roles?: RoleDto[] | undefined;
}

export class LicenseSummaryResponse implements ILicenseSummaryResponse {
    id?: number | undefined;
    name?: string | undefined;
    licenseCode?: string | undefined;
    applicationSummary?: ApplicationSummaryResponse;

    constructor(data?: ILicenseSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.licenseCode = _data["licenseCode"];
            this.applicationSummary = _data["applicationSummary"] ? ApplicationSummaryResponse.fromJS(_data["applicationSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): LicenseSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["licenseCode"] = this.licenseCode;
        data["applicationSummary"] = this.applicationSummary ? this.applicationSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface ILicenseSummaryResponse {
    id?: number | undefined;
    name?: string | undefined;
    licenseCode?: string | undefined;
    applicationSummary?: ApplicationSummaryResponse;
}

export class ModulesSummaryResponse implements IModulesSummaryResponse {
    id?: number | undefined;
    applicationId?: number | undefined;
    applicationSummary?: ApplicationSummaryResponse;
    name?: string | undefined;
    licencesSummary?: LicenseSummaryResponse[] | undefined;

    constructor(data?: IModulesSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.applicationSummary = _data["applicationSummary"] ? ApplicationSummaryResponse.fromJS(_data["applicationSummary"]) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["licencesSummary"])) {
                this.licencesSummary = [] as any;
                for (let item of _data["licencesSummary"])
                    this.licencesSummary!.push(LicenseSummaryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModulesSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModulesSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["applicationSummary"] = this.applicationSummary ? this.applicationSummary.toJSON() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.licencesSummary)) {
            data["licencesSummary"] = [];
            for (let item of this.licencesSummary)
                data["licencesSummary"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModulesSummaryResponse {
    id?: number | undefined;
    applicationId?: number | undefined;
    applicationSummary?: ApplicationSummaryResponse;
    name?: string | undefined;
    licencesSummary?: LicenseSummaryResponse[] | undefined;
}

export class OrganizationLicenseInfoDto implements IOrganizationLicenseInfoDto {
    licenseId?: number | undefined;
    licenseName?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    organisationCode?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IOrganizationLicenseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.licenseName = _data["licenseName"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.organisationCode = _data["organisationCode"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): OrganizationLicenseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationLicenseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["licenseName"] = this.licenseName;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["organisationCode"] = this.organisationCode;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IOrganizationLicenseInfoDto {
    licenseId?: number | undefined;
    licenseName?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    organisationCode?: string | undefined;
    fullName?: string | undefined;
}

export class OrganizationSummaryResponse implements IOrganizationSummaryResponse {
    id?: number | undefined;
    name?: string | undefined;
    organisationCode?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IOrganizationSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organisationCode = _data["organisationCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): OrganizationSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organisationCode"] = this.organisationCode;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IOrganizationSummaryResponse {
    id?: number | undefined;
    name?: string | undefined;
    organisationCode?: string | undefined;
    isActive?: boolean | undefined;
}

export class RoleDto implements IRoleDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IRoleDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class SendEmailAnnouncementDto implements ISendEmailAnnouncementDto {
    email?: string | undefined;
    application?: SummaryDto;
    license?: SummaryDto;
    organization?: SummaryDto;
    assignedRoles?: string[] | undefined;

    constructor(data?: ISendEmailAnnouncementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.application = _data["application"] ? SummaryDto.fromJS(_data["application"]) : undefined as any;
            this.license = _data["license"] ? SummaryDto.fromJS(_data["license"]) : undefined as any;
            this.organization = _data["organization"] ? SummaryDto.fromJS(_data["organization"]) : undefined as any;
            if (Array.isArray(_data["assignedRoles"])) {
                this.assignedRoles = [] as any;
                for (let item of _data["assignedRoles"])
                    this.assignedRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): SendEmailAnnouncementDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailAnnouncementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        if (Array.isArray(this.assignedRoles)) {
            data["assignedRoles"] = [];
            for (let item of this.assignedRoles)
                data["assignedRoles"].push(item);
        }
        return data;
    }
}

export interface ISendEmailAnnouncementDto {
    email?: string | undefined;
    application?: SummaryDto;
    license?: SummaryDto;
    organization?: SummaryDto;
    assignedRoles?: string[] | undefined;
}

export class SummaryDto implements ISummaryDto {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: ISummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISummaryDto {
    id?: number | undefined;
    name?: string | undefined;
}

export class UserOnLicenseInfoDto implements IUserOnLicenseInfoDto {
    userId?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    hasRegistered?: boolean;
    isGuestUser?: boolean;
    roleIds?: number[] | undefined;
    licenseId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IUserOnLicenseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.hasRegistered = _data["hasRegistered"];
            this.isGuestUser = _data["isGuestUser"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.licenseId = _data["licenseId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserOnLicenseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOnLicenseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["hasRegistered"] = this.hasRegistered;
        data["isGuestUser"] = this.isGuestUser;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["licenseId"] = this.licenseId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserOnLicenseInfoDto {
    userId?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    hasRegistered?: boolean;
    isGuestUser?: boolean;
    roleIds?: number[] | undefined;
    licenseId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class UserToRolesRequestDto implements IUserToRolesRequestDto {
    userId?: string | undefined;
    licenseId?: number;
    roleIds?: number[] | undefined;

    constructor(data?: IUserToRolesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.licenseId = _data["licenseId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserToRolesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserToRolesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["licenseId"] = this.licenseId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IUserToRolesRequestDto {
    userId?: string | undefined;
    licenseId?: number;
    roleIds?: number[] | undefined;
}

/** Dto for Element added to WE.UserPortal.Models.DataTransferObjects.CalculationDto */
export class AddedElementDto implements IAddedElementDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets the element Id */
    elementId!: number;
    /** Gets or sets the parent element Id */
    parentElementId!: number;
    /** Gets or sets the name */
    name!: string;
    /** Gets or sets the element type Id */
    elementTypeId!: number;
    /** Gets or sets the count of completed elements */
    completeElementsCount?: number;
    /** Gets or sets the Mpg value for new or existing current */
    mpg?: number;
    /** Gets or sets the Mpg value for existing building after */
    mpgAfter?: number;
    /** Gets or sets the Amount value */
    amount?: number;
    /** Gets or sets the Amount Unit Id */
    amountUnitId?: number;
    /** Gets or sets the count of required elements */
    requiredElementCount?: number;
    /** Gets or sets the order of added element in given main title */
    order?: number;
    /** Gets or sets the calculation Id */
    calculationId!: number;
    calculation?: CalculationDto;
    /** Gets or sets the list of WE.UserPortal.Models.DataTransferObjects.InputDto */
    inputs?: InputDto[] | undefined;
    comment?: CommentDto;
    /** Gets or sets paris proof indicator current situation */
    ppi?: number;
    /** Gets or sets paris proof indicator after situation */
    ppiAfter?: number;
    /** Gets or sets Gwp50 current situation */
    gwp50?: number;
    /** Gets or sets Gwp50 after situation */
    gwp50After?: number;

    constructor(data?: IAddedElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.createdByUser = _data["createdByUser"] ? UpUserDto.fromJS(_data["createdByUser"]) : undefined as any;
            this.modifiedByUser = _data["modifiedByUser"] ? UpUserDto.fromJS(_data["modifiedByUser"]) : undefined as any;
            this.elementId = _data["elementId"];
            this.parentElementId = _data["parentElementId"];
            this.name = _data["name"];
            this.elementTypeId = _data["elementTypeId"];
            this.completeElementsCount = _data["completeElementsCount"];
            this.mpg = _data["mpg"];
            this.mpgAfter = _data["mpgAfter"];
            this.amount = _data["amount"];
            this.amountUnitId = _data["amountUnitId"];
            this.requiredElementCount = _data["requiredElementCount"];
            this.order = _data["order"];
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(InputDto.fromJS(item));
            }
            this.comment = _data["comment"] ? CommentDto.fromJS(_data["comment"]) : undefined as any;
            this.ppi = _data["ppi"];
            this.ppiAfter = _data["ppiAfter"];
            this.gwp50 = _data["gwp50"];
            this.gwp50After = _data["gwp50After"];
        }
    }

    static fromJS(data: any): AddedElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddedElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined as any;
        data["elementId"] = this.elementId;
        data["parentElementId"] = this.parentElementId;
        data["name"] = this.name;
        data["elementTypeId"] = this.elementTypeId;
        data["completeElementsCount"] = this.completeElementsCount;
        data["mpg"] = this.mpg;
        data["mpgAfter"] = this.mpgAfter;
        data["amount"] = this.amount;
        data["amountUnitId"] = this.amountUnitId;
        data["requiredElementCount"] = this.requiredElementCount;
        data["order"] = this.order;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item ? item.toJSON() : undefined as any);
        }
        data["comment"] = this.comment ? this.comment.toJSON() : undefined as any;
        data["ppi"] = this.ppi;
        data["ppiAfter"] = this.ppiAfter;
        data["gwp50"] = this.gwp50;
        data["gwp50After"] = this.gwp50After;
        return data;
    }
}

/** Dto for Element added to WE.UserPortal.Models.DataTransferObjects.CalculationDto */
export interface IAddedElementDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets the element Id */
    elementId: number;
    /** Gets or sets the parent element Id */
    parentElementId: number;
    /** Gets or sets the name */
    name: string;
    /** Gets or sets the element type Id */
    elementTypeId: number;
    /** Gets or sets the count of completed elements */
    completeElementsCount?: number;
    /** Gets or sets the Mpg value for new or existing current */
    mpg?: number;
    /** Gets or sets the Mpg value for existing building after */
    mpgAfter?: number;
    /** Gets or sets the Amount value */
    amount?: number;
    /** Gets or sets the Amount Unit Id */
    amountUnitId?: number;
    /** Gets or sets the count of required elements */
    requiredElementCount?: number;
    /** Gets or sets the order of added element in given main title */
    order?: number;
    /** Gets or sets the calculation Id */
    calculationId: number;
    calculation?: CalculationDto;
    /** Gets or sets the list of WE.UserPortal.Models.DataTransferObjects.InputDto */
    inputs?: InputDto[] | undefined;
    comment?: CommentDto;
    /** Gets or sets paris proof indicator current situation */
    ppi?: number;
    /** Gets or sets paris proof indicator after situation */
    ppiAfter?: number;
    /** Gets or sets Gwp50 current situation */
    gwp50?: number;
    /** Gets or sets Gwp50 after situation */
    gwp50After?: number;
}

/** This dto store the mapping of organisation allowed to access the container. */
export class AllowedOrganisationByContainerDto implements IAllowedOrganisationByContainerDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of Organisation (from Licentiebeheer) */
    organisationId?: number;
    /** Gets or sets unique identifier for the WE.UserPortal.Models.DataTransferObjects.ContainerDto */
    containerId?: number;
    /** Sets end date for grant access */
    endDate?: Date | undefined;
    /** Gets or sets the organisation name */
    organisationName?: string | undefined;
    /** Gets or sets the flag to delete the access */
    isDeleted?: boolean;
    container?: ContainerDto;

    constructor(data?: IAllowedOrganisationByContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.organisationId = _data["organisationId"];
            this.containerId = _data["containerId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.organisationName = _data["organisationName"];
            this.isDeleted = _data["isDeleted"];
            this.container = _data["container"] ? ContainerDto.fromJS(_data["container"]) : undefined as any;
        }
    }

    static fromJS(data: any): AllowedOrganisationByContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowedOrganisationByContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["organisationId"] = this.organisationId;
        data["containerId"] = this.containerId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["organisationName"] = this.organisationName;
        data["isDeleted"] = this.isDeleted;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        return data;
    }
}

/** This dto store the mapping of organisation allowed to access the container. */
export interface IAllowedOrganisationByContainerDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of Organisation (from Licentiebeheer) */
    organisationId?: number;
    /** Gets or sets unique identifier for the WE.UserPortal.Models.DataTransferObjects.ContainerDto */
    containerId?: number;
    /** Sets end date for grant access */
    endDate?: Date | undefined;
    /** Gets or sets the organisation name */
    organisationName?: string | undefined;
    /** Gets or sets the flag to delete the access */
    isDeleted?: boolean;
    container?: ContainerDto;
}

/** Dto for Allowed User By Calculation */
export class AllowedUserByCalculationOrContainerDto implements IAllowedUserByCalculationOrContainerDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of WE.UserPortal.Models.DataTransferObjects.UpUserDto */
    userId!: number;
    user?: UpUserDto;
    /** Gets or sets the unique identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto */
    calculationId?: number | undefined;
    calculation?: CalculationDto;
    /** Gets or sets unique identifier for the WE.UserPortal.Models.DataTransferObjects.ContainerDto */
    containerId?: number | undefined;
    container?: ContainerDto;
    /** Sets end date for grant access */
    endDate?: Date | undefined;

    constructor(data?: IAllowedUserByCalculationOrContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UpUserDto.fromJS(_data["user"]) : undefined as any;
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            this.containerId = _data["containerId"];
            this.container = _data["container"] ? ContainerDto.fromJS(_data["container"]) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AllowedUserByCalculationOrContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowedUserByCalculationOrContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        data["containerId"] = this.containerId;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

/** Dto for Allowed User By Calculation */
export interface IAllowedUserByCalculationOrContainerDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of WE.UserPortal.Models.DataTransferObjects.UpUserDto */
    userId: number;
    user?: UpUserDto;
    /** Gets or sets the unique identifier of WE.UserPortal.Models.DataTransferObjects.CalculationDto */
    calculationId?: number | undefined;
    calculation?: CalculationDto;
    /** Gets or sets unique identifier for the WE.UserPortal.Models.DataTransferObjects.ContainerDto */
    containerId?: number | undefined;
    container?: ContainerDto;
    /** Sets end date for grant access */
    endDate?: Date | undefined;
}

/** Holds the user access of calculation information */
export class CalculationAccessDto implements ICalculationAccessDto {
    /** Get or Set userId */
    userId?: number;
    /** Get or Set endDate */
    endDate?: Date | undefined;

    constructor(data?: ICalculationAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

/** Holds the user access of calculation information */
export interface ICalculationAccessDto {
    /** Get or Set userId */
    userId?: number;
    /** Get or Set endDate */
    endDate?: Date | undefined;
}

/** Dto for holding calculation change detailed logs based on version date */
export class CalculationChangeDetailedLogDto implements ICalculationChangeDetailedLogDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for CalculationChangeSummaryLogId */
    calculationChangeSummaryLogId!: number;
    calculationChangeSummaryLog?: CalculationChangeSummaryLogDto;
    /** Gets or sets change log detailed data based on application type */
    jsonDetailedData?: string | undefined;
    calculationChangeDetailedLog?: CalculationChangeDetailedLogDto;

    constructor(data?: ICalculationChangeDetailedLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.calculationChangeSummaryLogId = _data["calculationChangeSummaryLogId"];
            this.calculationChangeSummaryLog = _data["calculationChangeSummaryLog"] ? CalculationChangeSummaryLogDto.fromJS(_data["calculationChangeSummaryLog"]) : undefined as any;
            this.jsonDetailedData = _data["jsonDetailedData"];
            this.calculationChangeDetailedLog = _data["calculationChangeDetailedLog"] ? CalculationChangeDetailedLogDto.fromJS(_data["calculationChangeDetailedLog"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationChangeDetailedLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationChangeDetailedLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["calculationChangeSummaryLogId"] = this.calculationChangeSummaryLogId;
        data["calculationChangeSummaryLog"] = this.calculationChangeSummaryLog ? this.calculationChangeSummaryLog.toJSON() : undefined as any;
        data["jsonDetailedData"] = this.jsonDetailedData;
        data["calculationChangeDetailedLog"] = this.calculationChangeDetailedLog ? this.calculationChangeDetailedLog.toJSON() : undefined as any;
        return data;
    }
}

/** Dto for holding calculation change detailed logs based on version date */
export interface ICalculationChangeDetailedLogDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for CalculationChangeSummaryLogId */
    calculationChangeSummaryLogId: number;
    calculationChangeSummaryLog?: CalculationChangeSummaryLogDto;
    /** Gets or sets change log detailed data based on application type */
    jsonDetailedData?: string | undefined;
    calculationChangeDetailedLog?: CalculationChangeDetailedLogDto;
}

/** Dto for holding calculation change summary logs based on version date */
export class CalculationChangeSummaryLogDto implements ICalculationChangeSummaryLogDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for CalculationId */
    calculationId!: number;
    calculation?: CalculationDto;
    /** Gets or sets the change date when user made changes in version date */
    changedDate?: Date;
    /** Gets or sets Application type change log WE.UserPortal.Models.Enums.ApplicationTypeEnum */
    applicationTypeId?: number;
    /** Gets or sets change log summary data based on application type */
    jsonSummaryData?: string | undefined;
    calculationChangeDetailedLog?: CalculationChangeDetailedLogDto;

    constructor(data?: ICalculationChangeSummaryLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            this.changedDate = _data["changedDate"] ? new Date(_data["changedDate"].toString()) : undefined as any;
            this.applicationTypeId = _data["applicationTypeId"];
            this.jsonSummaryData = _data["jsonSummaryData"];
            this.calculationChangeDetailedLog = _data["calculationChangeDetailedLog"] ? CalculationChangeDetailedLogDto.fromJS(_data["calculationChangeDetailedLog"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationChangeSummaryLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationChangeSummaryLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        data["changedDate"] = this.changedDate ? this.changedDate.toISOString() : undefined as any;
        data["applicationTypeId"] = this.applicationTypeId;
        data["jsonSummaryData"] = this.jsonSummaryData;
        data["calculationChangeDetailedLog"] = this.calculationChangeDetailedLog ? this.calculationChangeDetailedLog.toJSON() : undefined as any;
        return data;
    }
}

/** Dto for holding calculation change summary logs based on version date */
export interface ICalculationChangeSummaryLogDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for CalculationId */
    calculationId: number;
    calculation?: CalculationDto;
    /** Gets or sets the change date when user made changes in version date */
    changedDate?: Date;
    /** Gets or sets Application type change log WE.UserPortal.Models.Enums.ApplicationTypeEnum */
    applicationTypeId?: number;
    /** Gets or sets change log summary data based on application type */
    jsonSummaryData?: string | undefined;
    calculationChangeDetailedLog?: CalculationChangeDetailedLogDto;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultDto <br>Used for Calculation Core Result */
export class CalculationCoreResultDto implements ICalculationCoreResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Value CalculationCore */
    value!: string;
    /** Gets or sets Calculation Id */
    calculationId!: number;
    calculation?: CalculationDto;
    /** Gets or sets Data Member Id */
    dataMemberId?: number;
    dataMember?: DataMemberDto;
    /** Gets or sets the calculation type as described in WE.GPR.MaterialCalculationCore.Models.Enums.NmdCalculationTypeEnum
0: New
1: Current
2: After */
    calculationTypeId?: number;
    /** Get or Set WE.GPR.Connections.Models.Enums.Eds.AssessmentStrategyEnum> */
    assessmentStrategyId?: number;

    constructor(data?: ICalculationCoreResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            this.dataMemberId = _data["dataMemberId"];
            this.dataMember = _data["dataMember"] ? DataMemberDto.fromJS(_data["dataMember"]) : undefined as any;
            this.calculationTypeId = _data["calculationTypeId"];
            this.assessmentStrategyId = _data["assessmentStrategyId"];
        }
    }

    static fromJS(data: any): CalculationCoreResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        data["dataMemberId"] = this.dataMemberId;
        data["dataMember"] = this.dataMember ? this.dataMember.toJSON() : undefined as any;
        data["calculationTypeId"] = this.calculationTypeId;
        data["assessmentStrategyId"] = this.assessmentStrategyId;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultDto <br>Used for Calculation Core Result */
export interface ICalculationCoreResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Value CalculationCore */
    value: string;
    /** Gets or sets Calculation Id */
    calculationId: number;
    calculation?: CalculationDto;
    /** Gets or sets Data Member Id */
    dataMemberId?: number;
    dataMember?: DataMemberDto;
    /** Gets or sets the calculation type as described in WE.GPR.MaterialCalculationCore.Models.Enums.NmdCalculationTypeEnum
0: New
1: Current
2: After */
    calculationTypeId?: number;
    /** Get or Set WE.GPR.Connections.Models.Enums.Eds.AssessmentStrategyEnum> */
    assessmentStrategyId?: number;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultExpressionResultDto <br>Used for usage */
export class CalculationCoreResultExpressionResultDto implements ICalculationCoreResultExpressionResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Value for CalculationCoreResultExpressionResultDto */
    value!: string;
    /** Gets or sets AssessmentEntityByContentVersionId for CalculationCoreResultExpressionResultDto */
    assessmentEntityByContentVersionId!: number;
    /** Gets or sets CalculationId */
    calculationId?: number;
    calculation?: CalculationDto;

    constructor(data?: ICalculationCoreResultExpressionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationCoreResultExpressionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreResultExpressionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.CalculationCoreResultExpressionResultDto <br>Used for usage */
export interface ICalculationCoreResultExpressionResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Value for CalculationCoreResultExpressionResultDto */
    value: string;
    /** Gets or sets AssessmentEntityByContentVersionId for CalculationCoreResultExpressionResultDto */
    assessmentEntityByContentVersionId: number;
    /** Gets or sets CalculationId */
    calculationId?: number;
    calculation?: CalculationDto;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.CalculationDto */
export class CalculationDto implements ICalculationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    name!: string;
    urlId?: string | undefined;
    applicationId!: number;
    statusId!: number;
    inTrash?: boolean;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;
    containerId?: number;
    accessTypeId?: number;
    /** Gets and sets Description for Calculation */
    description?: string | undefined;
    /** Gets or sets the unique identifier for the Content Version for which the calculation is made */
    contentVersionId!: number;
    /** Gets or Sets Versions Date to create a request for the service to use the proper versions for a calculation */
    versionsDate?: Date;
    /** Gets or Sets the date on which the calculation was last opened */
    lastOpenedDate?: Date;
    /** Gets or sets the unique identifier of the WE.UserPortal.Models.DataTransferObjects.ProjectDto where this calculation is located in */
    projectId?: number | undefined;
    /** Gets or sets end date for retrieving updated data */
    isUpdateEndDateSet?: boolean;
    /** Gets or sets flag for not showing the Gebouw calculations in UserPortal */
    isGprGebouwCalculation?: boolean;
    /** Gets or sets date when notifications were read last time */
    notificationsLastReadDate?: Date | undefined;
    /** Gets or sets last applied NMD product update date, used for showing the user the last NMD product update available before the version date of the calculation */
    appliedNmdUpdateDate?: Date | undefined;
    /** Gets or sets date when Nmd Products were last updated successfully in Db prior to the WE.UserPortal.Models.DataTransferObjects.CalculationDto.VersionsDate of the calculation */
    lastNmdProductUpdateDate?: Date | undefined;
    /** Gets or sets a value indicating whether there are any unread notifications for calculation changes based on NotificationLastReadDate */
    areUnReadNotificationsAvailable?: boolean;
    /** Gets or sets a value indicating whether calculation is for New building or existing building */
    isExistingBuildingSet?: boolean;
    /** Get or Set dataset choice id made by user */
    datasetChoiceId?: number;
    /** Get or Set flag to apply labels as filters in calculation results. */
    applyLabelFilters?: boolean;
    container?: ContainerDto;
    application?: ApplicationDto;
    project?: ProjectDto;
    /** Gets or sets parameter to assessment expression results associated with this calculation */
    parameterToAssessmentExpressionResults?: ParameterToAssessmentExpressionResultDto[] | undefined;
    /** Gets or sets calculation results associated with this calculation */
    calculationCoreResults?: CalculationCoreResultDto[] | undefined;
    /** Gets or sets parameter to calculation core Expression results associated with this calculation */
    parameterToCalculationCoreExpressionResults?: ParameterToCalculationCoreExpressionResultDto[] | undefined;
    /** Gets or sets added element to calculation */
    addedElements?: AddedElementDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto */
    allowedUserByCalculationsOrContainers?: AllowedUserByCalculationOrContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.InputDto */
    inputs?: InputDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CalculationChangeSummaryLogDto */
    calculationChangeSummaryLogs?: CalculationChangeSummaryLogDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.UserMetadataDto */
    userMetadata?: UserMetadataDto[] | undefined;
    /** Get or Set to toggle view for amount per unit on front-end */
    isAmountPerUnitViewSet?: boolean;

    constructor(data?: ICalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.createdByUser = _data["createdByUser"] ? UpUserDto.fromJS(_data["createdByUser"]) : undefined as any;
            this.modifiedByUser = _data["modifiedByUser"] ? UpUserDto.fromJS(_data["modifiedByUser"]) : undefined as any;
            this.name = _data["name"];
            this.urlId = _data["urlId"];
            this.applicationId = _data["applicationId"];
            this.statusId = _data["statusId"];
            this.inTrash = _data["inTrash"];
            this.trashStatusId = _data["trashStatusId"];
            this.containerId = _data["containerId"];
            this.accessTypeId = _data["accessTypeId"];
            this.description = _data["description"];
            this.contentVersionId = _data["contentVersionId"];
            this.versionsDate = _data["versionsDate"] ? new Date(_data["versionsDate"].toString()) : undefined as any;
            this.lastOpenedDate = _data["lastOpenedDate"] ? new Date(_data["lastOpenedDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.isUpdateEndDateSet = _data["isUpdateEndDateSet"];
            this.isGprGebouwCalculation = _data["isGprGebouwCalculation"];
            this.notificationsLastReadDate = _data["notificationsLastReadDate"] ? new Date(_data["notificationsLastReadDate"].toString()) : undefined as any;
            this.appliedNmdUpdateDate = _data["appliedNmdUpdateDate"] ? new Date(_data["appliedNmdUpdateDate"].toString()) : undefined as any;
            this.lastNmdProductUpdateDate = _data["lastNmdProductUpdateDate"] ? new Date(_data["lastNmdProductUpdateDate"].toString()) : undefined as any;
            this.areUnReadNotificationsAvailable = _data["areUnReadNotificationsAvailable"];
            this.isExistingBuildingSet = _data["isExistingBuildingSet"];
            this.datasetChoiceId = _data["datasetChoiceId"];
            this.applyLabelFilters = _data["applyLabelFilters"];
            this.container = _data["container"] ? ContainerDto.fromJS(_data["container"]) : undefined as any;
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : undefined as any;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["parameterToAssessmentExpressionResults"])) {
                this.parameterToAssessmentExpressionResults = [] as any;
                for (let item of _data["parameterToAssessmentExpressionResults"])
                    this.parameterToAssessmentExpressionResults!.push(ParameterToAssessmentExpressionResultDto.fromJS(item));
            }
            if (Array.isArray(_data["calculationCoreResults"])) {
                this.calculationCoreResults = [] as any;
                for (let item of _data["calculationCoreResults"])
                    this.calculationCoreResults!.push(CalculationCoreResultDto.fromJS(item));
            }
            if (Array.isArray(_data["parameterToCalculationCoreExpressionResults"])) {
                this.parameterToCalculationCoreExpressionResults = [] as any;
                for (let item of _data["parameterToCalculationCoreExpressionResults"])
                    this.parameterToCalculationCoreExpressionResults!.push(ParameterToCalculationCoreExpressionResultDto.fromJS(item));
            }
            if (Array.isArray(_data["addedElements"])) {
                this.addedElements = [] as any;
                for (let item of _data["addedElements"])
                    this.addedElements!.push(AddedElementDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedUserByCalculationsOrContainers"])) {
                this.allowedUserByCalculationsOrContainers = [] as any;
                for (let item of _data["allowedUserByCalculationsOrContainers"])
                    this.allowedUserByCalculationsOrContainers!.push(AllowedUserByCalculationOrContainerDto.fromJS(item));
            }
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(InputDto.fromJS(item));
            }
            if (Array.isArray(_data["calculationChangeSummaryLogs"])) {
                this.calculationChangeSummaryLogs = [] as any;
                for (let item of _data["calculationChangeSummaryLogs"])
                    this.calculationChangeSummaryLogs!.push(CalculationChangeSummaryLogDto.fromJS(item));
            }
            if (Array.isArray(_data["userMetadata"])) {
                this.userMetadata = [] as any;
                for (let item of _data["userMetadata"])
                    this.userMetadata!.push(UserMetadataDto.fromJS(item));
            }
            this.isAmountPerUnitViewSet = _data["isAmountPerUnitViewSet"];
        }
    }

    static fromJS(data: any): CalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined as any;
        data["name"] = this.name;
        data["urlId"] = this.urlId;
        data["applicationId"] = this.applicationId;
        data["statusId"] = this.statusId;
        data["inTrash"] = this.inTrash;
        data["trashStatusId"] = this.trashStatusId;
        data["containerId"] = this.containerId;
        data["accessTypeId"] = this.accessTypeId;
        data["description"] = this.description;
        data["contentVersionId"] = this.contentVersionId;
        data["versionsDate"] = this.versionsDate ? this.versionsDate.toISOString() : undefined as any;
        data["lastOpenedDate"] = this.lastOpenedDate ? this.lastOpenedDate.toISOString() : undefined as any;
        data["projectId"] = this.projectId;
        data["isUpdateEndDateSet"] = this.isUpdateEndDateSet;
        data["isGprGebouwCalculation"] = this.isGprGebouwCalculation;
        data["notificationsLastReadDate"] = this.notificationsLastReadDate ? this.notificationsLastReadDate.toISOString() : undefined as any;
        data["appliedNmdUpdateDate"] = this.appliedNmdUpdateDate ? this.appliedNmdUpdateDate.toISOString() : undefined as any;
        data["lastNmdProductUpdateDate"] = this.lastNmdProductUpdateDate ? this.lastNmdProductUpdateDate.toISOString() : undefined as any;
        data["areUnReadNotificationsAvailable"] = this.areUnReadNotificationsAvailable;
        data["isExistingBuildingSet"] = this.isExistingBuildingSet;
        data["datasetChoiceId"] = this.datasetChoiceId;
        data["applyLabelFilters"] = this.applyLabelFilters;
        data["container"] = this.container ? this.container.toJSON() : undefined as any;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.parameterToAssessmentExpressionResults)) {
            data["parameterToAssessmentExpressionResults"] = [];
            for (let item of this.parameterToAssessmentExpressionResults)
                data["parameterToAssessmentExpressionResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calculationCoreResults)) {
            data["calculationCoreResults"] = [];
            for (let item of this.calculationCoreResults)
                data["calculationCoreResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parameterToCalculationCoreExpressionResults)) {
            data["parameterToCalculationCoreExpressionResults"] = [];
            for (let item of this.parameterToCalculationCoreExpressionResults)
                data["parameterToCalculationCoreExpressionResults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.addedElements)) {
            data["addedElements"] = [];
            for (let item of this.addedElements)
                data["addedElements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allowedUserByCalculationsOrContainers)) {
            data["allowedUserByCalculationsOrContainers"] = [];
            for (let item of this.allowedUserByCalculationsOrContainers)
                data["allowedUserByCalculationsOrContainers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calculationChangeSummaryLogs)) {
            data["calculationChangeSummaryLogs"] = [];
            for (let item of this.calculationChangeSummaryLogs)
                data["calculationChangeSummaryLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userMetadata)) {
            data["userMetadata"] = [];
            for (let item of this.userMetadata)
                data["userMetadata"].push(item ? item.toJSON() : undefined as any);
        }
        data["isAmountPerUnitViewSet"] = this.isAmountPerUnitViewSet;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.CalculationDto */
export interface ICalculationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    name: string;
    urlId?: string | undefined;
    applicationId: number;
    statusId: number;
    inTrash?: boolean;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;
    containerId?: number;
    accessTypeId?: number;
    /** Gets and sets Description for Calculation */
    description?: string | undefined;
    /** Gets or sets the unique identifier for the Content Version for which the calculation is made */
    contentVersionId: number;
    /** Gets or Sets Versions Date to create a request for the service to use the proper versions for a calculation */
    versionsDate?: Date;
    /** Gets or Sets the date on which the calculation was last opened */
    lastOpenedDate?: Date;
    /** Gets or sets the unique identifier of the WE.UserPortal.Models.DataTransferObjects.ProjectDto where this calculation is located in */
    projectId?: number | undefined;
    /** Gets or sets end date for retrieving updated data */
    isUpdateEndDateSet?: boolean;
    /** Gets or sets flag for not showing the Gebouw calculations in UserPortal */
    isGprGebouwCalculation?: boolean;
    /** Gets or sets date when notifications were read last time */
    notificationsLastReadDate?: Date | undefined;
    /** Gets or sets last applied NMD product update date, used for showing the user the last NMD product update available before the version date of the calculation */
    appliedNmdUpdateDate?: Date | undefined;
    /** Gets or sets date when Nmd Products were last updated successfully in Db prior to the WE.UserPortal.Models.DataTransferObjects.CalculationDto.VersionsDate of the calculation */
    lastNmdProductUpdateDate?: Date | undefined;
    /** Gets or sets a value indicating whether there are any unread notifications for calculation changes based on NotificationLastReadDate */
    areUnReadNotificationsAvailable?: boolean;
    /** Gets or sets a value indicating whether calculation is for New building or existing building */
    isExistingBuildingSet?: boolean;
    /** Get or Set dataset choice id made by user */
    datasetChoiceId?: number;
    /** Get or Set flag to apply labels as filters in calculation results. */
    applyLabelFilters?: boolean;
    container?: ContainerDto;
    application?: ApplicationDto;
    project?: ProjectDto;
    /** Gets or sets parameter to assessment expression results associated with this calculation */
    parameterToAssessmentExpressionResults?: ParameterToAssessmentExpressionResultDto[] | undefined;
    /** Gets or sets calculation results associated with this calculation */
    calculationCoreResults?: CalculationCoreResultDto[] | undefined;
    /** Gets or sets parameter to calculation core Expression results associated with this calculation */
    parameterToCalculationCoreExpressionResults?: ParameterToCalculationCoreExpressionResultDto[] | undefined;
    /** Gets or sets added element to calculation */
    addedElements?: AddedElementDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto */
    allowedUserByCalculationsOrContainers?: AllowedUserByCalculationOrContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.InputDto */
    inputs?: InputDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CalculationChangeSummaryLogDto */
    calculationChangeSummaryLogs?: CalculationChangeSummaryLogDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.UserMetadataDto */
    userMetadata?: UserMetadataDto[] | undefined;
    /** Get or Set to toggle view for amount per unit on front-end */
    isAmountPerUnitViewSet?: boolean;
}

/** Data transfer object for the calculations page in UserPortal */
export class CalculationPageDto implements ICalculationPageDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    /** The logo for the application */
    appBrandLogo?: string | undefined;
    /** Gets or sets flag whether user has access to application or not */
    userHasAccessToApplication?: boolean;
    /** Gets or sets the granted IdpUsers */
    grantedUsers?: CalculationAccessDto[] | undefined;
    /** Gets or sets the created by user name. */
    createdByUserName?: string | undefined;
    /** Gets or sets the modified by user name. */
    modifiedByUserName?: string | undefined;
    name!: string;
    urlId?: string | undefined;
    applicationId!: number;
    statusId!: number;
    inTrash?: boolean;
    containerId?: number;
    accessTypeId?: number;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;

    constructor(data?: ICalculationPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.appBrandLogo = _data["appBrandLogo"];
            this.userHasAccessToApplication = _data["userHasAccessToApplication"];
            if (Array.isArray(_data["grantedUsers"])) {
                this.grantedUsers = [] as any;
                for (let item of _data["grantedUsers"])
                    this.grantedUsers!.push(CalculationAccessDto.fromJS(item));
            }
            this.createdByUserName = _data["createdByUserName"];
            this.modifiedByUserName = _data["modifiedByUserName"];
            this.name = _data["name"];
            this.urlId = _data["urlId"];
            this.applicationId = _data["applicationId"];
            this.statusId = _data["statusId"];
            this.inTrash = _data["inTrash"];
            this.containerId = _data["containerId"];
            this.accessTypeId = _data["accessTypeId"];
            this.trashStatusId = _data["trashStatusId"];
        }
    }

    static fromJS(data: any): CalculationPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["appBrandLogo"] = this.appBrandLogo;
        data["userHasAccessToApplication"] = this.userHasAccessToApplication;
        if (Array.isArray(this.grantedUsers)) {
            data["grantedUsers"] = [];
            for (let item of this.grantedUsers)
                data["grantedUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["createdByUserName"] = this.createdByUserName;
        data["modifiedByUserName"] = this.modifiedByUserName;
        data["name"] = this.name;
        data["urlId"] = this.urlId;
        data["applicationId"] = this.applicationId;
        data["statusId"] = this.statusId;
        data["inTrash"] = this.inTrash;
        data["containerId"] = this.containerId;
        data["accessTypeId"] = this.accessTypeId;
        data["trashStatusId"] = this.trashStatusId;
        return data;
    }
}

/** Data transfer object for the calculations page in UserPortal */
export interface ICalculationPageDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    /** The logo for the application */
    appBrandLogo?: string | undefined;
    /** Gets or sets flag whether user has access to application or not */
    userHasAccessToApplication?: boolean;
    /** Gets or sets the granted IdpUsers */
    grantedUsers?: CalculationAccessDto[] | undefined;
    /** Gets or sets the created by user name. */
    createdByUserName?: string | undefined;
    /** Gets or sets the modified by user name. */
    modifiedByUserName?: string | undefined;
    name: string;
    urlId?: string | undefined;
    applicationId: number;
    statusId: number;
    inTrash?: boolean;
    containerId?: number;
    accessTypeId?: number;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;
}

/** holds the calculation filtering properties */
export class CalculationPaginationAndFilterRequestDto implements ICalculationPaginationAndFilterRequestDto {
    pageNumber?: number;
    pageSize?: number;
    nameFilter?: string | undefined;
    sortFilter?: SortFilterDto;
    /** Gets or sets the user ids for filtering list of calculation based on users. */
    userIds?: number[] | undefined;
    /** Gets or sets the organization Id to fetch the list of calculations. */
    organizationId?: number;
    /** Gets or sets the container Id to fetch the list of calculations. */
    containerId?: number;

    constructor(data?: ICalculationPaginationAndFilterRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.nameFilter = _data["nameFilter"];
            this.sortFilter = _data["sortFilter"] ? SortFilterDto.fromJS(_data["sortFilter"]) : undefined as any;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationId = _data["organizationId"];
            this.containerId = _data["containerId"];
        }
    }

    static fromJS(data: any): CalculationPaginationAndFilterRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationPaginationAndFilterRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["nameFilter"] = this.nameFilter;
        data["sortFilter"] = this.sortFilter ? this.sortFilter.toJSON() : undefined as any;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationId"] = this.organizationId;
        data["containerId"] = this.containerId;
        return data;
    }
}

/** holds the calculation filtering properties */
export interface ICalculationPaginationAndFilterRequestDto {
    pageNumber?: number;
    pageSize?: number;
    nameFilter?: string | undefined;
    sortFilter?: SortFilterDto;
    /** Gets or sets the user ids for filtering list of calculation based on users. */
    userIds?: number[] | undefined;
    /** Gets or sets the organization Id to fetch the list of calculations. */
    organizationId?: number;
    /** Gets or sets the container Id to fetch the list of calculations. */
    containerId?: number;
}

/** Dto for Comments */
export class CommentDto implements ICommentDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets the comments */
    value?: string | undefined;
    /** Gets or sets the unique identifier of WE.UserPortal.Models.DataTransferObjects.AddedElementDto */
    addedElementId!: number;
    addedElement?: AddedElementDto;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.createdByUser = _data["createdByUser"] ? UpUserDto.fromJS(_data["createdByUser"]) : undefined as any;
            this.modifiedByUser = _data["modifiedByUser"] ? UpUserDto.fromJS(_data["modifiedByUser"]) : undefined as any;
            this.value = _data["value"];
            this.addedElementId = _data["addedElementId"];
            this.addedElement = _data["addedElement"] ? AddedElementDto.fromJS(_data["addedElement"]) : undefined as any;
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined as any;
        data["value"] = this.value;
        data["addedElementId"] = this.addedElementId;
        data["addedElement"] = this.addedElement ? this.addedElement.toJSON() : undefined as any;
        return data;
    }
}

/** Dto for Comments */
export interface ICommentDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets the comments */
    value?: string | undefined;
    /** Gets or sets the unique identifier of WE.UserPortal.Models.DataTransferObjects.AddedElementDto */
    addedElementId: number;
    addedElement?: AddedElementDto;
}

/** Gets or sets the data for containers in the calculation management */
export class ContainerDto implements IContainerDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets the Name */
    name?: string | undefined;
    /** Gets or sets ParentId for container */
    parentId?: number | undefined;
    /** Gets or sets the OrganisationId */
    organisationId?: number;
    /** Gets or sets TypeId for container */
    typeId?: number;
    /** Gets or sets the GprGebouwProjectInhoudId */
    gprGebouwProjectInhoudId?: number | undefined;
    /** Gets or set flag to determine whether container is in trash or not. */
    inTrash?: boolean;
    /** Gets or sets the ProjectCode */
    projectCode?: string | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto */
    allowedUserByCalculationsOrContainers?: AllowedUserByCalculationOrContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedOrganisationByContainerDto */
    allowedOrganisationByContainers?: AllowedOrganisationByContainerDto[] | undefined;
    parentContainer?: ContainerDto;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ContainerDto which are children of this container */
    childContainers?: ContainerDto[] | undefined;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;

    constructor(data?: IContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.createdByUser = _data["createdByUser"] ? UpUserDto.fromJS(_data["createdByUser"]) : undefined as any;
            this.modifiedByUser = _data["modifiedByUser"] ? UpUserDto.fromJS(_data["modifiedByUser"]) : undefined as any;
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.organisationId = _data["organisationId"];
            this.typeId = _data["typeId"];
            this.gprGebouwProjectInhoudId = _data["gprGebouwProjectInhoudId"];
            this.inTrash = _data["inTrash"];
            this.projectCode = _data["projectCode"];
            if (Array.isArray(_data["allowedUserByCalculationsOrContainers"])) {
                this.allowedUserByCalculationsOrContainers = [] as any;
                for (let item of _data["allowedUserByCalculationsOrContainers"])
                    this.allowedUserByCalculationsOrContainers!.push(AllowedUserByCalculationOrContainerDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedOrganisationByContainers"])) {
                this.allowedOrganisationByContainers = [] as any;
                for (let item of _data["allowedOrganisationByContainers"])
                    this.allowedOrganisationByContainers!.push(AllowedOrganisationByContainerDto.fromJS(item));
            }
            this.parentContainer = _data["parentContainer"] ? ContainerDto.fromJS(_data["parentContainer"]) : undefined as any;
            if (Array.isArray(_data["childContainers"])) {
                this.childContainers = [] as any;
                for (let item of _data["childContainers"])
                    this.childContainers!.push(ContainerDto.fromJS(item));
            }
            this.trashStatusId = _data["trashStatusId"];
        }
    }

    static fromJS(data: any): ContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined as any;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["organisationId"] = this.organisationId;
        data["typeId"] = this.typeId;
        data["gprGebouwProjectInhoudId"] = this.gprGebouwProjectInhoudId;
        data["inTrash"] = this.inTrash;
        data["projectCode"] = this.projectCode;
        if (Array.isArray(this.allowedUserByCalculationsOrContainers)) {
            data["allowedUserByCalculationsOrContainers"] = [];
            for (let item of this.allowedUserByCalculationsOrContainers)
                data["allowedUserByCalculationsOrContainers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allowedOrganisationByContainers)) {
            data["allowedOrganisationByContainers"] = [];
            for (let item of this.allowedOrganisationByContainers)
                data["allowedOrganisationByContainers"].push(item ? item.toJSON() : undefined as any);
        }
        data["parentContainer"] = this.parentContainer ? this.parentContainer.toJSON() : undefined as any;
        if (Array.isArray(this.childContainers)) {
            data["childContainers"] = [];
            for (let item of this.childContainers)
                data["childContainers"].push(item ? item.toJSON() : undefined as any);
        }
        data["trashStatusId"] = this.trashStatusId;
        return data;
    }
}

/** Gets or sets the data for containers in the calculation management */
export interface IContainerDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets the Name */
    name?: string | undefined;
    /** Gets or sets ParentId for container */
    parentId?: number | undefined;
    /** Gets or sets the OrganisationId */
    organisationId?: number;
    /** Gets or sets TypeId for container */
    typeId?: number;
    /** Gets or sets the GprGebouwProjectInhoudId */
    gprGebouwProjectInhoudId?: number | undefined;
    /** Gets or set flag to determine whether container is in trash or not. */
    inTrash?: boolean;
    /** Gets or sets the ProjectCode */
    projectCode?: string | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto */
    allowedUserByCalculationsOrContainers?: AllowedUserByCalculationOrContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedOrganisationByContainerDto */
    allowedOrganisationByContainers?: AllowedOrganisationByContainerDto[] | undefined;
    parentContainer?: ContainerDto;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ContainerDto which are children of this container */
    childContainers?: ContainerDto[] | undefined;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;
}

/** Data Transfer Object for deleting an user and reassigning their calculations to another user. */
export class DeleteUserAndReassignCalculationsDto implements IDeleteUserAndReassignCalculationsDto {
    /** Gets or sets the ID of the organization. */
    organizationId?: number;
    /** Gets or sets the ID of the application. */
    applicationId?: number;
    /** Gets or sets the ID of the user to be deleted. */
    toBeDeletedUserId?: string | undefined;
    /** Gets or sets the ID of the user to whom the calculations will be reassigned. */
    toReassignUserId?: number;
    /** Get or set the licenseId */
    licenseId?: number;

    constructor(data?: IDeleteUserAndReassignCalculationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.applicationId = _data["applicationId"];
            this.toBeDeletedUserId = _data["toBeDeletedUserId"];
            this.toReassignUserId = _data["toReassignUserId"];
            this.licenseId = _data["licenseId"];
        }
    }

    static fromJS(data: any): DeleteUserAndReassignCalculationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserAndReassignCalculationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["applicationId"] = this.applicationId;
        data["toBeDeletedUserId"] = this.toBeDeletedUserId;
        data["toReassignUserId"] = this.toReassignUserId;
        data["licenseId"] = this.licenseId;
        return data;
    }
}

/** Data Transfer Object for deleting an user and reassigning their calculations to another user. */
export interface IDeleteUserAndReassignCalculationsDto {
    /** Gets or sets the ID of the organization. */
    organizationId?: number;
    /** Gets or sets the ID of the application. */
    applicationId?: number;
    /** Gets or sets the ID of the user to be deleted. */
    toBeDeletedUserId?: string | undefined;
    /** Gets or sets the ID of the user to whom the calculations will be reassigned. */
    toReassignUserId?: number;
    /** Get or set the licenseId */
    licenseId?: number;
}

/** DuplicateCalculationDto contains data to duplicate calculation to another organization */
export class DuplicateCalculationDto implements IDuplicateCalculationDto {
    /** Url id of calculation */
    calculationUrlId?: string;
    /** license id of targated license */
    licenseId?: number;
    /** Organization id of targated organization */
    organizationId?: number;
    /** Organization name of targated organization */
    organizationName?: string | undefined;
    /** New calculation name if modified from UI */
    calculationName?: string | undefined;

    constructor(data?: IDuplicateCalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationUrlId = _data["calculationUrlId"];
            this.licenseId = _data["licenseId"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.calculationName = _data["calculationName"];
        }
    }

    static fromJS(data: any): DuplicateCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationUrlId"] = this.calculationUrlId;
        data["licenseId"] = this.licenseId;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["calculationName"] = this.calculationName;
        return data;
    }
}

/** DuplicateCalculationDto contains data to duplicate calculation to another organization */
export interface IDuplicateCalculationDto {
    /** Url id of calculation */
    calculationUrlId?: string;
    /** license id of targated license */
    licenseId?: number;
    /** Organization id of targated organization */
    organizationId?: number;
    /** Organization name of targated organization */
    organizationName?: string | undefined;
    /** New calculation name if modified from UI */
    calculationName?: string | undefined;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ExampleCalculationsSelectListDto */
export class ExampleCalculationsSelectListDto implements IExampleCalculationsSelectListDto {
    /** Gets or sets the Url Id */
    urlId!: string;
    /** Gets or sets Name for Calculation */
    name!: string;

    constructor(data?: IExampleCalculationsSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlId = _data["urlId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExampleCalculationsSelectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExampleCalculationsSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlId"] = this.urlId;
        data["name"] = this.name;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ExampleCalculationsSelectListDto */
export interface IExampleCalculationsSelectListDto {
    /** Gets or sets the Url Id */
    urlId: string;
    /** Gets or sets Name for Calculation */
    name: string;
}

/** This Dto is used for Gpr Building application */
export class CalculationResultGprBuildingSummaryDto implements ICalculationResultGprBuildingSummaryDto {
    /** Mpg per phase of the building */
    mpgPerPhase?: MpgPerPhaseDto[] | undefined;
    /** Gets or sets the BVO of the building (Gross Floor Area) */
    bvo?: number;
    /** Gets or sets the building lifespan, for existing building this is calculated with WE.GPR.MaterialCalculationCore.Models.DataTransferObjects.ExistingBuildingAmpInputDto */
    lifespan?: number;
    /** Gets or sets the Mpg of the building */
    mpg?: number;
    /** Global Warming Potential is not divided by Lifespan and BVO */
    globalWarmingPotential?: number;
    /** Gets the last NMD product update available before the version date of the calculation */
    appliedNmdUpdateDate?: Date;
    /** Environment Effects of all phases of the building */
    environmentEffectsAllPhases?: { [key: string]: number; } | undefined;
    /** Gwp50 value
WE.GPR.Connections.Models.DataTransferObjects.Nmd.NmdCalculationResponseDto.Gwp50 */
    gwp50?: number;
    /** Gets or sets paris proof indicator situations like New, Existing Building Current and After */
    parisProofIndicator?: number;
    /** Gets or sets the amount of construction-stored carbon in kg CO2 equivalents */
    constructionStoredCarbon?: number;

    constructor(data?: ICalculationResultGprBuildingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mpgPerPhase"])) {
                this.mpgPerPhase = [] as any;
                for (let item of _data["mpgPerPhase"])
                    this.mpgPerPhase!.push(MpgPerPhaseDto.fromJS(item));
            }
            this.bvo = _data["bvo"];
            this.lifespan = _data["lifespan"];
            this.mpg = _data["mpg"];
            this.globalWarmingPotential = _data["globalWarmingPotential"];
            this.appliedNmdUpdateDate = _data["appliedNmdUpdateDate"] ? new Date(_data["appliedNmdUpdateDate"].toString()) : undefined as any;
            if (_data["environmentEffectsAllPhases"]) {
                this.environmentEffectsAllPhases = {} as any;
                for (let key in _data["environmentEffectsAllPhases"]) {
                    if (_data["environmentEffectsAllPhases"].hasOwnProperty(key))
                        (this.environmentEffectsAllPhases as any)![key] = _data["environmentEffectsAllPhases"][key];
                }
            }
            this.gwp50 = _data["gwp50"];
            this.parisProofIndicator = _data["parisProofIndicator"];
            this.constructionStoredCarbon = _data["constructionStoredCarbon"];
        }
    }

    static fromJS(data: any): CalculationResultGprBuildingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationResultGprBuildingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mpgPerPhase)) {
            data["mpgPerPhase"] = [];
            for (let item of this.mpgPerPhase)
                data["mpgPerPhase"].push(item ? item.toJSON() : undefined as any);
        }
        data["bvo"] = this.bvo;
        data["lifespan"] = this.lifespan;
        data["mpg"] = this.mpg;
        data["globalWarmingPotential"] = this.globalWarmingPotential;
        data["appliedNmdUpdateDate"] = this.appliedNmdUpdateDate ? this.appliedNmdUpdateDate.toISOString() : undefined as any;
        if (this.environmentEffectsAllPhases) {
            data["environmentEffectsAllPhases"] = {};
            for (let key in this.environmentEffectsAllPhases) {
                if (this.environmentEffectsAllPhases.hasOwnProperty(key))
                    (data["environmentEffectsAllPhases"] as any)[key] = (this.environmentEffectsAllPhases as any)[key];
            }
        }
        data["gwp50"] = this.gwp50;
        data["parisProofIndicator"] = this.parisProofIndicator;
        data["constructionStoredCarbon"] = this.constructionStoredCarbon;
        return data;
    }
}

/** This Dto is used for Gpr Building application */
export interface ICalculationResultGprBuildingSummaryDto {
    /** Mpg per phase of the building */
    mpgPerPhase?: MpgPerPhaseDto[] | undefined;
    /** Gets or sets the BVO of the building (Gross Floor Area) */
    bvo?: number;
    /** Gets or sets the building lifespan, for existing building this is calculated with WE.GPR.MaterialCalculationCore.Models.DataTransferObjects.ExistingBuildingAmpInputDto */
    lifespan?: number;
    /** Gets or sets the Mpg of the building */
    mpg?: number;
    /** Global Warming Potential is not divided by Lifespan and BVO */
    globalWarmingPotential?: number;
    /** Gets the last NMD product update available before the version date of the calculation */
    appliedNmdUpdateDate?: Date;
    /** Environment Effects of all phases of the building */
    environmentEffectsAllPhases?: { [key: string]: number; } | undefined;
    /** Gwp50 value
WE.GPR.Connections.Models.DataTransferObjects.Nmd.NmdCalculationResponseDto.Gwp50 */
    gwp50?: number;
    /** Gets or sets paris proof indicator situations like New, Existing Building Current and After */
    parisProofIndicator?: number;
    /** Gets or sets the amount of construction-stored carbon in kg CO2 equivalents */
    constructionStoredCarbon?: number;
}

export class MinimalCalculationDto implements IMinimalCalculationDto {
    /** Gets or set the Name */
    name!: string;
    /** Gets or set the UrlId */
    urlId?: string | undefined;

    constructor(data?: IMinimalCalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.urlId = _data["urlId"];
        }
    }

    static fromJS(data: any): MinimalCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["urlId"] = this.urlId;
        return data;
    }
}

export interface IMinimalCalculationDto {
    /** Gets or set the Name */
    name: string;
    /** Gets or set the UrlId */
    urlId?: string | undefined;
}

/** Special Dto for requesting access to WE.UserPortal.Models.DataTransferObjects.CalculationDto or WE.UserPortal.Models.DataTransferObjects.ContainerDto from GPR Gebouw. */
export class RequestBuildingAccessContainerDto implements IRequestBuildingAccessContainerDto {
    /** Gets or sets the Name */
    name!: string;
    /** Gets or sets the Organisation Id */
    organisationId!: number;
    /** Gets or sets the GPR Gebouw ProjectInhoudId */
    gprGebouwProjectInhoudId!: number;

    constructor(data?: IRequestBuildingAccessContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organisationId = _data["organisationId"];
            this.gprGebouwProjectInhoudId = _data["gprGebouwProjectInhoudId"];
        }
    }

    static fromJS(data: any): RequestBuildingAccessContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestBuildingAccessContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organisationId"] = this.organisationId;
        data["gprGebouwProjectInhoudId"] = this.gprGebouwProjectInhoudId;
        return data;
    }
}

/** Special Dto for requesting access to WE.UserPortal.Models.DataTransferObjects.CalculationDto or WE.UserPortal.Models.DataTransferObjects.ContainerDto from GPR Gebouw. */
export interface IRequestBuildingAccessContainerDto {
    /** Gets or sets the Name */
    name: string;
    /** Gets or sets the Organisation Id */
    organisationId: number;
    /** Gets or sets the GPR Gebouw ProjectInhoudId */
    gprGebouwProjectInhoudId: number;
}

export class GrantedIdpUserDto implements IGrantedIdpUserDto {
    /** Unique Identifier of the user in the Userportal DB */
    upUserId?: number;
    /** Unique Identifier of the userin the Idp db */
    identityId?: string | undefined;
    /** Full name of the user */
    fullname?: string | undefined;
    /** Email address */
    email?: string | undefined;
    /** Flag to check whether the user has been granted access or not */
    hasAccess?: boolean;
    /** Sets end date for grant access */
    endDate?: Date | undefined;

    constructor(data?: IGrantedIdpUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upUserId = _data["upUserId"];
            this.identityId = _data["identityId"];
            this.fullname = _data["fullname"];
            this.email = _data["email"];
            this.hasAccess = _data["hasAccess"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GrantedIdpUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GrantedIdpUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upUserId"] = this.upUserId;
        data["identityId"] = this.identityId;
        data["fullname"] = this.fullname;
        data["email"] = this.email;
        data["hasAccess"] = this.hasAccess;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IGrantedIdpUserDto {
    /** Unique Identifier of the user in the Userportal DB */
    upUserId?: number;
    /** Unique Identifier of the userin the Idp db */
    identityId?: string | undefined;
    /** Full name of the user */
    fullname?: string | undefined;
    /** Email address */
    email?: string | undefined;
    /** Flag to check whether the user has been granted access or not */
    hasAccess?: boolean;
    /** Sets end date for grant access */
    endDate?: Date | undefined;
}

export class IdpUserDto implements IIdpUserDto {
    /** Unique Identifier of the user in the Userportal DB */
    upUserId?: number;
    /** Unique Identifier of the userin the Idp db */
    identityId?: string | undefined;
    /** Full name of the user */
    fullname?: string | undefined;
    /** Email address */
    email?: string | undefined;
    /** Flag to check whether the user has been granted access or not */
    hasAccess?: boolean;

    constructor(data?: IIdpUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upUserId = _data["upUserId"];
            this.identityId = _data["identityId"];
            this.fullname = _data["fullname"];
            this.email = _data["email"];
            this.hasAccess = _data["hasAccess"];
        }
    }

    static fromJS(data: any): IdpUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdpUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upUserId"] = this.upUserId;
        data["identityId"] = this.identityId;
        data["fullname"] = this.fullname;
        data["email"] = this.email;
        data["hasAccess"] = this.hasAccess;
        return data;
    }
}

export interface IIdpUserDto {
    /** Unique Identifier of the user in the Userportal DB */
    upUserId?: number;
    /** Unique Identifier of the userin the Idp db */
    identityId?: string | undefined;
    /** Full name of the user */
    fullname?: string | undefined;
    /** Email address */
    email?: string | undefined;
    /** Flag to check whether the user has been granted access or not */
    hasAccess?: boolean;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.InputDto <br>can be used for create a new WE.UserPortal.Models.DataTransferObjects.InputDto,Update existing ones or get data from database */
export class InputDto implements IInputDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets unique identifier of WE.UserPortal.Models.DataTransferObjects.AddedElementDto */
    addedElementId?: number | undefined;
    addedElement?: AddedElementDto;
    /** Gets or sets the calculation Id */
    calculationId!: number;
    calculation?: CalculationDto;
    /** Gets or sets the order of a product input in given added element */
    order?: number;
    /** Gets or sets the Json data for input */
    jsonData?: string | undefined;
    /** Gets or sets Json data type */
    jsonDataTypeId!: number;
    /** Gets or sets the product Id */
    productId?: number;
    inputProductOverride?: InputProductOverrideDto;

    constructor(data?: IInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.createdByUser = _data["createdByUser"] ? UpUserDto.fromJS(_data["createdByUser"]) : undefined as any;
            this.modifiedByUser = _data["modifiedByUser"] ? UpUserDto.fromJS(_data["modifiedByUser"]) : undefined as any;
            this.addedElementId = _data["addedElementId"];
            this.addedElement = _data["addedElement"] ? AddedElementDto.fromJS(_data["addedElement"]) : undefined as any;
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            this.order = _data["order"];
            this.jsonData = _data["jsonData"];
            this.jsonDataTypeId = _data["jsonDataTypeId"];
            this.productId = _data["productId"];
            this.inputProductOverride = _data["inputProductOverride"] ? InputProductOverrideDto.fromJS(_data["inputProductOverride"]) : undefined as any;
        }
    }

    static fromJS(data: any): InputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined as any;
        data["addedElementId"] = this.addedElementId;
        data["addedElement"] = this.addedElement ? this.addedElement.toJSON() : undefined as any;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        data["order"] = this.order;
        data["jsonData"] = this.jsonData;
        data["jsonDataTypeId"] = this.jsonDataTypeId;
        data["productId"] = this.productId;
        data["inputProductOverride"] = this.inputProductOverride ? this.inputProductOverride.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.InputDto <br>can be used for create a new WE.UserPortal.Models.DataTransferObjects.InputDto,Update existing ones or get data from database */
export interface IInputDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets unique identifier of WE.UserPortal.Models.DataTransferObjects.AddedElementDto */
    addedElementId?: number | undefined;
    addedElement?: AddedElementDto;
    /** Gets or sets the calculation Id */
    calculationId: number;
    calculation?: CalculationDto;
    /** Gets or sets the order of a product input in given added element */
    order?: number;
    /** Gets or sets the Json data for input */
    jsonData?: string | undefined;
    /** Gets or sets Json data type */
    jsonDataTypeId: number;
    /** Gets or sets the product Id */
    productId?: number;
    inputProductOverride?: InputProductOverrideDto;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.InputProductOverrideDto <br>can be used for create a new WE.UserPortal.Models.DataTransferObjects.InputProductOverrideDto, Update existing ones or get data from database */
export class InputProductOverrideDto implements IInputProductOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the input id */
    inputId?: number;
    /** Gets or sets is Dismountability Overridden */
    isDismountabilityOverridden?: boolean;
    /** Gets or sets is Origin Reuse Overridden */
    isOriginReuseOverridden?: boolean;

    constructor(data?: IInputProductOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.inputId = _data["inputId"];
            this.isDismountabilityOverridden = _data["isDismountabilityOverridden"];
            this.isOriginReuseOverridden = _data["isOriginReuseOverridden"];
        }
    }

    static fromJS(data: any): InputProductOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputProductOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["inputId"] = this.inputId;
        data["isDismountabilityOverridden"] = this.isDismountabilityOverridden;
        data["isOriginReuseOverridden"] = this.isOriginReuseOverridden;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.InputProductOverrideDto <br>can be used for create a new WE.UserPortal.Models.DataTransferObjects.InputProductOverrideDto, Update existing ones or get data from database */
export interface IInputProductOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the input id */
    inputId?: number;
    /** Gets or sets is Dismountability Overridden */
    isDismountabilityOverridden?: boolean;
    /** Gets or sets is Origin Reuse Overridden */
    isOriginReuseOverridden?: boolean;
}

/** Minimal ContainerDto */
export class MinimalContainerDto implements IMinimalContainerDto {
    /** Gets or sets the Id */
    id?: number;
    /** Gets or sets the Name */
    name?: string | undefined;
    /** Gets or sets ParentId for container */
    parentId?: number | undefined;
    /** Gets or sets the unique identifier of user who created the container */
    createdById?: number;
    /** Gets or sets the GprGebouwProjectInhoudId */
    gprGebouwProjectInhoudId?: number | undefined;
    /** Gets or sets the OrganisationId */
    organisationId?: number | undefined;
    /** Gets or sets TypeId for container */
    typeId?: number;
    /** Gets or sets the WE.UserPortal.Models.Enums.AccessTypeEnum the logged in user has to this container coming from Licentiebeheer roles 
0 - No access
1 - Read only
2 - Edit
3 - Full (owner) */
    accessTypeId?: number;
    /** Gets or sets the ProjectCode */
    projectCode?: string | undefined;
    parentContainer?: MinimalContainerDto;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.MinimalContainerDto which are children of this container */
    childContainers?: MinimalContainerDto[] | undefined;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;

    constructor(data?: IMinimalContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.createdById = _data["createdById"];
            this.gprGebouwProjectInhoudId = _data["gprGebouwProjectInhoudId"];
            this.organisationId = _data["organisationId"];
            this.typeId = _data["typeId"];
            this.accessTypeId = _data["accessTypeId"];
            this.projectCode = _data["projectCode"];
            this.parentContainer = _data["parentContainer"] ? MinimalContainerDto.fromJS(_data["parentContainer"]) : undefined as any;
            if (Array.isArray(_data["childContainers"])) {
                this.childContainers = [] as any;
                for (let item of _data["childContainers"])
                    this.childContainers!.push(MinimalContainerDto.fromJS(item));
            }
            this.trashStatusId = _data["trashStatusId"];
        }
    }

    static fromJS(data: any): MinimalContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["createdById"] = this.createdById;
        data["gprGebouwProjectInhoudId"] = this.gprGebouwProjectInhoudId;
        data["organisationId"] = this.organisationId;
        data["typeId"] = this.typeId;
        data["accessTypeId"] = this.accessTypeId;
        data["projectCode"] = this.projectCode;
        data["parentContainer"] = this.parentContainer ? this.parentContainer.toJSON() : undefined as any;
        if (Array.isArray(this.childContainers)) {
            data["childContainers"] = [];
            for (let item of this.childContainers)
                data["childContainers"].push(item ? item.toJSON() : undefined as any);
        }
        data["trashStatusId"] = this.trashStatusId;
        return data;
    }
}

/** Minimal ContainerDto */
export interface IMinimalContainerDto {
    /** Gets or sets the Id */
    id?: number;
    /** Gets or sets the Name */
    name?: string | undefined;
    /** Gets or sets ParentId for container */
    parentId?: number | undefined;
    /** Gets or sets the unique identifier of user who created the container */
    createdById?: number;
    /** Gets or sets the GprGebouwProjectInhoudId */
    gprGebouwProjectInhoudId?: number | undefined;
    /** Gets or sets the OrganisationId */
    organisationId?: number | undefined;
    /** Gets or sets TypeId for container */
    typeId?: number;
    /** Gets or sets the WE.UserPortal.Models.Enums.AccessTypeEnum the logged in user has to this container coming from Licentiebeheer roles 
0 - No access
1 - Read only
2 - Edit
3 - Full (owner) */
    accessTypeId?: number;
    /** Gets or sets the ProjectCode */
    projectCode?: string | undefined;
    parentContainer?: MinimalContainerDto;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.MinimalContainerDto which are children of this container */
    childContainers?: MinimalContainerDto[] | undefined;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto <br>can be used for create a new WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto,Update existing ones or get data from database */
export class ParameterToAssessmentExpressionResultDto implements IParameterToAssessmentExpressionResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for ParameterToAssessmentExpressionResult */
    value!: string;
    /** Gets or sets unique Identifier for WE.UserPortal.Models.DataTransferObjects.CalculationDto */
    calculationId!: number;
    calculation?: CalculationDto;
    /** Gets or sets Unique Identifier for AssessmentEntity */
    assessmentEntityByContentVersionId!: number;

    constructor(data?: IParameterToAssessmentExpressionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
        }
    }

    static fromJS(data: any): ParameterToAssessmentExpressionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterToAssessmentExpressionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto <br>can be used for create a new WE.UserPortal.Models.DataTransferObjects.ParameterToAssessmentExpressionResultDto,Update existing ones or get data from database */
export interface IParameterToAssessmentExpressionResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for ParameterToAssessmentExpressionResult */
    value: string;
    /** Gets or sets unique Identifier for WE.UserPortal.Models.DataTransferObjects.CalculationDto */
    calculationId: number;
    calculation?: CalculationDto;
    /** Gets or sets Unique Identifier for AssessmentEntity */
    assessmentEntityByContentVersionId: number;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ParameterToCalculationCoreExpressionResultDto <br>Used for usage */
export class ParameterToCalculationCoreExpressionResultDto implements IParameterToCalculationCoreExpressionResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for Value */
    value!: string;
    /** Gets or sets value for RequestDataMemberName */
    requestDataMemberName!: string;
    /** Gets or sets value for CalculationId */
    calculationId!: number;
    calculation?: CalculationDto;
    /** Gets or sets ParamByCalculationCoreExpressionId */
    paramByCalculationCoreExpressionId!: number;

    constructor(data?: IParameterToCalculationCoreExpressionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.requestDataMemberName = _data["requestDataMemberName"];
            this.calculationId = _data["calculationId"];
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
            this.paramByCalculationCoreExpressionId = _data["paramByCalculationCoreExpressionId"];
        }
    }

    static fromJS(data: any): ParameterToCalculationCoreExpressionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterToCalculationCoreExpressionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["requestDataMemberName"] = this.requestDataMemberName;
        data["calculationId"] = this.calculationId;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        data["paramByCalculationCoreExpressionId"] = this.paramByCalculationCoreExpressionId;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ParameterToCalculationCoreExpressionResultDto <br>Used for usage */
export interface IParameterToCalculationCoreExpressionResultDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets value for Value */
    value: string;
    /** Gets or sets value for RequestDataMemberName */
    requestDataMemberName: string;
    /** Gets or sets value for CalculationId */
    calculationId: number;
    calculation?: CalculationDto;
    /** Gets or sets ParamByCalculationCoreExpressionId */
    paramByCalculationCoreExpressionId: number;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ProjectDto */
export class ProjectDto implements IProjectDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets Street Name for project */
    streetName?: string | undefined;
    /** Gets or sets House Name for project */
    houseNumber?: number | undefined;
    /** Gets or sets House Number Addition for project */
    houseNumberAddition?: string | undefined;
    /** Gets or sets House Letter for project */
    houseLetter?: string | undefined;
    /** Gets or sets Postal code for project */
    postalCode?: string | undefined;
    /** Gets or sets Town for project */
    town?: string | undefined;
    /** Gets or sets Client for project */
    client?: string | undefined;
    /** Gets or sets Architect for project */
    architect?: string | undefined;
    /** Gets or Sets Building Permit Date for a project */
    buildingPermitDate?: Date;
    /** Gets or sets the reference number */
    referenceNumber?: string | undefined;
    /** gets or sets WE.UserPortal.Models.DataTransferObjects.CalculationDto */
    calculations?: CalculationDto[] | undefined;
    /** Gets or sets phase based on !:ProjectPhaseEnum */
    phaseId?: number;
    /** Gets or sets status */
    statusId?: number;
    /** Gets or sets purpose */
    purposeValue?: number;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.createdById = _data["createdById"];
            this.modifiedById = _data["modifiedById"];
            this.createdByUser = _data["createdByUser"] ? UpUserDto.fromJS(_data["createdByUser"]) : undefined as any;
            this.modifiedByUser = _data["modifiedByUser"] ? UpUserDto.fromJS(_data["modifiedByUser"]) : undefined as any;
            this.streetName = _data["streetName"];
            this.houseNumber = _data["houseNumber"];
            this.houseNumberAddition = _data["houseNumberAddition"];
            this.houseLetter = _data["houseLetter"];
            this.postalCode = _data["postalCode"];
            this.town = _data["town"];
            this.client = _data["client"];
            this.architect = _data["architect"];
            this.buildingPermitDate = _data["buildingPermitDate"] ? new Date(_data["buildingPermitDate"].toString()) : undefined as any;
            this.referenceNumber = _data["referenceNumber"];
            if (Array.isArray(_data["calculations"])) {
                this.calculations = [] as any;
                for (let item of _data["calculations"])
                    this.calculations!.push(CalculationDto.fromJS(item));
            }
            this.phaseId = _data["phaseId"];
            this.statusId = _data["statusId"];
            this.purposeValue = _data["purposeValue"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["createdById"] = this.createdById;
        data["modifiedById"] = this.modifiedById;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["modifiedByUser"] = this.modifiedByUser ? this.modifiedByUser.toJSON() : undefined as any;
        data["streetName"] = this.streetName;
        data["houseNumber"] = this.houseNumber;
        data["houseNumberAddition"] = this.houseNumberAddition;
        data["houseLetter"] = this.houseLetter;
        data["postalCode"] = this.postalCode;
        data["town"] = this.town;
        data["client"] = this.client;
        data["architect"] = this.architect;
        data["buildingPermitDate"] = this.buildingPermitDate ? this.buildingPermitDate.toISOString() : undefined as any;
        data["referenceNumber"] = this.referenceNumber;
        if (Array.isArray(this.calculations)) {
            data["calculations"] = [];
            for (let item of this.calculations)
                data["calculations"].push(item ? item.toJSON() : undefined as any);
        }
        data["phaseId"] = this.phaseId;
        data["statusId"] = this.statusId;
        data["purposeValue"] = this.purposeValue;
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.ProjectDto */
export interface IProjectDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    createdById?: number;
    modifiedById?: number;
    createdByUser?: UpUserDto;
    modifiedByUser?: UpUserDto;
    /** Gets or sets Street Name for project */
    streetName?: string | undefined;
    /** Gets or sets House Name for project */
    houseNumber?: number | undefined;
    /** Gets or sets House Number Addition for project */
    houseNumberAddition?: string | undefined;
    /** Gets or sets House Letter for project */
    houseLetter?: string | undefined;
    /** Gets or sets Postal code for project */
    postalCode?: string | undefined;
    /** Gets or sets Town for project */
    town?: string | undefined;
    /** Gets or sets Client for project */
    client?: string | undefined;
    /** Gets or sets Architect for project */
    architect?: string | undefined;
    /** Gets or Sets Building Permit Date for a project */
    buildingPermitDate?: Date;
    /** Gets or sets the reference number */
    referenceNumber?: string | undefined;
    /** gets or sets WE.UserPortal.Models.DataTransferObjects.CalculationDto */
    calculations?: CalculationDto[] | undefined;
    /** Gets or sets phase based on !:ProjectPhaseEnum */
    phaseId?: number;
    /** Gets or sets status */
    statusId?: number;
    /** Gets or sets purpose */
    purposeValue?: number;
}

/** Data transfer object for the trash bin in UserPortal */
export class TrashBinDto implements ITrashBinDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Calculation UrlId */
    urlId?: string | undefined;
    /** Gets or sets the Container Id */
    containerId?: number;
    /** Gets or sets the Calculation name or Container(Folder) name */
    name?: string | undefined;
    /** Gets or sets the logo for the application */
    appBrandLogo?: string | undefined;
    /** Gets or sets the WE.UserPortal.Models.Enums.AccessTypeEnum the logged in user has to this calculation coming from Licentiebeheer roles
0 - No access
1 - Read only
2 - Edit
3 - Full (owner) */
    accessTypeId?: number;
    /** Gets or sets the WE.UserPortal.Models.Enums.AccessTypeEnum the logged in user has to this calculation coming from Licentiebeheer roles
0 - No access
1 - Read only
2 - Edit
3 - Full (owner) */
    userHasAccessToApplication?: boolean;
    /** Gets or sets the created by user name. */
    createdByUserName?: string | undefined;
    /** Gets or sets the modified by user name. */
    modifiedByUserName?: string | undefined;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;

    constructor(data?: ITrashBinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.urlId = _data["urlId"];
            this.containerId = _data["containerId"];
            this.name = _data["name"];
            this.appBrandLogo = _data["appBrandLogo"];
            this.accessTypeId = _data["accessTypeId"];
            this.userHasAccessToApplication = _data["userHasAccessToApplication"];
            this.createdByUserName = _data["createdByUserName"];
            this.modifiedByUserName = _data["modifiedByUserName"];
            this.trashStatusId = _data["trashStatusId"];
        }
    }

    static fromJS(data: any): TrashBinDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrashBinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["urlId"] = this.urlId;
        data["containerId"] = this.containerId;
        data["name"] = this.name;
        data["appBrandLogo"] = this.appBrandLogo;
        data["accessTypeId"] = this.accessTypeId;
        data["userHasAccessToApplication"] = this.userHasAccessToApplication;
        data["createdByUserName"] = this.createdByUserName;
        data["modifiedByUserName"] = this.modifiedByUserName;
        data["trashStatusId"] = this.trashStatusId;
        return data;
    }
}

/** Data transfer object for the trash bin in UserPortal */
export interface ITrashBinDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Calculation UrlId */
    urlId?: string | undefined;
    /** Gets or sets the Container Id */
    containerId?: number;
    /** Gets or sets the Calculation name or Container(Folder) name */
    name?: string | undefined;
    /** Gets or sets the logo for the application */
    appBrandLogo?: string | undefined;
    /** Gets or sets the WE.UserPortal.Models.Enums.AccessTypeEnum the logged in user has to this calculation coming from Licentiebeheer roles
0 - No access
1 - Read only
2 - Edit
3 - Full (owner) */
    accessTypeId?: number;
    /** Gets or sets the WE.UserPortal.Models.Enums.AccessTypeEnum the logged in user has to this calculation coming from Licentiebeheer roles
0 - No access
1 - Read only
2 - Edit
3 - Full (owner) */
    userHasAccessToApplication?: boolean;
    /** Gets or sets the created by user name. */
    createdByUserName?: string | undefined;
    /** Gets or sets the modified by user name. */
    modifiedByUserName?: string | undefined;
    /** Gets or sets the TrashStatus state for nested-folder trash/restore operations using WE.UserPortal.Models.Enums.TrashStatusEnum */
    trashStatusId?: number;
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.UpLicenseDto <br>Used to describe the license as it is used the user management service */
export class UpLicenseDto implements IUpLicenseDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique Identifier of the license in the user management service */
    identityId!: number;
    /** Many to many relationship between the WE.UserPortal.Models.DataTransferObjects.UpLicenseDto and WE.UserPortal.Models.DataTransferObjects.UserByLicenseDto */
    userByLicenses?: UserByLicenseDto[] | undefined;

    constructor(data?: IUpLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.identityId = _data["identityId"];
            if (Array.isArray(_data["userByLicenses"])) {
                this.userByLicenses = [] as any;
                for (let item of _data["userByLicenses"])
                    this.userByLicenses!.push(UserByLicenseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["identityId"] = this.identityId;
        if (Array.isArray(this.userByLicenses)) {
            data["userByLicenses"] = [];
            for (let item of this.userByLicenses)
                data["userByLicenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the WE.UserPortal.Models.DataTransferObjects.UpLicenseDto <br>Used to describe the license as it is used the user management service */
export interface IUpLicenseDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique Identifier of the license in the user management service */
    identityId: number;
    /** Many to many relationship between the WE.UserPortal.Models.DataTransferObjects.UpLicenseDto and WE.UserPortal.Models.DataTransferObjects.UserByLicenseDto */
    userByLicenses?: UserByLicenseDto[] | undefined;
}

/** <br>Gets or sets properties of a user <br>Used for storing the data for users from our user management service */
export class UpUserDto implements IUpUserDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of this user from the Identity provider */
    identityId!: string;
    /** Full name of the user */
    fullname?: string | undefined;
    /** Collection of mapping between WE.UserPortal.Models.DataTransferObjects.UpUserDto and !:LicenseDto */
    userByLicenses?: UserByLicenseDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto */
    allowedUserByCalculationsOrContainers?: AllowedUserByCalculationOrContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AddedElementDto which are created by user */
    createdByAddedElements?: AddedElementDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AddedElementDto which are modified by user */
    modifiedByByAddedElements?: AddedElementDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CalculationDto which are created by user */
    createdByCalculations?: CalculationDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CalculationDto which are modified by user */
    modifiedByCalculations?: CalculationDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CommentDto which are created by user */
    createdByComments?: CommentDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CommentDto which are modified by user */
    modifiedByComments?: CommentDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ContainerDto which are created by user */
    createdByContainers?: ContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ContainerDto which are modified by user */
    modifiedByContainers?: ContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.InputDto which are created by user */
    createdByInputs?: InputDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.InputDto which are modified by user */
    modifiedBydInputs?: InputDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ProjectDto which are created by user */
    createdByProjects?: ProjectDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ProjectDto which are modified by user */
    modifiedBydProjects?: ProjectDto[] | undefined;

    constructor(data?: IUpUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.identityId = _data["identityId"];
            this.fullname = _data["fullname"];
            if (Array.isArray(_data["userByLicenses"])) {
                this.userByLicenses = [] as any;
                for (let item of _data["userByLicenses"])
                    this.userByLicenses!.push(UserByLicenseDto.fromJS(item));
            }
            if (Array.isArray(_data["allowedUserByCalculationsOrContainers"])) {
                this.allowedUserByCalculationsOrContainers = [] as any;
                for (let item of _data["allowedUserByCalculationsOrContainers"])
                    this.allowedUserByCalculationsOrContainers!.push(AllowedUserByCalculationOrContainerDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByAddedElements"])) {
                this.createdByAddedElements = [] as any;
                for (let item of _data["createdByAddedElements"])
                    this.createdByAddedElements!.push(AddedElementDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedByByAddedElements"])) {
                this.modifiedByByAddedElements = [] as any;
                for (let item of _data["modifiedByByAddedElements"])
                    this.modifiedByByAddedElements!.push(AddedElementDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByCalculations"])) {
                this.createdByCalculations = [] as any;
                for (let item of _data["createdByCalculations"])
                    this.createdByCalculations!.push(CalculationDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedByCalculations"])) {
                this.modifiedByCalculations = [] as any;
                for (let item of _data["modifiedByCalculations"])
                    this.modifiedByCalculations!.push(CalculationDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByComments"])) {
                this.createdByComments = [] as any;
                for (let item of _data["createdByComments"])
                    this.createdByComments!.push(CommentDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedByComments"])) {
                this.modifiedByComments = [] as any;
                for (let item of _data["modifiedByComments"])
                    this.modifiedByComments!.push(CommentDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByContainers"])) {
                this.createdByContainers = [] as any;
                for (let item of _data["createdByContainers"])
                    this.createdByContainers!.push(ContainerDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedByContainers"])) {
                this.modifiedByContainers = [] as any;
                for (let item of _data["modifiedByContainers"])
                    this.modifiedByContainers!.push(ContainerDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByInputs"])) {
                this.createdByInputs = [] as any;
                for (let item of _data["createdByInputs"])
                    this.createdByInputs!.push(InputDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedBydInputs"])) {
                this.modifiedBydInputs = [] as any;
                for (let item of _data["modifiedBydInputs"])
                    this.modifiedBydInputs!.push(InputDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByProjects"])) {
                this.createdByProjects = [] as any;
                for (let item of _data["createdByProjects"])
                    this.createdByProjects!.push(ProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["modifiedBydProjects"])) {
                this.modifiedBydProjects = [] as any;
                for (let item of _data["modifiedBydProjects"])
                    this.modifiedBydProjects!.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["identityId"] = this.identityId;
        data["fullname"] = this.fullname;
        if (Array.isArray(this.userByLicenses)) {
            data["userByLicenses"] = [];
            for (let item of this.userByLicenses)
                data["userByLicenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.allowedUserByCalculationsOrContainers)) {
            data["allowedUserByCalculationsOrContainers"] = [];
            for (let item of this.allowedUserByCalculationsOrContainers)
                data["allowedUserByCalculationsOrContainers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdByAddedElements)) {
            data["createdByAddedElements"] = [];
            for (let item of this.createdByAddedElements)
                data["createdByAddedElements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modifiedByByAddedElements)) {
            data["modifiedByByAddedElements"] = [];
            for (let item of this.modifiedByByAddedElements)
                data["modifiedByByAddedElements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdByCalculations)) {
            data["createdByCalculations"] = [];
            for (let item of this.createdByCalculations)
                data["createdByCalculations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modifiedByCalculations)) {
            data["modifiedByCalculations"] = [];
            for (let item of this.modifiedByCalculations)
                data["modifiedByCalculations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdByComments)) {
            data["createdByComments"] = [];
            for (let item of this.createdByComments)
                data["createdByComments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modifiedByComments)) {
            data["modifiedByComments"] = [];
            for (let item of this.modifiedByComments)
                data["modifiedByComments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdByContainers)) {
            data["createdByContainers"] = [];
            for (let item of this.createdByContainers)
                data["createdByContainers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modifiedByContainers)) {
            data["modifiedByContainers"] = [];
            for (let item of this.modifiedByContainers)
                data["modifiedByContainers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdByInputs)) {
            data["createdByInputs"] = [];
            for (let item of this.createdByInputs)
                data["createdByInputs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modifiedBydInputs)) {
            data["modifiedBydInputs"] = [];
            for (let item of this.modifiedBydInputs)
                data["modifiedBydInputs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.createdByProjects)) {
            data["createdByProjects"] = [];
            for (let item of this.createdByProjects)
                data["createdByProjects"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modifiedBydProjects)) {
            data["modifiedBydProjects"] = [];
            for (let item of this.modifiedBydProjects)
                data["modifiedBydProjects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets properties of a user <br>Used for storing the data for users from our user management service */
export interface IUpUserDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of this user from the Identity provider */
    identityId: string;
    /** Full name of the user */
    fullname?: string | undefined;
    /** Collection of mapping between WE.UserPortal.Models.DataTransferObjects.UpUserDto and !:LicenseDto */
    userByLicenses?: UserByLicenseDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AllowedUserByCalculationOrContainerDto */
    allowedUserByCalculationsOrContainers?: AllowedUserByCalculationOrContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AddedElementDto which are created by user */
    createdByAddedElements?: AddedElementDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.AddedElementDto which are modified by user */
    modifiedByByAddedElements?: AddedElementDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CalculationDto which are created by user */
    createdByCalculations?: CalculationDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CalculationDto which are modified by user */
    modifiedByCalculations?: CalculationDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CommentDto which are created by user */
    createdByComments?: CommentDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.CommentDto which are modified by user */
    modifiedByComments?: CommentDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ContainerDto which are created by user */
    createdByContainers?: ContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ContainerDto which are modified by user */
    modifiedByContainers?: ContainerDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.InputDto which are created by user */
    createdByInputs?: InputDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.InputDto which are modified by user */
    modifiedBydInputs?: InputDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ProjectDto which are created by user */
    createdByProjects?: ProjectDto[] | undefined;
    /** Gets or sets the collection of WE.UserPortal.Models.DataTransferObjects.ProjectDto which are modified by user */
    modifiedBydProjects?: ProjectDto[] | undefined;
}

/** Associative relation between WE.UserPortal.Models.DataTransferObjects.UpUserDto and WE.UserPortal.Models.DataTransferObjects.UpLicenseDto */
export class UserByLicenseDto implements IUserByLicenseDto {
    /** Unique Identifier of WE.UserPortal.Models.DataTransferObjects.UserByLicenseDto.User */
    userId!: number;
    user?: UpUserDto;
    /** Unique Identifier of WE.UserPortal.Models.DataTransferObjects.UserByLicenseDto.License */
    licenseId!: number;
    license?: UpLicenseDto;

    constructor(data?: IUserByLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? UpUserDto.fromJS(_data["user"]) : undefined as any;
            this.licenseId = _data["licenseId"];
            this.license = _data["license"] ? UpLicenseDto.fromJS(_data["license"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserByLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserByLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["licenseId"] = this.licenseId;
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        return data;
    }
}

/** Associative relation between WE.UserPortal.Models.DataTransferObjects.UpUserDto and WE.UserPortal.Models.DataTransferObjects.UpLicenseDto */
export interface IUserByLicenseDto {
    /** Unique Identifier of WE.UserPortal.Models.DataTransferObjects.UserByLicenseDto.User */
    userId: number;
    user?: UpUserDto;
    /** Unique Identifier of WE.UserPortal.Models.DataTransferObjects.UserByLicenseDto.License */
    licenseId: number;
    license?: UpLicenseDto;
}

export class UserMetadataDto implements IUserMetadataDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of this user from the Identity provider */
    userId?: number;
    /** Gets or sets calculation id */
    calculationId!: number;
    /** Last opened date of a calculation */
    lastOpenedDate?: Date | undefined;
    upUser?: UpUserDto;
    calculation?: CalculationDto;

    constructor(data?: IUserMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.calculationId = _data["calculationId"];
            this.lastOpenedDate = _data["lastOpenedDate"] ? new Date(_data["lastOpenedDate"].toString()) : undefined as any;
            this.upUser = _data["upUser"] ? UpUserDto.fromJS(_data["upUser"]) : undefined as any;
            this.calculation = _data["calculation"] ? CalculationDto.fromJS(_data["calculation"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["calculationId"] = this.calculationId;
        data["lastOpenedDate"] = this.lastOpenedDate ? this.lastOpenedDate.toISOString() : undefined as any;
        data["upUser"] = this.upUser ? this.upUser.toJSON() : undefined as any;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserMetadataDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the unique identifier of this user from the Identity provider */
    userId?: number;
    /** Gets or sets calculation id */
    calculationId: number;
    /** Last opened date of a calculation */
    lastOpenedDate?: Date | undefined;
    upUser?: UpUserDto;
    calculation?: CalculationDto;
}

export enum AccessTypeEnum {
    Edit_access = 2,
    Full__owner__access = 3,
    No_access = 0,
    Readonly_access = 1,
}

export enum AmountUnitEnum {
    M = 1,
    M2 = 2,
    M3 = 3,
    Stuks = 4,
}

export enum ApplicationTypeEnum {
    Edit_access = 2,
    Full__owner__access = 3,
    No_access = 0,
    Readonly_access = 1,
}

export enum CalculationSortKeyEnum {
    ChangedBy = 4,
    CreatedBy = 2,
    CreatedOn = 3,
    ModifiedOn = 5,
    Name = 1,
}

export enum CalculationStatusEnum {
    Active = 6,
    Archived = 4,
    ExampleCalculation = 7,
    Locked = 3,
    New = 1,
    Ready = 2,
}

export enum CalculationValidationEnum {
    Gebouw_Calculation = 3,
    InTrash = 2,
    Null_or_Not_Found = 1,
}

export enum ContainerTypeEnum {
    Gebouw = 2,
    Hoofdmap = 1,
    Map = 0,
    Project = 3,
}

export enum DatasetChoiceEnum {
    A1 = 1,
    A1_en_A2 = 3,
    A2 = 2,
}

export enum LabelScopeTypeEnum {
    Calculation = 3,
    Organisation = 2,
    System = 1,
}

export enum LicenseTypeEnum {
    Demo = 2,
    Education = 3,
    Enterprise = 6,
    Management = 4,
    Prepaid = 5,
    Standard = 1,
}

export enum ProductStatusEnum {
    Active = 1,
    Deactivated = 3,
    InActiveDueToLabelSelection = 5,
    InActiveDueToVersionDate = 2,
    NotAvailableOnSelectedDataset = 4,
}

export enum ProjectPhaseTypeEnum {
    Definitief_ontwerp = 3,
    Geen = 0,
    Oplevering = 5,
    Schetsontwerp = 1,
    Vergunningaanvraag = 4,
    Voorlopig_ontwerp = 2,
}

export enum ProjectPurposeTypeEnum {
    None = 0,
    AanbestedingTender = 1,
    CertificeringBREEAM = 2,
    CertificeringGPRGebouw = 4,
    CertificeringOverig = 8,
    CSRD = 16,
    HetNieuweNormaalHNN = 32,
    Materialenpaspoort = 64,
    Subsidie = 128,
    StudieOnderzoek = 256,
    Variant = 512,
    VergunningBBL = 1024,
    Overig = 2048,
}

export enum ProjectStatusTypeEnum {
    Definitief = 1,
    In_bewerking = 0,
}

export enum TrashStatusEnum {
    Active = 0,
    DeletedByParent = 2,
    DeletedRoot = 1,
    GhostParent = 4,
    RestoredShell = 3,
}

export enum UserPortalProjectEnum {
    UserPortal = 1,
    WE_UserPortal_Api = 2,
    WE_UserPortal_Bll = 3,
    WE_UserPortal_Web = 4,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}